/* This file is automatically generated, do not edit manually! */

/* eslint-disable */

exports.ANDROID_INDEX = {
  '@': [
    'A[0-9]{3,3}!!',
    'E[0-9]{2,2}0?!!',
    'S[0-9]{2,2}0?!!',
    'V[0-9]{2,2}0!!',
    'Z[0-9]{3,3}!!',
    '[0-9]0[0-9]F!!',
    '(Haier[- ])?H[ETW]- ?[A-Z][0-9]!!',
    '(Hisense )?(LED[0-9]{2,2}(G|K|L|EC|XT)[0-9]{2,3})!',
    '[SX06][0-9]{2,2}HT!!',
    '(Huawei )?[MSTX](1|2|7|8|10)\\-[A-Z0-9][0-9]{2,2}!!',
    'G[0-9]{3,3}!!',
    'Y[0-9]{3,3}!!',
    '[0-9AS][0-9]{2,2}HW!!',
    '(USCC-|KYOCERA-)?E[0-9]{4,4}!!',
    '(USCC-|KYOCERA-)?C[0-9]{4,4}!!',
    '[0-9]0[0-9]KC?!!',
    'K\\-?Touch!!',
    '(Lenovo ?)?(IdeaTab ?)?[AB][0-9]{4,4}!!',
    '(Lenovo )?(Tab ?)?(2 ?)?[AS](7|8|10)!!',
    '(Lenovo ?)?(IdeaTab ?)?[KSV][0-9]{4,4}!!',
    '[0-9]0[0-9]LG!!',
    'M\\-PP!!',
    'M\\-MP!!',
    'M\\-IPRO!!',
    '(MEDION|(MD )?LIFETAB)!!',
    'M\\.T\\.T\\.!!',
    'O\\+!!',
    '[0-9]{2,2}PFH6[0-9]{3,3}!',
    '(?:RIVO )?RHYTHM RX ?([0-9]+)!',
    '[4567A]0[0-9]SH!!',
    '(3|5|6|7)0[0-9]SH!!',
    'C[0-9]{4,4}!!',
    'D[0-9]{4,4}!!',
    'E[0-9]{4,4}!!',
    'F[0-9]{4,4}!!',
    'G[0-9]{4,4}!!',
    'H[0-9]{4,4}!!',
    'E[0-9]{2,2}[a-z]!!',
    'L[0-9]{2,2}[a-z]!!',
    '(SNM\\-)?M[0-9]{2,2}[a-z]!!',
    'S[0-9]{2,2}[a-z]!!',
    '(XOLO )?[ABQX][0-9]{3,4}!!',
    '(ZTE ?)?N[0-9]{3,3}!!',
    '(ZXY-)?(ZTE )?N[0-9]{4,4}!!',
    '(ZTE ?)?U[0-9]{3,3}!!',
    '(ZTE ?)?V[0-9]{3,3}[A-Z]!!',
    '(ZTE ?)?V ?[0-9]{3,3}!!',
    '(ZTE ?)?X[0-9]{3,3}!!',
    '(ZTE )?Z[0-9]!!',
    '[a-z][a-z](?:-[a-z][a-z])?, SmartTabII7!'
  ],
  '@00': ['001DL', '003P', '003Z', '008Z', '009Z'],
  '@0P': ['0PCV1', '0PM92', '0PJA1!', '0PJA2!', '0PKV1', '0PAJ5'],
  '@10': ['101DL', '101N', '101T', '101P', '102P'],
  '@11': [1105, 1107],
  '@12': ['1216[X]!', 1201],
  '@15': ['1501-A02', '1501 M02', '1501-M02', '1503-A01', '1503-M02', '1505-A01', '1505-A02'],
  '@16': ['1605-A01', '1607-A01'],
  '@17': ['1713-A01'],
  '@18': ['1801-A01'],
  '@2 ': ['(Lenovo )?(Tab ?)?(2 ?)?[AS](7|8|10)!!'],
  '@20': ['201M', '(Xiaomi )?20!!', '(Xiaomi |HM)?20!!'],
  '@2P': ['2PQ93', '2PS64'],
  '@3': ['(3|5|6|7)0[0-9]SH!!'],
  '@36': ['360 N4S'],
  '@3G': ['3G7334i', '(Lenovo |Lephone )?3GC101!', '(Lenovo |Lephone )?3GW100!', '(Lenovo |Lephone )?3GW101!'],
  '@40': [
    '4002[X]!',
    '4003[AJ]!',
    '4007[D]!',
    '4008[A]!',
    '4009[ADEFIKMSX]!',
    '4013[ADEJKMX]!',
    '4014[AMX]!',
    '4015[ANTX]!',
    '4015[D]!',
    '4016[ADX]!',
    '4017[ADEFX]!',
    '4018[ADEFMX]!',
    '4024[DEX]!',
    '4027[ADNX]!',
    '4028[AEJS]!',
    '4032[ADEX]!',
    '4033[ADLX]!',
    '4034[ADEFGX]!',
    '4035[ADYX]!',
    '4036[E]!',
    '4037[AX]!',
    '4037[T]!',
    '4037[V]!',
    '4045[ADEFLOYX]!',
    '4047[ADFGX]!',
    '4049[DG]!',
    '4055[JU]!',
    '4060[A]!',
    '4060[SW]!',
    '40[0-9]SC!!',
    '40[0-9]SO!!',
    '402ZT'
  ],
  '@48': ['(48|50|55)AX600C!'],
  '@5': ['(3|5|6|7)0[0-9]SH!!'],
  '@50': [
    '5010[DEGSUX]!',
    '5011[A]!',
    '5012[G]!',
    '5015[ADEX]!',
    '5016[AJ]!',
    '5017[B]!',
    '5017[ADEOX]!',
    '5019[D]!',
    '5020[A]!',
    '5022[DEX]!',
    '5023[F]!',
    '5024[D]!',
    '5025[DEGX]!',
    '5027[B]!',
    '5033[ADJOX]!',
    '5034[D]!',
    '5036[D]!',
    '5038[ADEX]!',
    '5039[D]!',
    '5041[C]!',
    '5042[ADEFGTWXY]!',
    '5044[ADGIOSTY]!',
    '5045[ADFGJTXY]!',
    '5046[DGIJUY]!',
    '5047[DIUY]!',
    '5049[EGSWZ]!',
    '5050[ASYX]!',
    '5051[ADJMX]!',
    '5052[DY]!',
    '5053[D]!',
    '5054[ADOSTX]!',
    '5054[NW]!',
    '5056[ADEINUWX]!',
    '5056[O]!',
    '5057[M]!',
    '5058[I]!',
    '5059[ADJTXY]!',
    '5060[D]!',
    '5065[ADJNWX]!',
    '5070[DJX]!',
    '5080[A]!',
    '5080[DFQX]!',
    '5085[CDJNOYX]!',
    '5086[ADY]!',
    '5090[Y]!',
    '5095[BIKY]!',
    '5096[AI]!',
    '5098[OS]!',
    '5099[ADY]!',
    '504Q',
    '504Q+',
    '504QP',
    '501LV',
    '(48|50|55)AX600C!',
    '5080C Pro',
    '50[0-9]SO!!',
    '502ZT'
  ],
  '@55': ['5560S', '(48|50|55)AX600C!'],
  '@58': [5832, 5855, 5860, '5860A', '5860E', '5860S', 5870],
  '@6': ['(3|5|6|7)0[0-9]SH!!'],
  '@60': [
    '6014[DX]!',
    '6016[ADEX]!',
    '6031[X]!',
    '6036[AYX]!',
    '6037[BIKY]!',
    '6039[AHJKSY]!',
    '6042[D]!',
    '6043[AD]!',
    '6044D',
    '6045[BFGIKOXY]!',
    '6050[AFWY]!',
    '6055[ABDHIKPUY]!',
    '6058[D]!',
    '6060[S]!',
    '6062[W]!',
    '6070[KOY]!',
    '602LV',
    '60[0-9]SO!!',
    '602ZT',
    '6034R ORANGE Niva'
  ],
  '@70': [
    '7030[L]!',
    '7040[DNR]!',
    '7040[T]!',
    '7043[AEKY]!',
    '7044[AXY]!',
    '7045[Y]!',
    '7046[T]!',
    '7048[ASWX]!',
    '7050[Y]!',
    '7051[X]!',
    '7053[D]!',
    '7055[AW]!',
    '704DC',
    '70[0-9]SO!!'
  ],
  '@71': ['710C'],
  '@72': [7260, 7266],
  '@75': ['7500IPS'],
  '@7D': ['7D-501u'],
  '@80': ['8020[D]!', '8030[BY]!', 8022, '801ES', '80-1', '801a', '801s', '802w', '800P31C'],
  '@81': ['8190Q'],
  '@82': ['825 T-Mobile'],
  '@83': ['831C'],
  '@86': ['8681-M02', '8692-M02'],
  '@87': [8720, '8720L'],
  '@88': [8810],
  '@89': [8950],
  '@8X': ['8x-1000'],
  '@90': [
    '9001[DIX]!',
    '9002[AWX]!',
    '9003[AX]!',
    '9005[X]!',
    '9006[W]!',
    '9007[ATX]!',
    '9008[ADIJTUX]!',
    '9010[X]!',
    '9015[BJWQ]!',
    '9022[SX]!',
    '9024[OW]!',
    '9025[MQ]!',
    '9021[AM]!',
    '909d',
    9088,
    '9020[A]!'
  ],
  '@93': [9300, '9300+', '932i'],
  '@97': ['97FC'],
  '@A0': ['A001', 'A0001', 'A0002', 'A05510'],
  '@A1': [
    'A1-[0-9]{3,3}!!',
    'A10',
    'A13-?MID!',
    'A101B',
    'A101C',
    'A101B2-LZ',
    'A101IT',
    'A10 MID',
    'A10MID',
    'A101B-CF',
    'A1001T',
    '(GIO-)?(GiONEE[- ])?A1$!',
    'A19S',
    'A11',
    'A111',
    'A106',
    'A1 07',
    'A13',
    'A110Q',
    'A110Q Canvas 2 Plus',
    'A110Q Canvas 2+',
    'A1680',
    'A1001',
    'A11w',
    'A1603',
    'A1601',
    'A10H(D5W6)',
    'A10HD(N9A3)',
    'A10t(5DM3)',
    'A10T(8DM1)',
    'A11(M5A7)',
    'A11s(M5A7)',
    'A15(E6C2)'
  ],
  '@A2': ['A206G', 'A2', 'A21'],
  '@A3': [
    'A3-A[0-9]{2,2}!!',
    'A32',
    'A35DE',
    'A320a',
    'A3380',
    'A30t',
    'A380T',
    'A31',
    'A31c',
    'A31t',
    'A33f',
    'A33w',
    'A37f',
    'A37fw',
    'A3'
  ],
  '@A4': [
    'A450TL',
    'A460G',
    'A460T',
    'A462C',
    'A463BG',
    'A464BG',
    'A466BG',
    'A466T',
    'A480G',
    'A43',
    'A400CG',
    'A45',
    'A47',
    'A4'
  ],
  '@A5': [
    'A520L',
    'A520R',
    'A521L',
    'A554C',
    'A556C',
    'A560G',
    'A562G',
    'A564R',
    'A564C',
    'A570BL',
    'A571VL',
    'A573VC',
    'A5 Easy',
    'A5 Easy TM',
    'A5 Lite',
    'A5 Quad Plus',
    'A5 Quad Plus TM',
    'A500CG',
    'A55i',
    'A52',
    'A51f',
    'A51w',
    'A5000',
    'a5'
  ],
  '@A6': ['A621BL', 'A621R', 'A622GL', 'A622VL', 'A6 Duo', 'A6 Lite', 'A6277', 'A6020', 'A6S'],
  '@A7': [
    'A7 Lite',
    'A726T',
    'A70HB',
    'A70BHT',
    'A70BHT-LZ',
    'A70BHT-PR',
    'A70CHT',
    'A70H',
    'A70S',
    'A7EB',
    'a7272',
    'A7272+(HTC DesireZ)',
    'A7 HD',
    'A7*',
    'A7+',
    'A708T',
    'A750',
    'A7000-a',
    'A7010a48',
    'A7272+',
    'A70(CY6T)',
    'A78h四核(C1V3)'
  ],
  '@A8': [
    'A845L',
    'A846L',
    'A851L',
    'A862W',
    'A80KSC!',
    'A80HF',
    'A89',
    'A820t',
    'A87',
    'A853',
    'A853 Milestone',
    'A878 Duo',
    'A898 Duo',
    'A8HD',
    'A80h双核(A4P9)',
    'A80 se??(M5MA)',
    'A80 se四核(M5MC)',
    'A80HD四核(C4H6)',
    'A88 mini四核(M1C5)',
    'A81E'
  ],
  '@A9': ['A995L', 'A95', 'A97i', '(GIO-)?(GiONEE[- ])?A9$!', 'A90S', 'A953', 'A955'],
  '@AA': ['AA3-600'],
  '@AC': [
    'Acer Chromebook R11',
    'Acer Chromebook R11 (CB5-132T / C738T)',
    'Acer Chromebook 15 (CB3-532)',
    '(AC|BC|LC|MT|RC|QS|VM|TS|OC)[0-9]{4,4}[A-Z]!!',
    'AC45BHE',
    'AC50BHE',
    'AC50DHE',
    'AC45NE',
    'ACM3066-8',
    '(Explay|X-tremer|ActiveD|Informer|Surfer)!!',
    'ACT2000',
    'ACU Volvo',
    'Acqua'
  ],
  '@AD': [
    'ADT-1',
    'ADVAN Q7A',
    'ADVAN E1C+',
    'ADVAN S3',
    'ADVAN S3+',
    'ADVAN S3A',
    'ADVAN S3C',
    'ADVAN S3C 3502',
    'ADVAN S4',
    'ADVAN S4+',
    'ADVAN S4A',
    'ADVAN S4C',
    'ADVAN S4E',
    'Advan S4P [Official]',
    'ADVAN S5E',
    'ADVAN S5E Pro',
    'ADVAN S5F+',
    'ADVAN S5H',
    'ADVAN S5I',
    'Advan S5K',
    'ADVAN S5M',
    'ADVAN S5Q',
    'ADVAN S6A',
    'ADVAN T1G',
    'ADVAN T1J',
    'ADVAN T1J+',
    'ADVAN T1L',
    'ADVAN T1M',
    'ADVAN T1X',
    'ADVAN T2E',
    'ADVAN T2F',
    'ADVAN T3E+',
    'ADVAN T5C',
    'Advent Vega',
    'ADR3010',
    'AD683G',
    '(HTC|PCD|USCC)?ADR[0-9]{4,4}!!',
    'Adam',
    'ADM816KC',
    'ADM816HC',
    'ADM712HC',
    'ADM8000KP A',
    'ADM8000KP B',
    'ADR8995!',
    'ADR910L',
    'ADR910L 4G',
    'ADR930L',
    'ADR930L 4G',
    'AD686G',
    'AD687G',
    'AD6893G',
    'AD682H',
    'Admire Alpha',
    'Admire Curve'
  ],
  '@AE': ['Aero A2-110', 'Aegis2'],
  '@AF': ['AFTB', 'AFTS', 'AFTN', 'AFTRS', 'AFTM', 'AFTT'],
  '@AG': [
    'AG Chrome Selfie',
    'AG CHROME ULTRA',
    'AG Tab 7 0',
    'AG Go-Tab Access',
    'AG Chrome Go Tab 7.0',
    'AGS-(L09|W09)!',
    '(KATBL|Kogan|Agora)!!'
  ],
  '@AI': [
    'aigoPad',
    'aigoPadM60',
    'AigoPad M60',
    'aigoPad M80D',
    'aigoPad M80E',
    'Ainovo Aurora-II',
    'Ainovo Flame (Nexus 7)',
    'AIRIS GN135',
    'AIRIS S211',
    'AIRIS TM([0-9]+[A-Z]*)!',
    'AIRIS OnePAD 725',
    'AIRIS OnePAD700',
    'AIRIS OnePAD 730',
    'AirisOnePad1000',
    'AirBook TTJ702',
    '(DNS )?(Airtab )?(E|ES|M|MA|MC|MF|MW|P|PC|PF)[0-9]{2,4}!!',
    'Air!!',
    'Aiki-4S',
    'Aiki-5'
  ],
  '@AK': ['AK330', 'AK330s', 'AKAI NEO', 'AKAI N8800', 'AKAI PHA-4800', 'AKAIPHA 5800', 'AKAI MIDMA-7002S'],
  '@AL': [
    'alien jolla bionic',
    'alien ubuntu qt',
    'Alcatel A851L',
    'Alcatel one touch 908F',
    'Alcatel one touch 918',
    'Alcatel ONETOUCH 918',
    'ALCATEL OT 919',
    'Alcatel one touch 990',
    'Alcatel one touch 990S',
    "Alcatel OT M'pop 5020D",
    'Alcatel 5098O',
    'Alcatel 7046T',
    'Alcatel 7049D',
    'Alcor Access Q913M',
    'Alcor Zest Q813I',
    'Alcor Zest Q813IS',
    'Alcor Zest Q813IX',
    'Alcor Zest Q933R',
    'ALLVIEW A4ALL',
    'ALLVIEW A6 Quad',
    'ALLVIEW P1',
    'Allview P2',
    'ALLVIEW P4',
    'ALLVIEW P4i',
    'Allview P5',
    'Allview P5-Mini',
    'ALLVIEW P5 Quad',
    'ALLVIEW P5 Qmax',
    'ALLVIEW P6',
    'ALLVIEW P6 Quad',
    'ALLVIEW TX1 Quasar',
    'ALLVIEW X2 Soul',
    'ALLVIEW-X3 Soul',
    '(Allview|Alldro)!!',
    'Allwinner A10',
    '(Highscreen|Alpha|Bay|Boost|Cosmo|Explosion|Power|Prime|Zera)!!',
    '(HUAWEI )?(ALP|BLA|CRR|LON|MATE|MHA|MT1|MT2|MT7|M200|NXT|Z100)!!',
    '(HW-|HUAWEI )?(ALE|ANE|D2|DAV|EML|EVA|FIG|G6|G7|GRA|M100|P2|P6|P7|PRA|RIO|SC|Sophia|VIE|VKY|VNS|VTR|WAS)!!',
    'Alfa A93 POP',
    'Alfa L',
    'Ally',
    'Altus 18',
    'Altus 24'
  ],
  '@AM': [
    'amd brazos',
    'amd persimmon',
    'Amlogic M1 reference board',
    'AML8726M',
    'AMLOGIC8726MX',
    'AM335XEVM',
    'AM335XEVM SK',
    'am3517evm',
    'AM437XEVM',
    'AM-H200',
    'Amazon Kindle Fire!',
    'Amazon Otter',
    'Amazon OtterX',
    'Amazon Otter2',
    'Amazon Tate',
    'Amazon Jem',
    'AMI-TT2',
    'AMI-TT2C',
    'AMI-TT2E',
    'AMI-TT4',
    'AMI-TTS',
    'AMI-TTLITE',
    'AMI-TTFORCE',
    'AML-MX REF',
    '(AMO-)?AMOI!!',
    'AMD120',
    '(Amaze|Hitech)!!',
    'Amaze 4G',
    '(Amazing|Fantastic)!!'
  ],
  '@AN': [
    'Android',
    'Android-for-Rockchip-2818',
    'AN7CG2',
    'AN7G2',
    'AN7G2DTE',
    'AN7G2I',
    'AN7G3',
    'AN7BG2',
    'AN7BG2DT',
    'AN7BG3',
    'AN7CG3',
    'AN7DG3',
    'AN7DG3B',
    'AN7DG3-CP',
    'AN7DG3ST-CP',
    'AN7FG3',
    'AN7HG3',
    'AN7IG3',
    'AN7SP',
    'AN8G2',
    'AN8G2I',
    'AN8G3',
    'AN8BG2',
    'AN8BG3',
    'AN8CG3',
    'AN9G2',
    'AN9G2I',
    'AN9G3',
    'AN10G2',
    'AN10G2-KN',
    'AN10G2-LN',
    'AN10G2I',
    'AN10BG2',
    'AN10BG2DT',
    'AN10BG2I',
    'AN10BG3',
    'AN10BG3DT',
    'AN10CG3',
    'AN10DG3',
    'AN13FP',
    'AN8BG3-LZ',
    'AN10G2-LZ',
    'AN10BG3-LZ',
    'AN7DG3C',
    '(HW-|HUAWEI )?(ALE|ANE|D2|DAV|EML|EVA|FIG|G6|G7|GRA|M100|P2|P6|P7|PRA|RIO|SC|Sophia|VIE|VKY|VNS|VTR|WAS)!!',
    '(iBall )?Andi!!',
    'AND1',
    'AND1E',
    'AND1E TV',
    'Android edition by sfr STARADDICT',
    'Android Edition Starnaute',
    'Android Edition StarText',
    'Android Edition StarTrail',
    '(Smartfren|Andromax)!!',
    'Androtab 7',
    '(Starway )?Andromeda!!',
    '(Andy|Yezz)!!'
  ],
  '@AO': [
    'AOLE 828',
    'AOSON G18',
    'Aoson M11',
    'Aoson M19',
    'aoson m33',
    'aoson M33 3G',
    'AOSON M82T',
    'AOSON M97F',
    'AOSON M106NB',
    'AOSON M701TG-C',
    'AOSON M706T',
    'AOSON M721S',
    'aoson M787T',
    'AOSON M1016',
    '(cm|aokp) tenderloin!',
    'AO5510'
  ],
  '@AP': [
    'App Runtime for Chrome',
    'apollo',
    'Apanda.A60!',
    'apanda-A80S',
    'apanda A80S',
    'apanda-A80T',
    'apanda-A100',
    'apanda-A101',
    'Aprix D97+'
  ],
  '@AQ': [
    '(bq|Aquaris|Edison|Maxwell)!!',
    'Aquila 070-0508',
    'Aquila 070-0508 3G',
    'Aquila 080-0508',
    'AQUILA 080-1008',
    'Aquila 097-0508',
    'AQUILA 097-1006',
    'AQUILA 097-1016',
    'AQUILA 097-1016 BT + 3G',
    'AQUILA 097-1016 BT 3G',
    'Aquila 101',
    'Aquila 101-1008 3G',
    'Aquila LE 080-0508',
    'Aquila SE 090-0508',
    '(Intex )?Aqua!!',
    'AQUOS!!',
    'aqua',
    'AQT80'
  ],
  '@AR': [
    'ARCHM901',
    'Arnova 7G2',
    'ARNOVA8G2',
    'Arnova 10G2',
    'ARNOVA 90G3',
    'ARNOVA 90 G4',
    'ARNOVA 97G4',
    'ARNOVA 101 G4',
    'ARCHOS 50PL',
    'ARCHOS 79XE',
    'Archos5',
    'ARCHOS 70it2',
    'ARCHOS 70it2G8',
    'Archos 80 Internet Tablet',
    'Archos 101 Internet Tablet',
    'Archos!!',
    'Artes D708',
    'Artes D821',
    'Artes i701',
    'ARTES I709',
    'Artes Q812',
    'Arya A1+',
    'Arya Z2',
    'ARMM2V',
    'ARMM3V',
    'arrowsM03',
    'ARIES 101',
    'ARIES 785',
    'ARA YS608',
    'Arctic450',
    'Arc',
    'Arc S'
  ],
  '@AS': [
    'ASUS Chromebook Flip C100PA',
    'ASUS Chromebook Flip C302',
    'Astone A108',
    'aspire1000s',
    'Aspire!!',
    'ASK SP[0-9]{3,3}!!',
    'ASTRI',
    'asus laptop',
    'ASUS T20',
    'ASUS Pad ME370T',
    'Asus Fonepad ME371MG 8GB',
    'AST21',
    'asus google cube',
    'ASP-4300W',
    'ASP-4500Z',
    'ASP-5000H',
    'Asus A10',
    '(Huawei|Ascend|HW-)!!',
    'AS740',
    'AS870 4G',
    'AS985',
    'AS650C',
    'Aster',
    'Aster T'
  ],
  '@AT': [
    'AT390',
    'AT102HC',
    'AT104GS',
    'AT107F',
    'AT108F',
    'AT197F',
    'AT10H-A10WP',
    'AT101-014',
    'AT101T-114',
    'AT1A*',
    'AT1C',
    'AT1C*',
    'AT1D',
    'AT1G*',
    'AT7E',
    'ATP515CKIT',
    '(HW-|HUAWEI |HONOR )?(ATH|BLN|BKL|BND|CHE|CHM|COL|DUA|DUK|DLI|EDI|FRD|HN3|H30|H60|HOL|JMM|KIW|LLD|NEM|NMO|PE|PLK|RNE|SCL|KNT|CAM|STF|HDN)!!',
    'aTab9.7 IPS',
    'AT735',
    'Atrix 2',
    'Atrix 2 WeifanZ',
    'Atrix 4G',
    'Atrix 4G ME860',
    'Atrix 4G MB860',
    'Atrix HD',
    'AtrixHD',
    'ATLANTIS',
    'ATP7526',
    'ATP7683',
    'AT1S0',
    'AT7-A',
    'AT7-B',
    'AT7-C',
    'AT10-A',
    'AT10LE-A',
    'AT10PE-A',
    'AT100',
    'AT200',
    'AT270',
    'AT300',
    'AT300SE',
    'AT330',
    'AT374',
    'AT400',
    'AT470',
    'AT500',
    'AT500a',
    'AT503',
    'AT570',
    'AT703',
    'AT830',
    'AT-A[QS][0-9]{2,2}!!',
    'ATLAS W'
  ],
  '@AU': ['Aurora-II', 'AUX!!', '(Aura|iberry|AUXUS)!!', 'AURUS III'],
  '@AV': ['Avea!!', '(Ilium )?Avvio!!'],
  '@AX': [
    'AX3Party',
    'AX4Nano plus',
    '(Axioo[\\- ])?PICO!!',
    '(AXPAD|Axxion)!!',
    '(Bmobile )?AX[0-9]{3,4}!!',
    'AX7OO',
    'AX600C'
  ],
  '@AZ': ['Azumi!!', '(AZ|BT)[0-9]{3,3}!!'],
  '@B1': ['B1-[A0-9][A0-9]{2,2}!!', 'B15', 'B15Q'],
  '@B3': ['B3-A10', 'B3-A20', 'B3-A20B', 'B3-A30', 'B3-A32', 'B3-A40', 'B3-A40FHD', 'B3000'],
  '@B9': ['B916C'],
  '@BA': [
    'Bay Trail Generic Platform',
    'Bayley Bay',
    'baoxue',
    'Barnes & Noble Nook Tablet',
    'Barnes & Noble Nook HD',
    'Barnes & Noble Nook HD+',
    '(Highscreen|Alpha|Bay|Boost|Cosmo|Explosion|Power|Prime|Zera)!!',
    'BAH-(W09|AL00|L09)!',
    '(HW-|HUAWEI )?BAC-(AL00|L03|L21|L22|TL00)!',
    'Backflip',
    'Backflip Me600',
    'Bambook S1',
    'BARRY',
    'BASE!!'
  ],
  '@BB': [
    'BB EH7',
    'BB EH7LE',
    '(BB )?Q5$!',
    '(BB )?Q10$!',
    '(BB )?Z10$!',
    '(BB )?Z30$!',
    'BBA100-[0-9]!',
    'BBB100-[0-9]!',
    'BBC100-[0-9]!',
    'BBD100-[0-9]!',
    'BBE100-[0-9]!',
    'BBF100-[0-9]!',
    '(BBG-|VIV-)?vivo!!',
    'Bbox Miami'
  ],
  '@BC': [
    'bcm platform',
    'bcm7231',
    'bcm7425',
    'bcm7429',
    'bcm7435',
    'bcm7439',
    'bcm7445',
    'bcm7584',
    'BCM21654!',
    'BCM21664!',
    'BCM23550!',
    'BCM28145!',
    'BCM28155!',
    '(AC|BC|LC|MT|RC|QS|VM|TS|OC)[0-9]{4,4}[A-Z]!!',
    'BC1003'
  ],
  '@BD': ['(BDS|BHX|BKO)\\-!!'],
  '@BE': [
    'BEAGLEBONE',
    'BeagleBone Black',
    'BEAGLEBONEBLACK',
    'BEAGLEBONEBLACK.A5C',
    'berlin',
    'berlin bg2!',
    'berlin generic!',
    'BenQ JD-130',
    'BenQ Android TV',
    'BenWee 5100',
    'BEE 9500',
    'BenQ!!',
    'BenWee!!',
    'BePhone UN030',
    'Best ?sonny!!',
    'BEAN 454',
    'beetle',
    'Be Touch 2',
    'Beeline!!'
  ],
  '@BF': ['BF[ \\-]!!', 'BFB!!', 'BF[0-9]{2,2}00!!'],
  '@BG': ['bg2 !', 'bg2ct !', 'bg2q4k !', 'bg2qa0v4 !', 'bg2qv4 !', 'BGO-(DL09|L03)!', 'BG2-(U01)!'],
  '@BH': ['(BDS|BHX|BKO)\\-!!'],
  '@BI': ['bird75v2', 'BioniQ!!', 'Bird!!', 'BizSmartPhone', 'BIP-6000', 'BIRDY'],
  '@BK': [
    '(BDS|BHX|BKO)\\-!!',
    '(HW-|HUAWEI |HONOR )?(ATH|BLN|BKL|BND|CHE|CHM|COL|DUA|DUK|DLI|EDI|FRD|HN3|H30|H60|HOL|JMM|KIW|LLD|NEM|NMO|PE|PLK|RNE|SCL|KNT|CAM|STF|HDN)!!'
  ],
  '@BL': [
    'Blaze',
    'Blaze Tablet',
    'BlueStacks!',
    'BlackBerry Runtime for Android Apps',
    "BLACKBERRY P'9982",
    '(BLU|DASH|LIFE|NEO|STUDIO|VIVO)!!',
    'Bluboo S1',
    'Blaze S180',
    'BLADE LE 70',
    '(HUAWEI )?(ALP|BLA|CRR|LON|MATE|MHA|MT1|MT2|MT7|M200|NXT|Z100)!!',
    '(HW-|HUAWEI |HONOR )?(ATH|BLN|BKL|BND|CHE|CHM|COL|DUA|DUK|DLI|EDI|FRD|HN3|H30|H60|HOL|JMM|KIW|LLD|NEM|NMO|PE|PLK|RNE|SCL|KNT|CAM|STF|HDN)!!',
    '(HW-|HUAWEI )?(BLL|CHC|TAG|KII)!!',
    '(BLF-)?lephone!!',
    'Blackphone 2',
    'BLOOM',
    'BLACK',
    '(ZTE )?Blade!!'
  ],
  '@BM': ['BMOBILE DASH 3.5', '(Bmobile )?AX[0-9]{3,4}!!', 'Bmobile T35AC', 'BM999'],
  '@BN': [
    '(NOOK )?BNRV(200|300)!',
    '(NOOK )?BNTV250!',
    '(NOOK )?BNRV350!',
    '(NOOK )?BNTV(400)!',
    '(NOOK )?BNTV(450)!',
    '(NOOK )?BNTV(600)!',
    '(NOOK )?BNTV(800)!',
    'BN Nook HD',
    'BN NookHD+',
    '(HW-|HUAWEI |HONOR )?(ATH|BLN|BKL|BND|CHE|CHM|COL|DUA|DUK|DLI|EDI|FRD|HN3|H30|H60|HOL|JMM|KIW|LLD|NEM|NMO|PE|PLK|RNE|SCL|KNT|CAM|STF|HDN)!!'
  ],
  '@BO': [
    'Boost',
    'BO-FRSP4',
    'BO-LFSPBS5',
    'BOVO S-F16',
    'BOWAY!!',
    '(Highscreen|Alpha|Bay|Boost|Cosmo|Explosion|Power|Prime|Zera)!!',
    'Bouygues Telecom Bs 351',
    'Bouygues Telecom Bs 402',
    'Bouygues Telecom Bs 403',
    'Bouygues Telecom Bs 451',
    'Boston 4G',
    'Boston'
  ],
  '@BP': ['BP710A'],
  '@BQ': [
    '(bq|Aquaris|Edison|Maxwell)!!',
    'BQS-3510',
    'BQS-3552',
    'BQS-4001',
    'BQS-4004',
    'BQS-4005',
    'BQS-4007',
    'BQS-4008',
    'BQS-4009',
    'BQS-4010',
    'BQS-4501 Bristol',
    'BQS-4502',
    'BQS-4503',
    'BQS-4510',
    'BQS-4515',
    'BQS-4516',
    'BQS-4525',
    'BQS-4552',
    'BQS-4555',
    'BQS-4560',
    'BQS-4700',
    'BQS-4701',
    'BQS-4702',
    'BQS-4707',
    'BQS-4800',
    'BQS-5000 Tokyo',
    'BQS-5003',
    'BQS-5004',
    'BQS-5005',
    'BQS-5009',
    'BQS-5001',
    'BQS 5007',
    'BQS-5010',
    'BQS-5011',
    'BQS-5020',
    'BQS-5025',
    'BQS-5040',
    'BQS-5045',
    'BQS-5050',
    'BQS-5065',
    'BQS-5070',
    'BQS-5200',
    'BQS-5500',
    'BQS-5502',
    'BQS-5505',
    'BQS 5505'
  ],
  '@BR': [
    'Bravo',
    'BRAVIA 2015',
    'BRAVIA 4K 2015',
    'BRAVIA 4K GB',
    'BroadSign Xpress!',
    'Broncho M7',
    '(BRS-)?BROR!!',
    'BRAVIA'
  ],
  '@BS': ['Bs 451', 'Bs 501', 'Bs541', 'BSTB-200C'],
  '@BT': ['BTV-(DL09|W09)!', '(AZ|BT)[0-9]{3,3}!!'],
  '@BU': ['BUSH!!', 'Burst S280', 'Butterfly S', 'Bucare Y330-U05'],
  '@BV': ['BV8000Pro'],
  '@C2': ['C2'],
  '@C5': ['(GIO-)?(GiONEE[- ])?C500!', 'C525c'],
  '@C6': [
    'C6 Duo',
    'C6Quad 4G',
    '(GIO-)?(GiONEE[- ])?C600!',
    '(GIO-)?(GiONEE[- ])?C610!',
    '(GIO-)?(GiONEE[- ])?C620!'
  ],
  '@C7': ['C771', '(GIO-)?(GiONEE[- ])?C700!'],
  '@C8': ['C811 4G', 'C8297W', 'C8660', '(GIO-)?(GiONEE[- ])?C800!', 'C8817D', 'C8817E', 'C8[0-9]{3,3}!!', 'C868'],
  '@C9': ['C908'],
  '@CA': [
    'Cardhu',
    'CA907AAC0G',
    'Camangi-Mangrove7',
    'CAPTIVA!!',
    'Carpad T5',
    'Carpad T61 2g',
    'CAL21',
    'CA201SP',
    'CA-201L',
    'Casper VIA!!',
    'CAT!!',
    'Candy TV',
    '(HW-|HUAWEI |HONOR )?(ATH|BLN|BKL|BND|CHE|CHM|COL|DUA|DUK|DLI|EDI|FRD|HN3|H30|H60|HOL|JMM|KIW|LLD|NEM|NMO|PE|PLK|RNE|SCL|KNT|CAM|STF|HDN)!!',
    '(HW-|HUAWEI )?(CRO|LUA|CUN|SCC|SCU|CAM|LDN|LYO|MYA)!!',
    '(HW-|HUAWEI )?CAZ-(AL10|TL10|TL20)!',
    '(HW-|HUAWEI )?CAN-(L01|L11|L12)!',
    'calgary',
    'Captivate-I897',
    'capricorn'
  ],
  '@CC': ['CCE SK352'],
  '@CE': ['cedartrail', 'CENTURION', 'CENTURION 3', 'Celkon!!'],
  '@CH': [
    'Chacer',
    'ChangHong!!',
    'CHER!!',
    'Cherry Mobile Burst',
    'Cherry Life',
    'Cherry Razor',
    'Cherry Mobile Razor',
    'CHERRY SNAP',
    'Cherry Sonic',
    'Cherry thunder2.0',
    'Cherry Mobile Amber W380',
    'Cherry w500',
    'CHUWI!!',
    'CHONG!!',
    '(HW-|HUAWEI |HONOR )?(ATH|BLN|BKL|BND|CHE|CHM|COL|DUA|DUK|DLI|EDI|FRD|HN3|H30|H60|HOL|JMM|KIW|LLD|NEM|NMO|PE|PLK|RNE|SCL|KNT|CAM|STF|HDN)!!',
    '(HW-|HUAWEI )?(BLL|CHC|TAG|KII)!!',
    'chagall',
    'chiron'
  ],
  '@CI': [
    'cius',
    'CIUS-7!',
    'Citycall!!',
    'CINK',
    'CINK+',
    'CINK FIVE',
    'CINK KING',
    'CINK PEAX',
    'CINK PEAX+',
    'CINK PEAX 2',
    'CINK SLIM',
    'Cink Slim A',
    'Cink Slim B',
    'CINK SLIM 2'
  ],
  '@CJ': ['(CJ-)?ThL!!'],
  '@CL': [
    'Clarion Mirage 2',
    '(Cloudfone|CloudPad|Excite|Thrill)!!',
    'Clanga 079-1016',
    'Clanga 097-2016',
    'Clanga SE 097-1008',
    'CLP281X',
    'Click',
    '(Intex )?Cloud!!',
    'CLIQ',
    'CLIQ XT',
    'CLIQ2'
  ],
  '@CM': ['CMP!!', '(cm|aokp) tenderloin!', 'CM980', 'CM990'],
  '@CN': ['CnM!!', 'CN51 [NQ]!'],
  '@CO': [
    'Colibri-T20',
    'Commodore!!',
    'Commtiva-HD710',
    'Commtiva-N700',
    'Connspeed IP71',
    '(Colorfly|CT[0-9]{3,3})!!',
    'Colors!!',
    'ConCorde!!',
    'Coolgen!!',
    'Coolpad!!',
    'COSHIP F2',
    'COWON!!',
    'COZCO C1 Plus',
    'Collo DG100',
    'Collo 2 DG120',
    'Connect-2G-2.0',
    '(Highscreen|Alpha|Bay|Boost|Cosmo|Explosion|Power|Prime|Zera)!!',
    'Coquettish Red',
    '(HW-|HUAWEI |HONOR )?(ATH|BLN|BKL|BND|CHE|CHM|COL|DUA|DUK|DLI|EDI|FRD|HN3|H30|H60|HOL|JMM|KIW|LLD|NEM|NMO|PE|PLK|RNE|SCL|KNT|CAM|STF|HDN)!!',
    'Comet',
    'Corvair',
    'COOLPIX S800c',
    'COOLPIX S810c',
    'Constellation V'
  ],
  '@CP': [
    'CP-DX!!',
    'CP3700A',
    'CP8676!',
    'CP8298!',
    'CPN-(W09|AL00|L09)!',
    'CPH1605',
    'CPH1701',
    'CPH1717',
    'CPH1609',
    'CPH1613',
    'CPH1723',
    'CPH1611'
  ],
  '@CR': [
    'Crespo!',
    'CRESTA.CTP888',
    'Cross!!',
    'Crosscall!!',
    '(HUAWEI )?(ALP|BLA|CRR|LON|MATE|MHA|MT1|MT2|MT7|M200|NXT|Z100)!!',
    '(HW-|HUAWEI )?(CRO|LUA|CUN|SCC|SCU|CAM|LDN|LYO|MYA)!!',
    'CRONO 22',
    'Crescent'
  ],
  '@CS': ['CS-1A13', '(CSL[- ])?(Spice[- ]?)?Mi(-| )?[0-9]{3,3}!!'],
  '@CT': [
    'CT[0-9]{3,4}!!',
    'CT-1',
    'CT910',
    '(Colorfly|CT[0-9]{3,3})!!',
    'CTP828BT',
    '(GIO-)?(GiONEE[- ])?Ctrl V1!',
    '(GIO-)?(GiONEE[- ])?Ctrl V2!',
    '(GIO-)?(GiONEE[- ])?Ctrl V3!',
    '(GIO-)?(GiONEE[- ])?Ctrl V4!',
    '(GIO-)?(GiONEE[- ])?Ctrl V5!',
    'CT50',
    'CT720G',
    'CT720HD',
    'CT920',
    'CT1006',
    'CT9973W43M'
  ],
  '@CU': [
    'CUBOT!!',
    '(CUBE ?)?(K8|U1|U2|U3|U5|U6|U8|U9)[0-9]?GT!!',
    'CUBE!!',
    '(HW-|HUAWEI )?(CRO|LUA|CUN|SCC|SCU|CAM|LDN|LYO|MYA)!!'
  ],
  '@CW': ['CW[- ]!!'],
  '@CX': ['CX-919', 'CX-921', 'CX-921B', 'CX-929', 'CX-950', 'CX-958'],
  '@CY': ['Cydle M7!', 'Cynus!!', 'Cyclone!!'],
  '@D-': ['d-01G', 'd-01H', 'd-01J', 'd-02H'],
  '@D0': [
    'D000-0000(13|18|19)-[0-9]{3,3}!',
    'D000-0000(01|07)-[A-Z][0-9]{2,2}!',
    'D000-000002-[W0][0-9]{2,2}!',
    'D000-0000(10|11)-N!',
    'D000 000043'
  ],
  '@D2': [
    'D2-[0-9]{3,3}!!',
    '(HW-|HUAWEI )?(ALE|ANE|D2|DAV|EML|EVA|FIG|G6|G7|GRA|M100|P2|P6|P7|PRA|RIO|SC|Sophia|VIE|VKY|VNS|VTR|WAS)!!'
  ],
  '@D5': ['D530', 'D539'],
  '@D7': ['D709', 'D7800AD', 'D75E', 'D70W'],
  '@D8': ['D820X', 'D816(d|t|v|w|x)!', 'D816G', 'D820mt', 'D80'],
  '@D9': ['D9702', 'D91'],
  '@DA': [
    'DA2[0-9]{2,2}[A-Z]+!!',
    '(BLU|DASH|LIFE|NEO|STUDIO|VIVO)!!',
    'Dakele A380',
    'DAKELE MC001',
    '(HW-|HUAWEI )?(ALE|ANE|D2|DAV|EML|EVA|FIG|G6|G7|GRA|M100|P2|P6|P7|PRA|RIO|SC|Sophia|VIE|VKY|VNS|VTR|WAS)!!',
    'DATAM803HC',
    'DATAM805HC',
    'DATAM819HD!',
    'DARKFULL',
    'DARKMOON',
    'DARKNIGHT',
    'DARKSIDE'
  ],
  '@DE': [
    'Dell!!',
    'Dell XCD35',
    'DEM752HCF',
    '(DENVER-)?TA[CD]-[0-9]{4,5}!!',
    'deovo V5',
    'DESAY!!',
    'DEXP Ixion ML 5',
    'DEXP Ixion XL 5',
    'desire200',
    'Desire 310 dual sim',
    'Desire 500',
    'Desire 500 Plus',
    'Desire 510',
    'Desire 610',
    'Desire 619d',
    'Desire 816',
    'Desire 816 dual sim',
    'Desire ?HD!',
    'desirec',
    'Desire L by HTC',
    'Desire ?S!',
    'Desire X',
    'Desire Z',
    'Desire!',
    'DEOX',
    'DEFY',
    'Defy(\\+| Plus)!',
    'DEDY+',
    'Dext',
    'Devour',
    'DEM752NC'
  ],
  '@DG': ['DG310', 'DG750 Iron Bone'],
  '@DI': [
    'Dialog!!',
    'DIT[0-9]{4,6}!!',
    'DIGICELDL1plus',
    'DIGICEL DL800',
    'DIGICEL DL1000',
    '(Digma )?iD[jmnsx][DQ]?[0-9]*!!',
    'DISTAB9000R',
    'DishTV Smartvu A2020',
    'Discovery DG500',
    'Discovery2-DG500C',
    '(HW-|HUAWEI )?DIG-(AL00|L01|L03|L21|TL10)!',
    'DIAMOND D1',
    'DIAMOND S3',
    'Discovery',
    'Discovery Elite',
    'Discovery II Mini'
  ],
  '@DJ': ['DJC Touchtab3', 'DJC Touchtab4'],
  '@DK': ['DKL01', 'Dk1031'],
  '@DL': [
    'DL750',
    'DL8006',
    'DLX',
    'DLXU',
    '(HW-|HUAWEI |HONOR )?(ATH|BLN|BKL|BND|CHE|CHM|COL|DUA|DUK|DLI|EDI|FRD|HN3|H30|H60|HOL|JMM|KIW|LLD|NEM|NMO|PE|PLK|RNE|SCL|KNT|CAM|STF|HDN)!!',
    'dL1'
  ],
  '@DM': ['DM0[0-9]{2,2}(K|SH)!!', 'DM-01G', 'DM-01K', 'DM-02H', 'DMC-CM1', 'DM-01H', 'DM-01J'],
  '@DN': [
    'DNS Airbook TYT701',
    '(DNS )?(Airtab )?(E|ES|M|MA|MC|MF|MW|P|PC|PF)[0-9]{2,4}!!',
    'DNS S!!',
    'DNSS4003',
    'DNS4502M'
  ],
  '@DO': [
    'Dooderbutt!',
    'domod G20',
    'Doogee X5 Max Pro',
    'DOOGEE-TITANS-DG150',
    'DOOV!!',
    'Doro Liberto!!',
    'Doro 8030',
    'Doro 824',
    'Doro PhoneEasy 745',
    'Dolphin 70e Black',
    'Docomo HT-03A'
  ],
  '@DP': ['DPS Dream 7', 'DPS Dream 9', 'DP-X1', 'DPH-D710'],
  '@DR': [
    'Dream',
    '(GIO-)?(GiONEE[- ])?Dream D1!',
    'Droid Incredible',
    '(HW-|HUAWEI )?(DRA|FLA|TIT|TAG|NCE|TRT|SLA)!!',
    'DroniX-0.5',
    'Droid',
    'DROID',
    'DROID ?2!',
    'DROID ?3!',
    'DROID ?4!',
    'DroidPro',
    'DROID Pro',
    'DROID HD',
    'DROID BIONIC!',
    'DROID RAZR HD!',
    'DROID ?RAZR!',
    'DROID SPYDER',
    'DROID ?X2!',
    'DROID ?X!',
    'DROIDZ Duo',
    'DROIDZ Active 3G',
    'DROIDZ ATOM S',
    'DROIDZ Beat TV',
    'DROIDZ Drive+',
    'DROIDZ Excel',
    'DROIDZ Excite',
    'DROIDZ Force',
    'DROIDZ Match TV',
    'DROIDZ Mini Q',
    'DROIDZ Portal X',
    'DROIDZ Quad',
    'DROIDZ Race',
    'DROIDZ Race X',
    'DROIDZ Sport',
    'DROIDZ Ultimate'
  ],
  '@DS': ['Dslide!!'],
  '@DT': ['Dtac phone Joey Jet 2', 'dtab01'],
  '@DU': [
    '(HW-|HUAWEI |HONOR )?(ATH|BLN|BKL|BND|CHE|CHM|COL|DUA|DUK|DLI|EDI|FRD|HN3|H30|H60|HOL|JMM|KIW|LLD|NEM|NMO|PE|PLK|RNE|SCL|KNT|CAM|STF|HDN)!!'
  ],
  '@DW': ['DW-PS3G5', 'DW-UBT7W', 'DW-UBT7SC*', 'DW-UBT27Cz', 'DW-UBT23G7'],
  '@DY': [
    'dyno 7.80',
    'dyno 7.85',
    'Dynamic Fun',
    'Dynamic Jump',
    'Dynamic Maxi',
    'Dynamic Milo',
    'Dynamic Racing 2',
    'Dynamic Raging Go',
    'Dynamic Shake',
    'Dynamic Wide',
    'Dynamic Wing',
    'Dynamic Racing 3'
  ],
  '@E': ['(DNS )?(Airtab )?(E|ES|M|MA|MC|MF|MW|P|PC|PF)[0-9]{2,4}!!'],
  '@E-': ['(E-Boda|Eruption|Essential|Supreme|Storm|Revo)!!'],
  '@E1': ['E1 v360', 'E170BS', 'E1031', 'e1808 v75!', 'e1109 v73!'],
  '@E2': ['E2 Jump', 'E239', 'E270BSA', 'E2281', '(Moto)?E2$!', '(Moto)?E2\\(4G-LTE\\)$!'],
  '@E3': ['E3 Living', 'E3 Sign', '(GIO-)?(GiONEE[- ])?E3T!', '(GIO-)?(GiONEE[- ])?E3$!'],
  '@E4': ['E4', 'E4 Lite'],
  '@E5': ['(GIO-)?(GiONEE[- ])?E5$!'],
  '@E6': [
    '(GIO-)?(GiONEE[- ])?E6mini!',
    '(GIO-)?(GiONEE[- ])?E6$!',
    '(GIO-)?(GiONEE[- ])?E6T$!',
    'E6782',
    'E650',
    'E60w'
  ],
  '@E7': ['E70[0-9]{2,2}H[DG]!!', '(GIO-)?(GiONEE[- ])?E7$!', 'E780', 'E731'],
  '@E8': ['E80[0-9]{2,2}H[DG]!!', 'E860', 'E800', 'E815', 'E812', 'E810'],
  '@E9': ['E900', 'E912'],
  '@EA': ['eagle75v1 2', 'EasyPhone EP5', 'EasyPad 971'],
  '@EB': ['EBEN!!', 'EBEST!!', 'EB-4063-X', 'EB-A71GJ', 'EB-W51GJ', 'EB-WX1GJ', 'EB-L76G-B'],
  '@EC': ['(Hisense )?(LED[0-9]{2,2}(G|K|L|EC|XT)[0-9]{2,3})!', 'Eco9 v1', 'Eco9 v2', 'Eco11 v2'],
  '@ED': [
    '(bq|Aquaris|Edison|Maxwell)!!',
    'edgejr',
    '(HW-|HUAWEI |HONOR )?(ATH|BLN|BKL|BND|CHE|CHM|COL|DUA|DUK|DLI|EDI|FRD|HN3|H30|H60|HOL|JMM|KIW|LLD|NEM|NMO|PE|PLK|RNE|SCL|KNT|CAM|STF|HDN)!!',
    'edenTAB ET-701'
  ],
  '@EE': ['eeepc', 'eee 701', '(Eee Pad )?Transformer Prime TF201!'],
  '@EF': ['EFM710A'],
  '@EG': ['EG98', 'EG680', 'EG968B'],
  '@EI': ['EIS01PT'],
  '@EK': ['EK-[GK][CN][0-9]{3,3}!!'],
  '@EL': [
    'EL72B',
    'ELF-II',
    'Elephone!!',
    'ELIYA S1',
    'ELIFE-E3',
    'Elife E5',
    'ElifeE6',
    'Elektra L',
    'Elektra XL',
    'Electrify',
    'Eluga A2',
    'ELUGA A3',
    'ELUGA A3 Pro',
    'ELUGA I2',
    'ELUGA I2 Activ',
    'ELUGA I4',
    'Eluga Arc 2',
    'Eluga Mark 2',
    'ELUGA Note',
    'ELUGA Prim',
    'ELUGA Pulse X',
    'ELUGA Ray',
    'ELUGA Ray Max',
    'ELUGA Ray X',
    'Eluga Ray 700',
    'ELUGA Turbo',
    'Elite',
    'Elite 11',
    '(SENCOR )?ELEMENT!!',
    'Elite 5.5L+',
    'Elite 6.0L'
  ],
  '@EM': [
    'EMBT3C',
    'EM63',
    'EM01F',
    '(HW-|HUAWEI )?(ALE|ANE|D2|DAV|EML|EVA|FIG|G6|G7|GRA|M100|P2|P6|P7|PRA|RIO|SC|Sophia|VIE|VKY|VNS|VTR|WAS)!!',
    'eMAX mini',
    'EMR1879'
  ],
  '@EN': ['Endeavour!!', 'ENR U', 'EndeavorU', 'Enjoy 71', 'Enjoy 7 Plus'],
  '@EP': ['EPAD', 'epade!!'],
  '@EQ': ['equiso.smart.tv.pro'],
  '@ER': [
    '(E-Boda|Eruption|Essential|Supreme|Storm|Revo)!!',
    'Eris',
    'ERIS ADR6200',
    'era 2',
    'era X',
    'era1X',
    'Era 2X',
    'era HD',
    'era 4G',
    'era 4K'
  ],
  '@ES': [
    '(DNS )?(Airtab )?(E|ES|M|MA|MC|MF|MW|P|PC|PF)[0-9]{2,4}!!',
    '(E-Boda|Eruption|Essential|Supreme|Storm|Revo)!!',
    'eSTAR!!'
  ],
  '@ET': ['ETBW11AA', 'Etel!!', 'ETOOSPAD5', 'ETOOSPAD6', 'ET1', 'Etisalat Smartphone', 'etab5'],
  '@EV': [
    'EVOKE HDI Box',
    'EVDO1000',
    'EvoPAD!!',
    '(EVAS )?EVERCOSS[- ]A!!',
    'EVERPAD SC-710',
    'Ever!!',
    'EVO',
    'Evo HD2',
    'EVO ?3D!',
    'EVO 4G',
    'Evo V 4G',
    '(HW-|HUAWEI )?(ALE|ANE|D2|DAV|EML|EVA|FIG|G6|G7|GRA|M100|P2|P6|P7|PRA|RIO|SC|Sophia|VIE|VKY|VNS|VTR|WAS)!!',
    '(EV|KM)-[ES][0-9]{3,3}!!',
    'Event',
    'EVERY35'
  ],
  '@EX': [
    'Exynos5410',
    '(Cloudfone|CloudPad|Excite|Thrill)!!',
    '(Explay|X-tremer|ActiveD|Informer|Surfer)!!',
    '(Highscreen|Alpha|Bay|Boost|Cosmo|Explosion|Power|Prime|Zera)!!',
    'Explorer A310e'
  ],
  '@EZ': ['Ezcast', 'eZee!!'],
  '@F&': ['F&U ETB!!'],
  '@F-': ['F-[0-9]{2,2}[A-Z]!!', 'F-074'],
  '@F1': ['f12[a-z]{3,3}!!', '(GIO-)?(GiONEE[- ])?F103!', 'F100', 'F1f', 'F1w', 'F13', 'F15'],
  '@F3': ['(GIO-)?(GiONEE[- ])?F301!'],
  '@F5': ['F50Q'],
  '@F6': ['F600'],
  '@FA': ['FAR7', 'FAR70B', 'FARTM933KZ', 'Fablet F3', '(Amazing|Fantastic)!!'],
  '@FC': ['FC6100'],
  '@FD': ['FDT!!', 'FDR-A01w'],
  '@FE': ['FEVER', 'ferrari'],
  '@FH': ['FHMD001'],
  '@FI': [
    'FIH-FB0',
    'FIH-!!',
    '(HW-|HUAWEI )?(ALE|ANE|D2|DAV|EML|EVA|FIG|G6|G7|GRA|M100|P2|P6|P7|PRA|RIO|SC|Sophia|VIE|VKY|VNS|VTR|WAS)!!',
    'Find 5',
    'FIND7'
  ],
  '@FJ': ['FJ[LT][0-9]{2,2}!!', 'FJJB091'],
  '@FL': [
    'Flo',
    'Flounder',
    'Flame2',
    'Flare S100',
    'Flare 2.0',
    'Flare 2.1',
    'Flare2X',
    'Flare 5',
    'FlareA1',
    'Flare J1',
    'FLARE J1 PLUS',
    'FLARE J2',
    'Flare J2 DTV',
    'Flare J3 Plus',
    'Flare P1 Mini',
    'Flare S3 Power',
    'Flare S4',
    'Flare S4 Max',
    'Flare S4 Mini',
    'FLARE S5 MAX',
    'Flare S6 Max',
    'Fly F[0-9]{2,3}!!',
    'Fly Phoenix 2',
    'Fly Ego Art 2',
    '(Fly )?IQ ?[0-9]{3,4}!!',
    'Flylife!!',
    'Fly Flylife Web 7.85 Slim',
    'Flyer',
    '(HW-|HUAWEI )?(DRA|FLA|TIT|TAG|NCE|TRT|SLA)!!',
    'Flair E1',
    'Flair E2',
    'FlairE3',
    'Flair P1',
    'Flair P1i',
    'Flair P8',
    'Flair S1',
    'Flair Z1'
  ],
  '@FN': ['(tablet )?fnac!!'],
  '@FO': [
    'Forward Active',
    'Forward Art',
    'Forward Escape',
    'Forward Endurance',
    'ForwardEndurance',
    'FORWARD EVOLVE',
    'Forward Infinity',
    'Forward Next',
    'Forward Prime',
    'Forward Racing 3',
    'Forward Ruby',
    'ForwardRuby',
    'Forward Shake',
    'ForwardXtreme',
    'Forward Young',
    'ForwardZero',
    'Forward 5 5',
    'Forward 5.5',
    'Folio 100',
    'folio100'
  ],
  '@FP': ['FP1', 'FP1U', 'FP2'],
  '@FR': [
    'Freelander I20',
    '(HW-|HUAWEI |HONOR )?(ATH|BLN|BKL|BND|CHE|CHM|COL|DUA|DUK|DLI|EDI|FRD|HN3|H30|H60|HOL|JMM|KIW|LLD|NEM|NMO|PE|PLK|RNE|SCL|KNT|CAM|STF|HDN)!!',
    '(MODECOM )?FreeTAB!!'
  ],
  '@FS': ['FS403', 'FS407', 'FS451', 'FS514'],
  '@FT': ['FTJ152A', 'FTJ161B', 'FTJ162E'],
  '@FU': ['full Android on Microsoft Windows, pad, pc, n*books', 'Fusion Bolt', 'FUSIONideos', 'Fuel F2'],
  '@FW': ['FWS[0-9]{3,3}!!'],
  '@FZ': ['FZ-A1(A|B)!', 'FZ-A2A', 'FZ-B2(B|D)!', 'FZ-N1', 'FZ-T1', 'FZ-X1'],
  '@G ': ['G Watch', 'G Watch R'],
  '@G0': ['G0215D', 'G0775'],
  '@G1': [
    'G1-715',
    'G1-725',
    'G100W',
    'G17(B5DV)',
    'G17(B7DV)',
    'G17h 3G??(K5E2)',
    'G17h 3G??(K6E2',
    'G17h 3G四核(K5E2)',
    'G17h 3G四核(K6E2)',
    'G17s 3G',
    'G17s 3G??(K5E5)',
    'G17s 3G四核(K5E5)',
    'G17s 3G四核(K5E4)',
    'G17s 3G四核(K5E3)',
    'G18 3G四核(C6B9)',
    'G18mini(C5B9)',
    'G18d 3G四核(D3A2)',
    'G18d mini(FV2C)'
  ],
  '@G2': ['G2S', 'G2SMNT'],
  '@G3': ['(Moto)?G3$!', '(Moto)?G3-TE$!', 'G3SMNTS22', 'G3SMNTS23'],
  '@G6': [
    '(HW-|HUAWEI )?(ALE|ANE|D2|DAV|EML|EVA|FIG|G6|G7|GRA|M100|P2|P6|P7|PRA|RIO|SC|Sophia|VIE|VKY|VNS|VTR|WAS)!!'
  ],
  '@G7': [
    '(HW-|HUAWEI )?(ALE|ANE|D2|DAV|EML|EVA|FIG|G6|G7|GRA|M100|P2|P6|P7|PRA|RIO|SC|Sophia|VIE|VKY|VNS|VTR|WAS)!!'
  ],
  '@G9': ['G9'],
  '@GA': ['(Google )?Galaxy Nexus!', 'Galaxy S4 Google Editon', 'Garmin!!', 'Galaxy!!'],
  '@GE': [
    'generic',
    'generic x86',
    'Gear Live',
    'Genius!!',
    '(GP-|Geeksphone)!!',
    'Gemei!!',
    'GEM[0-9]{4,4}!!',
    'GEM-702L',
    'GEM-703L',
    'GETAWAY',
    'gemini',
    'General Mobile 4G',
    'General Mobile 4G Dual'
  ],
  '@GF': ['GFIVE!!'],
  '@GH': ['Ghost', 'GHIA!!'],
  '@GI': [
    '(Gsmart|Gigabyte|Rio)!!',
    'Gigaset!!',
    '(GIO-)?(GiONEE[- ])?A1$!',
    '(GIO-)?(GiONEE[- ])?A9$!',
    '(GIO-)?(GiONEE[- ])?C500!',
    '(GIO-)?(GiONEE[- ])?C600!',
    '(GIO-)?(GiONEE[- ])?C610!',
    '(GIO-)?(GiONEE[- ])?C620!',
    '(GIO-)?(GiONEE[- ])?C700!',
    '(GIO-)?(GiONEE[- ])?C800!',
    '(GIO-)?(GiONEE[- ])?Dream D1!',
    '(GIO-)?(GiONEE[- ])?E3T!',
    '(GIO-)?(GiONEE[- ])?E3$!',
    '(GIO-)?(GiONEE[- ])?E5$!',
    '(GIO-)?(GiONEE[- ])?E6mini!',
    '(GIO-)?(GiONEE[- ])?E6$!',
    '(GIO-)?(GiONEE[- ])?E6T$!',
    '(GIO-)?(GiONEE[- ])?E7$!',
    '(GIO-)?(GiONEE[- ])?F103!',
    '(GIO-)?(GiONEE[- ])?F301!',
    '(GIO-)?(GiONEE[- ])?GN5001!',
    '(GIO-)?(GiONEE[- ])?GN5002!',
    '(GIO-)?(GiONEE[- ])?GN8001!',
    '(GIO-)?(GiONEE[- ])?GN9000!',
    '(GIO-)?(GiONEE[- ])?GN9001!',
    '(GIO-)?(GiONEE[- ])?GN9002!',
    '(GIO-)?(GiONEE[- ])?GN9004!',
    '(GIO-)?(GiONEE[- ])?GN9005!',
    '(GIO-)?(GiONEE[- ])?GN9006!',
    '(GIO-)?(GiONEE[- ])?GN9007!',
    '(GIO-)?(GiONEE[- ])?GN9008!',
    '(GIO-)?(GiONEE[- ])?GN9010!',
    '(GIO-)?(GiONEE[- ])?GN100T!',
    '(GIO-)?(GiONEE[- ])?GN100!',
    '(GIO-)?(GiONEE[- ])?GN105!',
    '(GIO-)?(GiONEE[- ])?GN106!',
    '(GIO-)?(GiONEE[- ])?GN107!',
    '(GIO-)?(GiONEE[- ])?GN108!',
    '(GIO-)?(GiONEE[- ])?GN109!',
    '(GIO-)?(GiONEE[- ])?GN135!',
    '(GIO-)?(GiONEE[- ])?GN136!',
    '(GIO-)?(GiONEE[- ])?GN137!',
    '(GIO-)?(GiONEE[- ])?GN139!',
    '(GIO-)?(GiONEE[- ])?GN150!',
    '(GIO-)?(GiONEE[- ])?GN151!',
    '(GIO-)?(GiONEE[- ])?GN152!',
    '(GIO-)?(GiONEE[- ])?GN160T!',
    '(GIO-)?(GiONEE[- ])?GN160!',
    '(GIO-)?(GiONEE[- ])?GN168T!',
    '(GIO-)?(GiONEE[- ])?GN170!',
    '(GIO-)?(GiONEE[- ])?GN180!',
    '(GIO-)?(GiONEE[- ])?GN181!',
    '(GIO-)?(GiONEE[- ])?GN200!',
    '(GIO-)?(GiONEE[- ])?GN205!',
    '(GIO-)?(GiONEE[- ])?GN210!',
    '(GIO-)?(GiONEE[- ])?GN305!',
    '(GIO-)?(GiONEE[- ])?GN320!',
    '(GIO-)?(GiONEE[- ])?GN360!',
    '(GIO-)?(GiONEE[- ])?GN380!',
    '(GIO-)?(GiONEE[- ])?GN600!',
    '(GIO-)?(GiONEE[- ])?GN700T!',
    '(GIO-)?(GiONEE[- ])?GN700W!',
    '(GIO-)?(GiONEE[- ])?GN705T!',
    '(GIO-)?(GiONEE[- ])?GN705W!',
    '(GIO-)?(GiONEE[- ])?GN706L!',
    '(GIO-)?(GiONEE[- ])?GN708T!',
    '(GIO-)?(GiONEE[- ])?GN708W!',
    '(GIO-)?(GiONEE[- ])?GN787!',
    '(GIO-)?(GiONEE[- ])?GN800!',
    '(GIO-)?(GiONEE[- ])?GN810!',
    '(GIO-)?(GiONEE[- ])?GN818T!',
    '(GIO-)?(GiONEE[- ])?GN858!',
    '(GIO-)?(GiONEE[- ])?GN868!',
    '(GIO-)?(GiONEE[- ])?GN878!',
    'Gionee M1',
    'Gionee M2',
    'Gionee-M2',
    'Gionee M3S',
    'Gionee M5',
    '(GIO-)?(GiONEE[- ])?S101!',
    'GiONEE TD500',
    '(GIO-)?(GiONEE[- ])?V182!',
    '(GIO-)?(GiONEE[- ])?V185!',
    '(GIO-)?(GiONEE[- ])?V188!',
    '(GIO-)?(GiONEE[- ])?W800!',
    '(GIO-)?(GiONEE[- ])?X817!',
    '(GIO-)?(GiONEE[- ])?Ctrl V1!',
    '(GIO-)?(GiONEE[- ])?Ctrl V2!',
    '(GIO-)?(GiONEE[- ])?Ctrl V3!',
    '(GIO-)?(GiONEE[- ])?Ctrl V4!',
    '(GIO-)?(GiONEE[- ])?Ctrl V5!',
    '(GIO-)?(GiONEE[- ])?Pioneer P1!',
    '(GIO-)?(GiONEE[- ])?Pioneer P2!',
    '(GIO-)?(GiONEE[- ])?Pioneer P3!',
    '(GIO-)?(GiONEE[- ])?Pioneer P4!',
    'Gionee P3',
    'Gionee P4',
    'GIONEE P7',
    'GiONEE S7',
    'GIONEE S10',
    '(GIO-)?(GiONEE[- ])?Gpad G1!',
    '(GIO-)?(GiONEE[- ])?Gpad G2!',
    '(GIO-)?(GiONEE[- ])?Gpad G3!',
    'GinDream/GinMagic'
  ],
  '@GK': ['GK802'],
  '@GL': [
    'Glass 1',
    'GLADIATOR',
    'GLADIATOR-2',
    'GLADIATOR 3',
    'GLADIATOR 4',
    'Glory',
    'Glory 2',
    'Glory3',
    'GLORY 4',
    'GloryG1000',
    'GL-900',
    'GLX!!',
    'GL07S'
  ],
  '@GM': [
    'Gm Discovery',
    'GM Discovery II',
    'GM Discovery II+',
    'GM FOX',
    'GM Ultimate Slim',
    'GM 5',
    'GM 5 d',
    'GM 5 Plus',
    'GM 5 Plus d',
    'GM 6',
    'GM 6 d',
    'GM Discovery tab 8'
  ],
  '@GN': [
    '(GIO-)?(GiONEE[- ])?GN5001!',
    '(GIO-)?(GiONEE[- ])?GN5002!',
    '(GIO-)?(GiONEE[- ])?GN8001!',
    '(GIO-)?(GiONEE[- ])?GN9000!',
    '(GIO-)?(GiONEE[- ])?GN9001!',
    '(GIO-)?(GiONEE[- ])?GN9002!',
    '(GIO-)?(GiONEE[- ])?GN9004!',
    '(GIO-)?(GiONEE[- ])?GN9005!',
    '(GIO-)?(GiONEE[- ])?GN9006!',
    '(GIO-)?(GiONEE[- ])?GN9007!',
    '(GIO-)?(GiONEE[- ])?GN9008!',
    '(GIO-)?(GiONEE[- ])?GN9010!',
    '(GIO-)?(GiONEE[- ])?GN100T!',
    '(GIO-)?(GiONEE[- ])?GN100!',
    '(GIO-)?(GiONEE[- ])?GN105!',
    '(GIO-)?(GiONEE[- ])?GN106!',
    '(GIO-)?(GiONEE[- ])?GN107!',
    '(GIO-)?(GiONEE[- ])?GN108!',
    '(GIO-)?(GiONEE[- ])?GN109!',
    '(GIO-)?(GiONEE[- ])?GN135!',
    '(GIO-)?(GiONEE[- ])?GN136!',
    '(GIO-)?(GiONEE[- ])?GN137!',
    '(GIO-)?(GiONEE[- ])?GN139!',
    '(GIO-)?(GiONEE[- ])?GN150!',
    '(GIO-)?(GiONEE[- ])?GN151!',
    '(GIO-)?(GiONEE[- ])?GN152!',
    '(GIO-)?(GiONEE[- ])?GN160T!',
    '(GIO-)?(GiONEE[- ])?GN160!',
    '(GIO-)?(GiONEE[- ])?GN168T!',
    '(GIO-)?(GiONEE[- ])?GN170!',
    '(GIO-)?(GiONEE[- ])?GN180!',
    '(GIO-)?(GiONEE[- ])?GN181!',
    '(GIO-)?(GiONEE[- ])?GN200!',
    '(GIO-)?(GiONEE[- ])?GN205!',
    '(GIO-)?(GiONEE[- ])?GN210!',
    '(GIO-)?(GiONEE[- ])?GN305!',
    '(GIO-)?(GiONEE[- ])?GN320!',
    '(GIO-)?(GiONEE[- ])?GN360!',
    '(GIO-)?(GiONEE[- ])?GN380!',
    '(GIO-)?(GiONEE[- ])?GN600!',
    '(GIO-)?(GiONEE[- ])?GN700T!',
    '(GIO-)?(GiONEE[- ])?GN700W!',
    '(GIO-)?(GiONEE[- ])?GN705T!',
    '(GIO-)?(GiONEE[- ])?GN705W!',
    '(GIO-)?(GiONEE[- ])?GN706L!',
    '(GIO-)?(GiONEE[- ])?GN708T!',
    'GN 708T',
    '(GIO-)?(GiONEE[- ])?GN708W!',
    '(GIO-)?(GiONEE[- ])?GN787!',
    '(GIO-)?(GiONEE[- ])?GN800!',
    '(GIO-)?(GiONEE[- ])?GN810!',
    '(GIO-)?(GiONEE[- ])?GN818T!',
    '(GIO-)?(GiONEE[- ])?GN858!',
    '(GIO-)?(GiONEE[- ])?GN868!',
    '(GIO-)?(GiONEE[- ])?GN878!',
    'Gnappo Ideos'
  ],
  '@GO': [
    'google sdk',
    'Google Ion',
    '(Google )?Nexus S!',
    '(Google )?Galaxy Nexus!',
    '(Google )?Nexus ?4!',
    '(Google )?Nexus ?5!',
    '(Google )?Nexus ?6P!',
    '(Google )?Nexus ?6!',
    '(Google )?Nexus ?7 2013!',
    '(Google )?Nexus ?7!',
    '(Google )?Nexus ?9!',
    '(Google )?Nexus ?10!',
    'Google Pixel',
    'Google Pixel 2',
    'Google Pixel 2XL',
    'Google Chromebook Pixel (2015)',
    'google cube',
    'GOCL!!',
    'GO Live!!',
    'GOOPHONE!!',
    'GO !!',
    'GOA',
    'GO504',
    'GO778',
    'GO960',
    'GO963',
    'GO980',
    'GO984',
    'Gomobile GO1001'
  ],
  '@GP': [
    '(GP-|Geeksphone)!!',
    'GP-431',
    'GP-720',
    'GPLUS GN708W',
    'GPLUS N809',
    '(GIO-)?(GiONEE[- ])?Gpad G1!',
    '(GIO-)?(GiONEE[- ])?Gpad G2!',
    '(GIO-)?(GiONEE[- ])?Gpad G3!',
    'Gpad G5'
  ],
  '@GR': [
    'Grouper',
    'GR-TB!!',
    '(HW-|HUAWEI )?(ALE|ANE|D2|DAV|EML|EVA|FIG|G6|G7|GRA|M100|P2|P6|P7|PRA|RIO|SC|Sophia|VIE|VKY|VNS|VTR|WAS)!!',
    'greenridge',
    'Graphos A10',
    '(ZTE )?(Grand|Mimosa)!!'
  ],
  '@GS': ['GS01', '(Gsmart|Gigabyte|Rio)!!', 'GS02', 'GS03'],
  '@GT': [
    'GT-I9505G',
    'GT-810',
    'GT-I7105',
    'GT-I9810',
    'GT-[HN][0-9]{4,4}!!',
    'GT-9000',
    'GT-[0-9]{4,4}!!',
    'GT-i9377',
    'GT-T9500',
    'GT540',
    'GT540f',
    'GTV100',
    'GT-B[0-9]{4,4}!!',
    'GT-I[0-9]{3,4}!!',
    'GT-N[0-9]{4,4}!!',
    'GT-P[0-9]{4,4}!!',
    'GT-S[0-9]{4,4}!!',
    'GT-T959!',
    'GT9100',
    'GTablet',
    'GtabComb'
  ],
  '@GU': ['gucci'],
  '@GV': ['GVON 898'],
  '@GW': ['GW620'],
  '@GX': ['GX1210V TV'],
  '@H1': ['H120'],
  '@H2': ['H2000+'],
  '@H3': [
    '(HW-|HUAWEI |HONOR )?(ATH|BLN|BKL|BND|CHE|CHM|COL|DUA|DUK|DLI|EDI|FRD|HN3|H30|H60|HOL|JMM|KIW|LLD|NEM|NMO|PE|PLK|RNE|SCL|KNT|CAM|STF|HDN)!!'
  ],
  '@H6': [
    '(HW-|HUAWEI |HONOR )?(ATH|BLN|BKL|BND|CHE|CHM|COL|DUA|DUK|DLI|EDI|FRD|HN3|H30|H60|HOL|JMM|KIW|LLD|NEM|NMO|PE|PLK|RNE|SCL|KNT|CAM|STF|HDN)!!'
  ],
  '@H7': ['H701', 'H7100', 'H7500+', 'H710VL', 'H715BL'],
  '@H8': ['H8 Life', 'H866C', 'H882L'],
  '@H9': ['H940', 'H9500'],
  '@HA': [
    'HammerHead',
    '(Haier[- ])?H[ETW]- ?[A-Z][0-9]!!',
    'Haier-W700',
    'Haier-SY0880',
    'Hasee E50 S1',
    'Hasee H45 T2',
    'Hasee W50 T2',
    'Hasee-X50TS',
    'HannsComb',
    'Hannspadd',
    'Hayabusa'
  ],
  '@HB': ['HB-100 DASAN', 'HB-100 DASAN Networks, Inc.', 'HB-1000'],
  '@HD': [
    'HD2',
    'HD2 LEO',
    'HD7  Pro',
    '(HW-|HUAWEI |HONOR )?(ATH|BLN|BKL|BND|CHE|CHM|COL|DUA|DUK|DLI|EDI|FRD|HN3|H30|H60|HOL|JMM|KIW|LLD|NEM|NMO|PE|PLK|RNE|SCL|KNT|CAM|STF|HDN)!!'
  ],
  '@HE': ['HEDY!!', 'HERO H7500+', 'Hero', 'HERO CDMA', 'HERO200'],
  '@HI': [
    'HiBook pro',
    '(Highscreen|Alpha|Bay|Boost|Cosmo|Explosion|Power|Prime|Zera)!!',
    'Himax Pure',
    'HIKe!!',
    'HILIVE H7',
    '(HS-)?Hisense!!',
    'Hisense AD686G',
    '(Hisense )?(LED[0-9]{2,2}(G|K|L|EC|XT)[0-9]{2,3})!',
    'Hisense Google TV TV',
    'hisense gx1200v',
    '(Amaze|Hitech)!!',
    'HITO HT-3',
    'Hikari-iFrame!',
    'HIGHWAY',
    'HIGHWAY PURE',
    'HIGHWAY SIGNS'
  ],
  '@HK': ['HKPHONE H8-3G'],
  '@HL': ['HLV-T!!'],
  '@HM': [
    'HMP8100 ATV 93',
    'HMP8100 ATV INT',
    '(Xiaomi )?(Redmi|RedRice|HM)!!',
    '(Xiaomi )?(Redmi|HM)[ \\-]?Note!!',
    '(Xiaomi |HM)?20!!'
  ],
  '@HN': [
    '(HW-|HUAWEI |HONOR )?(ATH|BLN|BKL|BND|CHE|CHM|COL|DUA|DUK|DLI|EDI|FRD|HN3|H30|H60|HOL|JMM|KIW|LLD|NEM|NMO|PE|PLK|RNE|SCL|KNT|CAM|STF|HDN)!!'
  ],
  '@HO': [
    'HOSIN!!',
    '(HW-|HUAWEI |HONOR )?(ATH|BLN|BKL|BND|CHE|CHM|COL|DUA|DUK|DLI|EDI|FRD|HN3|H30|H60|HOL|JMM|KIW|LLD|NEM|NMO|PE|PLK|RNE|SCL|KNT|CAM|STF|HDN)!!',
    'Honor3c2G-T',
    'Honor Bee',
    'HOMESYNCT2WIFI'
  ],
  '@HP': ['HP Chromebook x360 11 G1 EE', '(HP|Slate)!!', 'HP!!', 'HP-TouchPad', '(HP )?Touchpad!'],
  '@HS': [
    'HS-[0-9]{1,2}DTB!!',
    'HS-[EFHITUX][0-9]!!',
    'HS-E[GT][0-9]{3,3}!!',
    '(HS-)?Hisense!!',
    'HS-EG98',
    'HS U978'
  ],
  '@HT': [
    '(HTC )?Nexus ?One!',
    'HTC One',
    'HT7 Pro',
    'HT17Pro',
    'HT20Pro',
    'HTC!!',
    '(HTC|PCD|USCC)?ADR[0-9]{4,4}!!',
    '(HTC )?HT[LV][0-9]{2,2}!!',
    'HTX21',
    'HTC Dream',
    'HTC Dream G1',
    'HTC Dream SparksMod ',
    'HTC Vision',
    'HTC T-Mobile myTouch 3G Slide',
    'HTC my ?Touch 3G Slide!',
    'HTC Glacier',
    'HTC Panache',
    'HTC My ?Touch ?4G$!',
    'HTC S910m',
    'HTC myTouch 4G Slide',
    'HTC Doubleshot'
  ],
  '@HU': [
    'HUAWEI WATCH',
    'Huawei MediaPad',
    'Huawei OsiMood MediaPad',
    'HUAWEI MediaPad M1 8.0',
    'Huawei MediaPad T1 7.0 3G',
    'Huawei MediaPad T1 8.0 4G',
    'Huawei MediaPad T1 10 4G',
    '(Huawei )?[MSTX](1|2|7|8|10)\\-[A-Z0-9][0-9]{2,2}!!',
    'HUAWEI GEM-703L',
    '(HUAWEI )?(ALP|BLA|CRR|LON|MATE|MHA|MT1|MT2|MT7|M200|NXT|Z100)!!',
    '(HW-|HUAWEI )?(DRA|FLA|TIT|TAG|NCE|TRT|SLA)!!',
    '(HW-|HUAWEI |HONOR )?(ATH|BLN|BKL|BND|CHE|CHM|COL|DUA|DUK|DLI|EDI|FRD|HN3|H30|H60|HOL|JMM|KIW|LLD|NEM|NMO|PE|PLK|RNE|SCL|KNT|CAM|STF|HDN)!!',
    '(HW-|HUAWEI )?(BLL|CHC|TAG|KII)!!',
    '(HW-|HUAWEI )?(ALE|ANE|D2|DAV|EML|EVA|FIG|G6|G7|GRA|M100|P2|P6|P7|PRA|RIO|SC|Sophia|VIE|VKY|VNS|VTR|WAS)!!',
    'HUAWEI A168-(AL10|DL09|L09|L29)!',
    '(HW-|HUAWEI )?(CRO|LUA|CUN|SCC|SCU|CAM|LDN|LYO|MYA)!!',
    '(HW-|HUAWEI )?CAZ-(AL10|TL10|TL20)!',
    '(HW-|HUAWEI )?CAN-(L01|L11|L12)!',
    '(HW-|HUAWEI )?MLA-(L01|L03|L11|L12|L13)!',
    '(HW-|HUAWEI )?DIG-(AL00|L01|L03|L21|TL10)!',
    '(HW-|HUAWEI )?BAC-(AL00|L03|L21|L22|TL00)!',
    '(HW-|HUAWEI )?HWI-(AL00|TL00)!',
    '(HW-|HUAWEI )?MLA-(AL00|AL10)!',
    '(HW-|HUAWEI )?MLA-(TL00|TL10|UL00)!',
    'Huawei P7 mini',
    'Huawei P8max',
    '(Huawei|Ascend|HW-)!!',
    'HUAWEI Honor 3c w',
    'Huawei S7',
    'Hudl HT7S3',
    'Hudl 2',
    'HUAWEI U8686',
    'Huawei 858'
  ],
  '@HW': [
    '(HW-|HUAWEI )?(DRA|FLA|TIT|TAG|NCE|TRT|SLA)!!',
    '(HW-|HUAWEI |HONOR )?(ATH|BLN|BKL|BND|CHE|CHM|COL|DUA|DUK|DLI|EDI|FRD|HN3|H30|H60|HOL|JMM|KIW|LLD|NEM|NMO|PE|PLK|RNE|SCL|KNT|CAM|STF|HDN)!!',
    '(HW-|HUAWEI )?(BLL|CHC|TAG|KII)!!',
    '(HW-|HUAWEI )?(ALE|ANE|D2|DAV|EML|EVA|FIG|G6|G7|GRA|M100|P2|P6|P7|PRA|RIO|SC|Sophia|VIE|VKY|VNS|VTR|WAS)!!',
    '(HW-|HUAWEI )?(CRO|LUA|CUN|SCC|SCU|CAM|LDN|LYO|MYA)!!',
    '(HW-|HUAWEI )?CAZ-(AL10|TL10|TL20)!',
    '(HW-|HUAWEI )?CAN-(L01|L11|L12)!',
    '(HW-|HUAWEI )?MLA-(L01|L03|L11|L12|L13)!',
    '(HW-|HUAWEI )?DIG-(AL00|L01|L03|L21|TL10)!',
    '(HW-|HUAWEI )?BAC-(AL00|L03|L21|L22|TL00)!',
    '(HW-|HUAWEI )?HWI-(AL00|TL00)!',
    '(HW-|HUAWEI )?MLA-(AL00|AL10)!',
    '(HW-|HUAWEI )?MLA-(TL00|TL10|UL00)!',
    '(Huawei|Ascend|HW-)!!',
    'hwu8812D',
    'HW-01E',
    'HW-01K',
    'HW-03E',
    'HWT31',
    'HWV32'
  ],
  '@HY': ['HY5001', 'HYUNDAI!!', 'Hydro', 'Hydro PLUS', 'HYPER X BLADE'],
  '@I ': ['I 7520'],
  '@I-': ['i-Joy i-Call', 'i-Call 300', 'i-Call 300v2', 'i-Call 504', '(i-mobile|i-style|IQ)!!'],
  '@I1': ['I110', 'i1'],
  '@I3': ['i3000'],
  '@I5': ['i5300', 'i5350'],
  '@I6': ['i6000'],
  '@I7': ['I7500'],
  '@I8': ['i8400', 'i8450', 'i803w', 'I897'],
  '@I9': ['I9220', 'i9400', 'i9430', 'i9480', 'i9500', 'i9570', 'I9000', 'I9300 Galaxy SIII ', 'I9300'],
  '@IB': ['(iBall )?Andi!!', 'iBall!!', '(Aura|iberry|AUXUS)!!'],
  '@IC': ['ICONIA!!', 'IconBit NetTab Thor Mini'],
  '@ID': [
    '(Digma )?iD[jmnsx][DQ]?[0-9]*!!',
    'IDEOS!!',
    'IdeaPad A1',
    'IdeaPadA10',
    'Ideapad K1!',
    'Ideapad S10-3T',
    '(Lenovo ?)?(IdeaTab ?)?[AB][0-9]{4,4}!!',
    '(Lenovo ?)?(IdeaTab ?)?[KSV][0-9]{4,4}!!',
    'idea ?tv!!'
  ],
  '@IF': ['ifive!!'],
  '@IG': ['IGGY'],
  '@IL': ['(Ilium )?Avvio!!', 'ILT-MX100', '(Lanix )?(Ilium|llium)!!'],
  '@IM': [
    'imx50!',
    'imx51!',
    'imx53!',
    'imx6q!',
    'IMO!!',
    'Im(Smart|PAD)!!',
    '(SKY )?IM[- ][A-Z][0-9]{3,3}!!',
    'IM-100K',
    'IM-100S'
  ],
  '@IN': [
    '(Explay|X-tremer|ActiveD|Informer|Surfer)!!',
    'INSIGNIA 5',
    'INSIGNIA 5X',
    'Inspire HD',
    'Incredible',
    'Incredible 2',
    'Incredible ?S!',
    'Incredible ?2!',
    'Incredible 4G LTE',
    'Inspire 4G',
    'INFOBAR!!',
    'Infinix!!',
    'IN[0-9]{3,3}!!',
    'Infocus!!',
    'INHON PAPILIO G1',
    'intki E86',
    'Innos!!',
    '(Intex )?Aqua!!',
    '(Intex )?Cloud!!',
    'INTEX IRIS-II',
    'INQ Cloud Touch',
    'INQ Mayfair (EU)',
    '(iNote|itel)!!',
    'Infinity',
    'Internet TV',
    'Internet TV Box'
  ],
  '@IO': ['iOCEAN!!'],
  '@IP': ['iP977', 'IPRO i5S'],
  '@IQ': ['(Fly )?IQ ?[0-9]{3,4}!!', 'iQ(Talk|Tab)!!', 'iQ7 8GB', '(i-mobile|i-style|IQ)!!'],
  '@IR': ['Iris!!'],
  '@IS': [
    'IS11CA',
    'ISW?[0-9]{2,2}F!!',
    'ISW[0-9]{2,2}HT!!',
    'ISW11K',
    'IS11LG',
    'ISW11M',
    'IS12M',
    'IS11N',
    'IS06',
    'IS11PT',
    'IS703C',
    'IS801C',
    'ISW11SC',
    'IS0[0-9]!!',
    'ISW?1[0-9]SH!!',
    'IS[0-9]{2,2}S!!',
    'IS04',
    'IS11T'
  ],
  '@IT': ['(iNote|itel)!!', 'ITP-XD10W', 'ITP-XD80L', 'ITP-XD97W'],
  '@IU': ['IUNI U810'],
  '@IV': ['IVIO!!'],
  '@IW': ['iwoo i900'],
  '@IX': ['iX101T1', 'iX101T1-2G', 'iX101T1-XS'],
  '@JA': ['Jaguar3', 'Jaguar7'],
  '@JC': ['JC-S9220', 'JC-A[0-9]{3,3}!!', 'JC-KSP8000'],
  '@JD': ['JDN-W09'],
  '@JI': ['(JIAYU|JY)!!', 'JIMMY'],
  '@JJ': ['JJ5S+'],
  '@JM': [
    '(HW-|HUAWEI |HONOR )?(ATH|BLN|BKL|BND|CHE|CHM|COL|DUA|DUK|DLI|EDI|FRD|HN3|H30|H60|HOL|JMM|KIW|LLD|NEM|NMO|PE|PLK|RNE|SCL|KNT|CAM|STF|HDN)!!'
  ],
  '@JO': ['Jolla', 'Joy', 'JOIN'],
  '@JT': ['JT SmartPC02', 'JT-Smart PC01', 'JT-H580VT', 'JT-H581VT', 'JT-B1'],
  '@JX': ['JXD!!'],
  '@JY': ['(JIAYU|JY)!!'],
  '@K0': [
    'K00C',
    'K010',
    'K010E',
    'K018',
    'K014',
    'K01B',
    'K00G',
    'K00E',
    'K00Y',
    'K00Z',
    'K012',
    'K019',
    'K01F',
    'K01N',
    'K01Q',
    'K016',
    'K01E',
    'K00X',
    'K00R',
    'K007',
    'K013',
    'K013C',
    'K017',
    'K01A',
    'K012 2',
    'K01U',
    'K00S',
    'K00U',
    'K011',
    'K015',
    'K01H',
    'K00L',
    'K00F',
    'K080'
  ],
  '@K1': ['K11', 'K1', 'K10000 Pro'],
  '@K3': ['K3', 'K30-T', 'K30-W', 'K3 Note'],
  '@K8': ['(CUBE ?)?(K8|U1|U2|U3|U5|U6|U8|U9)[0-9]?GT!!'],
  '@K9': ['K9 Smart 4G'],
  '@KA': [
    'Karbonn!!',
    '(Karbonn|Titanium)!!',
    'Karbonn Aura 9',
    '(KAZAM|Thunder|Tornado|Trooper)!!',
    '(KATBL|Kogan|Agora)!!',
    'Kavak Y625-U03'
  ],
  '@KB': ['KB901'],
  '@KC': ['KC-01', 'KC-S301AE', 'KC-S701', 'KCP01K'],
  '@KE': ['KENEKSI!!', 'kenzo'],
  '@KF': [
    'KFOTE?!',
    'KFTT',
    'KFJW(I|A)!',
    'KFJMWI',
    'KFSOWI',
    'KFTHW(I|A)!',
    'KFAPW(I|A)!',
    'KFARWI',
    'KFASWI',
    'KFSAW(I|A)!',
    'KFFOWI',
    'KFMEWI',
    'KFTBWI',
    'KFAUWI',
    'KFGIWI',
    'KFDOWI',
    'KFSUWI'
  ],
  '@KI': [
    'Kindle Fire',
    '(HW-|HUAWEI |HONOR )?(ATH|BLN|BKL|BND|CHE|CHM|COL|DUA|DUK|DLI|EDI|FRD|HN3|H30|H60|HOL|JMM|KIW|LLD|NEM|NMO|PE|PLK|RNE|SCL|KNT|CAM|STF|HDN)!!',
    '(HW-|HUAWEI )?(BLL|CHC|TAG|KII)!!',
    'KIOTO 793',
    'KITE',
    '(ZTE )?Kis!!'
  ],
  '@KM': ['(EV|KM)-[ES][0-9]{3,3}!!'],
  '@KN': [
    '(HW-|HUAWEI |HONOR )?(ATH|BLN|BKL|BND|CHE|CHM|COL|DUA|DUK|DLI|EDI|FRD|HN3|H30|H60|HOL|JMM|KIW|LLD|NEM|NMO|PE|PLK|RNE|SCL|KNT|CAM|STF|HDN)!!'
  ],
  '@KO': [
    'Konka Amber3',
    'KOB-(L09|W09)!',
    '(KATBL|Kogan|Agora)!!',
    'KOMU!!',
    'KONKA!!',
    'koobee-T550',
    'Koobe!!',
    'KORIDY H15',
    'KORIDY H16'
  ],
  '@KP': ['KPT!!', 'KPN!!'],
  '@KS': ['KSP8000'],
  '@KU': ['Kurio!!', 'KU9500', 'KUNO4', 'KUNO 4+'],
  '@KY': [
    'KYV33',
    'Kyobo mirasol eReader',
    'KYL[0-9]{2,2}!!',
    '(USCC-|KYOCERA-)?E[0-9]{4,4}!!',
    '(USCC-|KYOCERA-)?C[0-9]{4,4}!!',
    'KY[FLTYV][0-9]{2,2}!!',
    'Kyivstar!!'
  ],
  '@L': ['(Hisense )?(LED[0-9]{2,2}(G|K|L|EC|XT)[0-9]{2,3})!'],
  '@L-': ['L-0[0-9][A-Z]!!'],
  '@L3': ['L3'],
  '@L9': ['l97D'],
  '@LA': [
    'LA-!!',
    '(Lanix )?(Ilium|llium)!!',
    'Lark!!',
    'LAVA iris 351',
    'LAVA iRIS 504q',
    'LAVA A1',
    'Lava A89',
    'LAVA R1',
    'LAVA R1s',
    'LAVA S12',
    'LAVA V5',
    'LAP250U',
    'LAP255U',
    'LaVieTab!!',
    'land',
    'LA-I Dual core',
    'LA-M3',
    'LA1-L',
    'LA2-E',
    'LA2-E1',
    'LA2-L',
    'LA2-T',
    'LA2-T1',
    'LA2-S',
    'LA2-SN',
    'LA2-W',
    'LA2-W1',
    'LA3-W',
    'LA3S',
    'LA5-W'
  ],
  '@LC': [
    '(AC|BC|LC|MT|RC|QS|VM|TS|OC)[0-9]{4,4}[A-Z]!!',
    'LC-Ux30US',
    'LC-[0-9]{2,2}((LE|UE)[0-9]{1,3}[A-Z])!',
    'LC-((A|S|LX)[0-9]{1,3}[A-Z])!',
    'LCD-((S|V|LX|UF)[0-9]{1,3}[A-Z])!'
  ],
  '@LD': ['(HW-|HUAWEI )?(CRO|LUA|CUN|SCC|SCU|CAM|LDN|LYO|MYA)!!', 'LDK-ICK v1.4'],
  '@LE': [
    '(LE[0-9]{2,2}[BMU][0-9]{4,4}[A-Z]+)!',
    '(Hisense )?(LED[0-9]{2,2}(G|K|L|EC|XT)[0-9]{2,3})!',
    'Legend',
    'LEAGOOLG13',
    'Le 1S',
    'Le 1 Pro',
    'Le 2',
    'Le 2 Pro',
    'Le Max',
    'LEX626',
    'LEX720',
    'LEX820',
    'Le X500',
    'Le X501',
    'Le X506',
    'Le X507',
    'Le X509',
    'Le X520',
    'Le X522',
    'Le X526',
    'Le X527',
    'Le X528',
    'Le X620',
    'Le X621',
    'Le X622',
    'Le X625',
    'Le X820',
    'Le X821',
    'Le X822',
    'Le X829',
    'Le X829M',
    'Le X920',
    'LETV Letv X500',
    'LeTv 1s',
    'Letv X500',
    'Letv X501',
    'Letv X502',
    'Letv X507',
    'Letv X520',
    'Letv X600',
    'Letv X900',
    'Letv X910',
    'Letv Max4-70',
    'Letv C1S',
    'Letv U2',
    'Letv S40 Air',
    'Letv S40 Air L',
    'Letv S50 Air',
    'Letv X3-40',
    'Letv X3-50 UHD',
    'Letv X3-55',
    'Letv X3-55 Pro',
    'Letv X3-65',
    'LeTVX60',
    'leepoo!!',
    'LEMON P7',
    'Lemon S3',
    'Lemon S8',
    'Lenco!!',
    'LENCM900HZ',
    'Lenovo A1-32AB0',
    'Lenovo A1-32AJ0',
    'Lenovo IdeaPad Yoga 11S',
    'Lenovo IdeaPad Yoga 13',
    '(Lenovo ?)?(IdeaTab ?)?[AB][0-9]{4,4}!!',
    'Lenovo YB1-X90L',
    'Lenovo YB1-X90F',
    'Lenovo YB-Q501F',
    'Lenovo YT3-X50F',
    'Lenovo YT3-X50L',
    'Lenovo YT3-850F',
    'Lenovo YT-X703F',
    'Lenovo YT3-X90F',
    'Lenovo YT3-X90L',
    '(Lenovo )?(Tab ?)?(2 ?)?[AS](7|8|10)!!',
    'Lenovo TB-7304F',
    'Lenovo TB-X103F',
    'Lenovo TB2-X30F',
    'Lenovo TB2-X30L',
    'Lenovo TB3-730X',
    'Lenovo TB3-710F',
    'Lenovo TB3-710I',
    'Lenovo TB-7703X',
    'Lenovo TB3-850F',
    'Lenovo TB3-850M',
    'Lenovo TB3-X70F',
    'Lenovo TB3-X70L',
    'Lenovo TB-8504F',
    'Lenovo TB-8703F',
    'Lenovo TB-8704F',
    'Lenovo TB-X304F',
    'Lenovo TB-X704F',
    'Lenovo TB-X704L',
    '(Lenovo ?)?(IdeaTab ?)?[KSV][0-9]{4,4}!!',
    'Lenovo Pad A4',
    'Lenovo',
    'lepad 001b',
    'lepad 001n',
    '(Lenovo |Lephone )?3GC101!',
    '(Lenovo |Lephone )?3GW100!',
    '(Lenovo |Lephone )?3GW101!',
    '(Lenovo )?S1[- ]37AH0!',
    '(Lenovo )?S2[- ]38A(H0|T0)!',
    'Lenovo!!',
    'LenovoTV 40S9',
    'LenovoTV 50S52',
    'Lenovo Z2',
    '(BLF-)?lephone!!',
    'Le Pan Mini',
    'Le Pan TC802A',
    'Le Pan TC1010',
    'Le Pan TC1020',
    'LePanII',
    'Le Pan S',
    'LENNY',
    'LENNY2',
    'LENNY3'
  ],
  '@LG': [
    'LGE-lap crespo',
    'LGE-lap maguro',
    'LGE-maguro cappuccino',
    'LGE-lap mako',
    'LG-Nexus5',
    'LG-Watch Urbane',
    'LG-AN160',
    'LG-AK495',
    'LG-?AS[0-9]{3,3}!!',
    'LG-?C[0-9]{3,3}!!',
    'LG-CX670',
    'LG-?D[0-9]{3,3}!!',
    'LG-DS1203',
    'LG-?E[0-9]{3,3}!!',
    'LG-F[0-9]{3,3}!!',
    'LG-FL40L!',
    'LG-GT540!',
    'LG-GW620!',
    'LG-H[0-9]{3,3}!!',
    'LG-K[0-9]{3,3}!!',
    'LG-KH5200',
    'LG-KS1024',
    'LG-KU[0-9]{4,4}!!',
    'LG-?L[0-9]{2,3}[A-Z]!!',
    'LG-LG[0-9]{3,3}!!',
    'LGLK430',
    'LG-LK460',
    'LG-?LS[0-9]{3,3}!!',
    'LG-LU[0-9]{4,4}!!',
    'LG-LW690',
    'LG-LW770',
    'LG-M[0-9]{3,3}!!',
    'LG-?MS[0-9]{3,3}!!',
    'LGMP260',
    'LG-P[0-9]{3,3}!!',
    'LG-Q710!',
    'LG-RS988!',
    'LG-SP[0-9]{3,3}!!',
    'LG-SU[0-9]{3,3}!!',
    'LG-T480!',
    'LG-T540!',
    'LG-TP260',
    'LG-TP450',
    'LG-SU-760',
    'LGUK410',
    'LG-UK495',
    'LGUK750',
    'LGUK932',
    'LG-UN350',
    'LG-?US[0-9]{3,3}!!',
    'LG-V[0-9]{3,3}!!',
    'LG-VK[0-9]{3,3}!!',
    'LG-VN[0-9]{3,3}!!',
    'LG-VM[0-9]{3,3}!!',
    'LG-VS[0-9]{3,3}!!',
    'LG-X[0-9]{3,3}!!',
    'LGM-[GKVX][0-9]{3,3}!!',
    'LGMP450',
    'lge-F160!',
    'LGE-E988!',
    'lgp-970',
    'LG[LSTV][0-9]{2,2}!!',
    'LG!!',
    'LG-Google TV!!',
    'LG-ANDROID MINI BOX',
    'LG-P999',
    'LG-E739',
    'LG-C800'
  ],
  '@LI': [
    'Liquid!!',
    '(BLU|DASH|LIFE|NEO|STUDIO|VIVO)!!',
    'Liberty',
    '(MEDION|(MD )?LIFETAB)!!',
    'Life',
    'Liberty Tab G100',
    'Live ?With ?Walkman!',
    'libra',
    'lithium',
    'Light Tab',
    'Light Tab 2',
    'Light Tab 2W'
  ],
  '@LL': [
    '(HW-|HUAWEI |HONOR )?(ATH|BLN|BKL|BND|CHE|CHM|COL|DUA|DUK|DLI|EDI|FRD|HN3|H30|H60|HOL|JMM|KIW|LLD|NEM|NMO|PE|PLK|RNE|SCL|KNT|CAM|STF|HDN)!!',
    '(Lanix )?(Ilium|llium)!!'
  ],
  '@LM': [
    'LM-G710!',
    'LM-G715!',
    'LM-Q610!',
    'LM-Q710!',
    'LM-V350!',
    'LM-X210!',
    'LM-X410!',
    'LM-X415!',
    'LM-X510!',
    'LM-Y110!'
  ],
  '@LO': ['LogicPD Zoom2', '(HUAWEI )?(ALP|BLA|CRR|LON|MATE|MHA|MT1|MT2|MT7|M200|NXT|Z100)!!', 'Loox'],
  '@LS': [
    'LS670',
    'LS740',
    'LS-4001',
    'LS-4002',
    'LS-4003',
    'LS-4004',
    'LS-4005',
    'LS-4006',
    'LS-4008',
    'LS-4503',
    'LS-4505',
    'LS-5002',
    'LS-5004',
    'LS-5005',
    'LS-5006',
    'LS-5007',
    'LS-5008',
    'LS-5009',
    'LS-5010',
    'LS-5013',
    'LS-5014',
    'LS-5015',
    'LS-5016',
    'LS-5017',
    'LS-5018',
    'LS-5020',
    'LS-5021',
    'LS-5201',
    'LS-5501',
    'LS-5502',
    'LS-5503',
    'LS-5504',
    'LS-5505',
    'LS-5506',
    'LS-5507',
    'LS-6001'
  ],
  '@LT': ['LT[0-9]{4,4}!!', 'LTB-HS', 'LT-TLA', 'LT-NA7', 'LT-NA7F', '(SNM\\-)?LT[0-9]{2,2}[a-z]?!!'],
  '@LU': [
    'LUXURY',
    'LUXURY 3',
    'LUXURY 4',
    'LUXURY 5',
    '(HW-|HUAWEI )?(CRO|LUA|CUN|SCC|SCU|CAM|LDN|LYO|MYA)!!',
    'Lucky Ultra Sonic U8650',
    'LU2300',
    'Lumia800',
    'Lumia 900',
    'Luna TAB07-920N',
    'Luna TAB07-100',
    'Luna TAB07-101',
    'Luna TAB274',
    'Luna TAB374',
    'Luna TAB474',
    'Luna TAB10-150',
    'Luno'
  ],
  '@LY': ['(HW-|HUAWEI )?(CRO|LUA|CUN|SCC|SCU|CAM|LDN|LYO|MYA)!!', 'LYF LS-4006', 'LYF LS-5009'],
  '@M': ['(DNS )?(Airtab )?(E|ES|M|MA|MC|MF|MW|P|PC|PF)[0-9]{2,4}!!'],
  '@M ': ['M POP 5020A', 'M POP'],
  '@M-': ['M-270', 'M-PAD N8'],
  '@M0': ['M01', 'M02', 'M01T', 'M009F', 'M030', 'M031', 'M032', 'M040', 'M045'],
  '@M1': [
    'M19',
    '(HW-|HUAWEI )?(ALE|ANE|D2|DAV|EML|EVA|FIG|G6|G7|GRA|M100|P2|P6|P7|PRA|RIO|SC|Sophia|VIE|VKY|VNS|VTR|WAS)!!',
    'M1050S',
    'M1',
    'm1 metal',
    'm1 note',
    'M1001',
    'M12'
  ],
  '@M2': ['(HUAWEI )?(ALP|BLA|CRR|LON|MATE|MHA|MT1|MT2|MT7|M200|NXT|Z100)!!', 'M210', 'm2 note', 'm2', 'M2mini'],
  '@M3': [
    'M3 Enjoy TV Box',
    'M3-2200',
    'M305',
    'M350',
    'M363',
    'M310',
    'M370i',
    'm3 note',
    'm3',
    'M3s',
    'M351',
    'M353',
    'M355',
    'M356'
  ],
  '@M4': ['M4301', 'M470BSA', 'M470BSE', 'M4', 'M4(TEL)? SS[0-9]{3,4}!!'],
  '@M5': ['M555', 'M532', 'M5 lite', 'M571C', 'M5 Note', 'M578C', 'M5'],
  '@M6': ['M623C', 'M650', 'M660', 'M6 Note', 'M6'],
  '@M7': ['M701C', 'M702', 'M758A', 'M7CDTU', 'M70', 'M785', 'M726HC', 'M70014'],
  '@M8': ['M801', 'M8047IU', 'M812C', 'm8wl', 'M860', 'M865', 'M886', 'M8', 'M8 pro'],
  '@M9': ['M975', 'M9300', 'M9', 'M9-unlocked', 'M9 pro', 'M9000'],
  '@MA': [
    'Maguro',
    'Mako',
    'manta',
    '(bq|Aquaris|Edison|Maxwell)!!',
    '(DNS )?(Airtab )?(E|ES|M|MA|MC|MF|MW|P|PC|PF)[0-9]{2,4}!!',
    '(HUAWEI )?(ALP|BLA|CRR|LON|MATE|MHA|MT1|MT2|MT7|M200|NXT|Z100)!!',
    'MAX FIND 5.0',
    'Malata!!',
    'Masstel!!',
    'MASTONE!!',
    'Maxtron!!',
    'magi',
    'MagicBox',
    '(Xiaomi )?(MI )?MAX$!',
    '(Xiaomi )?(MI )?MAX 2$!',
    'markf',
    'markw'
  ],
  '@MB': [
    'MBX DVBT reference board (c03ref)',
    'MBX Dongle board!',
    'MBX reference board!',
    '(NMP|MBR|XDK|XDS|XMP)\\-!!',
    'MBS BEAN 454',
    'MB[0-9]{3,3}!!'
  ],
  '@MC': ['MC002', '(DNS )?(Airtab )?(E|ES|M|MA|MC|MF|MW|P|PC|PF)[0-9]{2,4}!!', 'MC32N0', 'MC40N0', 'MC67NA'],
  '@MD': ['(MEDION|(MD )?LIFETAB)!!', 'MD-[0-9]{4,4}!!'],
  '@ME': [
    'ME102A',
    'ME180A',
    'ME171',
    'ME172V',
    'ME173X',
    'ME301T',
    'ME302C',
    'ME302KL',
    'ME370T',
    'ME371MG',
    'ME372CG',
    'ME372CL-FF',
    'ME560CG',
    'ME581CL',
    'MeMO Pad 7',
    'MediaPad!!',
    'Mediacom 810C',
    '(MEDION|(MD )?LIFETAB)!!',
    'MEEG!!',
    'MEIZU E3',
    'meizu m1note',
    'MEIZU M5',
    'MEIZU M9',
    'MEIZU MX',
    'Meizu S6',
    '(MEO )?Smart A!!',
    'MEU AN!!',
    'ME[0-9]{3,3}!!',
    'MEM02',
    'MegaFon SP-AI',
    'MegaFon SP-A3',
    'MegaFon SP-A5',
    'MegaFon SP-A10',
    'MegaFon V9',
    'MegaFon V9+',
    'MegaFon SIM+',
    'MegaFon Login 3'
  ],
  '@MF': [
    'mfld (dv10|dv20|gi|lw00|pr2|pr3)!',
    '(DNS )?(Airtab )?(E|ES|M|MA|MC|MF|MW|P|PC|PF)[0-9]{2,4}!!',
    'MFC[0-9]!!',
    'MF97B'
  ],
  '@MH': ['MH350', '(HUAWEI )?(ALP|BLA|CRR|LON|MATE|MHA|MT1|MT2|MT7|M200|NXT|Z100)!!'],
  '@MI': [
    'MID1040C',
    'MID[0-9]{4,4}!!',
    'Mini 3iG',
    'MINT-DG330',
    'MID1018',
    'MID1028',
    'MID Ser(ai|ia)ls!',
    'MIUI.us Sensation 4G',
    'MID[0-9]!!',
    'Mi-A402',
    'Micromax!!',
    'Mio!!',
    'MITO!!',
    'MIZ Z2',
    'Milestone XT711',
    'Milestone XT720',
    'Milestone',
    'Milestone X',
    'Milestone X2',
    'Milestone MAXX',
    'MILESTONE3',
    'MID7C',
    'MID43C',
    'MID74C',
    'MID77C',
    'MID82C',
    'MID84C',
    'MID102C',
    'MID103C',
    'MID104C',
    'MID114C',
    'MID[C012]!!',
    'Mi438S',
    '(CSL[- ])?(Spice[- ]?)?Mi(-| )?[0-9]{3,3}!!',
    'miTab!!',
    '(Xiaomi )?(Xiaomi|Xiaomi M|MI)!!',
    '(Xiaomi|Xiaomi Mi|MI) Note!!',
    '(Xiaomi )?(MI )?MAX$!',
    '(Xiaomi )?(MI )?MAX 2$!',
    '(Xiaomi )?(MI )?MIX$!',
    '(Xiaomi )?(MI )?MIX 2$!',
    '(Xiaomi )?(MI )?MIX 2S$!',
    'mido',
    '(Xiaomi|Xiaomi Mi|MI) Pad!!',
    '(Xiaomi|Xiaomi Mi|MI)Box!!',
    '(Xiaomi|Xiaomi Mi|MI)TV!!',
    '(ZTE )?(Grand|Mimosa)!!'
  ],
  '@MK': ['MK808', 'MK808B', 'MK809', 'MK809B', 'MK809IV', 'MK818B', 'MK908', 'MK908II', 'MK16(a|i|$)!'],
  '@ML': [
    '(HW-|HUAWEI )?MLA-(L01|L03|L11|L12|L13)!',
    '(HW-|HUAWEI )?MLA-(AL00|AL10)!',
    '(HW-|HUAWEI )?MLA-(TL00|TL10|UL00)!',
    'MLLED!!'
  ],
  '@MM': ['MM-3201'],
  '@MO': [
    'Moto E',
    'Moto G',
    'Moto G LTE',
    'Moto G 2014',
    'Moto G 2014 LTE',
    'Moto G (2014)',
    'Moto X',
    'Moto 360',
    'Mobile Sosh',
    'Monterra',
    'Mobiistar!!',
    'MOCHE SMART A16',
    '(MODECOM )?FreeTAB!!',
    'MOGU!!',
    'moii!!',
    'MORAL N01',
    'Moto Droid',
    'Motorola Pro XT610',
    'Motorola Milestone MAXX',
    'Motorola Backflip Me600',
    'Moto ME860',
    'Moto C',
    'Moto C Plus',
    '(Moto)?E2$!',
    '(Moto)?E2\\(4G-LTE\\)$!',
    'Motorola MotoE2!',
    'Moto E (4)',
    'Moto E (4) Plus',
    'moto e5 cruise',
    '(Moto)?G3$!',
    '(Moto)?G3-TE$!',
    'MOTOROLA MOTOG',
    'Moto G Play',
    'Moto G4',
    'Moto G (4)',
    'Moto G4 Plus',
    'Moto G (5)',
    'Moto G (5) Plus',
    'Moto G (5S) Plus',
    'moto g(6)',
    'moto g(6) plus',
    'Moto Z (2)',
    'Moto Z2 Play',
    'Moto X Pro',
    'moto x4',
    'Moto Backflip',
    'MOTOROLA XOOM MZ606',
    'MOTOROLA RAZR',
    'MOTWX435KT',
    '(PLOYER-)?MOMO!!',
    'MOB-5045',
    'Mobii 7',
    'MoFing',
    'mocha',
    'MO-01J',
    'MO-01K',
    'Movistar Express',
    'Movistar Link',
    'Movistar Motion',
    'Movistar Prime',
    'MOVE'
  ],
  '@MP': [
    'MP[0-9]{3,3}C!!',
    'MP717',
    'MP843',
    'MP888',
    'MP959',
    'MP969',
    'MP1010',
    'MP7007',
    'MPDC100 BT',
    'MPDC110 BT IPS',
    'MPDC112 BT IPS',
    'MPDC8 BT',
    'MPDC88 BT IPS',
    'MPDC706',
    'MPDC903',
    'MPQC704 HD',
    'MPQC784 IPS',
    'MPQC804HD',
    'MPQC1010'
  ],
  '@MS': [
    'MStar Amber3',
    'MSM',
    'msm(7227|7627)!',
    'msm7630!',
    'msm8660!',
    'msm(8x25|8625|8960)!',
    'msm8x30!',
    'msm8610!',
    'msm8909!',
    'msm(8226|8228)!',
    'MSM8926!',
    'msm8916!',
    'msm8952!',
    'msm8974!',
    'MSM8992!',
    'msm8994!',
    'MS840 4G',
    'MS3B',
    'MS4A',
    'MS3A'
  ],
  '@MT': [
    'mt5396!',
    'mt5399!',
    'mt5861!',
    'mt5880!',
    'mt5882!',
    'mt5890!',
    'mt6515!',
    'MTK6515',
    'mt6517!',
    'mt6571!',
    'mt6572!',
    'mt6575!',
    'mt6577!',
    'mt6582!',
    'mt6589!',
    'MTK-MT6589',
    'MTK6589!',
    'mt6592!',
    'MTK-MT6592',
    'MTK6592',
    'mt6595!',
    'mt6599!',
    'mt8125!',
    'mt8127!',
    'mt8135!',
    'MTK--8312',
    'mt8377!',
    'mt8389!',
    'mt8580!',
    'mt8658!',
    '(AC|BC|LC|MT|RC|QS|VM|TS|OC)[0-9]{4,4}[A-Z]!!',
    '(HUAWEI )?(ALP|BLA|CRR|LON|MATE|MHA|MT1|MT2|MT7|M200|NXT|Z100)!!',
    'MTC Android',
    'MT791',
    'MT70[0-9]{2,2}!!',
    'MTK6516',
    'MT[0-9]{3,3}!!',
    'MTS-SP100',
    'MTS-SP101',
    'MT[0-9]{2,2}[a-z]!!',
    'MT7A',
    'MTC!!'
  ],
  '@MU': ['muPAD 7M', 'Multilaser Diamond', 'Multilaser Orion', 'Multilaser Oxy', 'Multilaser Titanium'],
  '@MW': [
    'MWND1',
    'mw07',
    'MW0710',
    'MW0711',
    'MW0712',
    'MW0731',
    'MW0731PLUS',
    'MW0733',
    'MW0811',
    'MW0812',
    'MW0812 V2.0',
    'MW0821',
    'MW0821 V2.0',
    'MW0821+',
    'MW0831',
    'MW0831Plus',
    'MW0922',
    'MW0931',
    '(DNS )?(Airtab )?(E|ES|M|MA|MC|MF|MW|P|PC|PF)[0-9]{2,4}!!',
    'MW1031'
  ],
  '@MX': ['MX Enjoy TV BOX', 'MX2', 'MX4', 'MX4 Pro', 'MX5', 'MX6'],
  '@MY': [
    '(HW-|HUAWEI )?(CRO|LUA|CUN|SCC|SCU|CAM|LDN|LYO|MYA)!!',
    'MyPhone A818g Duo',
    'MyPhone A818 Slim Duo',
    'MyPhone A848 Duo',
    'MyPhone A848i Duo',
    'MyPhone A848g Duo',
    'MyPhone A888',
    'MyPhone A888 Duo',
    'My|Phone A888 Duo',
    'MyPhone A919 Duo',
    'MyPhone A919 3D Duo',
    'MyPhone A919i',
    'MyPhone A919i Duo',
    'MyPhone Agua Cyclone',
    'MyPhone Agua Hail',
    'MyPhone Agua Iceberg',
    'MyPhone Agua Iceberg Mini',
    'MyPhone Agua Iceberg Slim',
    'MyPhone Agua Infinity',
    'MyPhone Agua Ocean Lite',
    'MyPhone Agua Ocean Mini',
    'MyPhone Agua Ocean Pro',
    'MyPhone Agua Rain 2G',
    'MyPhone Agua Rain 3G',
    'MyPhone Agua Rio',
    'MyPhone Agua Rio Fun',
    'MyPhone Agua Rio Lite',
    'MyPhone Agua Storm',
    'MyPhone Agua Vortex',
    'myPhone C Smart',
    'myPhone Cube',
    'myPhone Cube 16GB',
    'myPhone Duosmart',
    'myPhone FUN 2',
    'myPhone Funky',
    'myPhone Hammer',
    'myPhone INFINITY 3G',
    'myPhone NEXT',
    'myPhone NEXTS',
    'myPhone NEXT S',
    'myPhone Smart',
    'myPhone S-line',
    'MyPhone Rio Craze',
    'MyPhone Rio Grande',
    'MyPhone Rio Junior TV',
    'MyPhone Rio 2',
    'MyPhone Rio 2 Fun',
    'MyPhone UNO',
    'MyPhone Xperia Rain 3G',
    'Myphone MY25',
    'MyPhone MY26',
    'MyPhone MY28S',
    'MyPad 2',
    'MyPad 750HD',
    'MyPad 1000 HD',
    'MY ?SAGA!!',
    'My ?Touch ?4G$!',
    'myTouch 4G Slide',
    'myTouch Slide 4G'
  ],
  '@MZ': [
    'MZ-m2 note',
    'MZ-M571C',
    'MZ-m3 note',
    'MZ-M5',
    'MZ-MEIZU M6',
    'MZ-MX4',
    'MZ-MX4 Pro',
    'MZ-MX5',
    'MZ[0-9]{3,3}!!'
  ],
  '@N-': ['N-0[0-9][A-Z]!!'],
  '@N1': ['N1', 'N12', 'N12R', 'N101 DUAL CORE!'],
  '@N2': ['N2T'],
  '@N3': ['N3-2200', 'N320'],
  '@N5': ['N51(10|11|16|17)!', 'N52(06|07|09)!', 'N5PRO2jingying', 'N50', 'N50DT!', 'N50GT', 'N50GT A'],
  '@N6': ['N612', 'N6'],
  '@N7': [
    'N700',
    'N710',
    'N70',
    'N70 3G',
    'N70 C',
    'N70DC',
    'N70-S',
    'N70HD',
    'N70 DUAL CORE',
    'N70DC-S',
    'N70DC-T'
  ],
  '@N8': ['N8730-411', 'N8730-41101', 'N8730-41102', 'N80($| from moage.com)!', 'N80DC', 'N80IPS', 'N861'],
  '@N9': ['N930', 'N9600', 'N90', 'N90 DUAL CORE!', 'N90FHDRK', 'N918St'],
  '@NA': [
    'NABI!!',
    'NaviPad TM-7055HD 3G',
    'NaviPad TM-7855 3G',
    'NaviPad TM-7858 3G (revision 1)',
    'natrium',
    'NATCOM N8302'
  ],
  '@NB': ['NB036', 'NBX-T7013N', 'NBX-T7023N'],
  '@NC': ['(HW-|HUAWEI )?(DRA|FLA|TIT|TAG|NCE|TRT|SLA)!!'],
  '@NE': [
    '(HTC )?Nexus ?One!',
    '(Google )?Nexus S!',
    '(Google )?Nexus ?4!',
    'Nexus 5X',
    '(Google )?Nexus ?5!',
    'Nexus 6P',
    '(Google )?Nexus ?6P!',
    '(Google )?Nexus ?6!',
    '(Google )?Nexus ?7 2013!',
    '(Google )?Nexus ?7!',
    '(Google )?Nexus ?9!',
    '(Google )?Nexus ?10!',
    'Nexus Player',
    'NEO-G4',
    'NEO-G4-108A',
    'NEO-G4 a',
    'NEO-U9-H',
    'NEO-X5',
    'NEO X5',
    'Neo-X5-B',
    'NEO-X5-116A',
    'NEO-X5-mini',
    'NEO X5 mini',
    'NEO-X6',
    'NEO-X7-216A',
    'NEO-X7-mini',
    'NEO-X8',
    'NEO-X8-H',
    'NEO-X8H-PLUS',
    'Neon',
    '(BLU|DASH|LIFE|NEO|STUDIO|VIVO)!!',
    'NexusHD2',
    'Nexus HD2',
    '(HW-|HUAWEI |HONOR )?(ATH|BLN|BKL|BND|CHE|CHM|COL|DUA|DUK|DLI|EDI|FRD|HN3|H30|H60|HOL|JMM|KIW|LLD|NEM|NMO|PE|PLK|RNE|SCL|KNT|CAM|STF|HDN)!!',
    'Neon7',
    'Neon9',
    '(NetTab|NT-)!!',
    'Newman K1',
    'NewmanK1',
    'Newman K2',
    'Newman N1',
    'Newman N2!',
    'Newman-N2!',
    'Newpad',
    'Newpad-K97',
    'Newpad-NP900',
    'Newpad P9',
    'Newpad P72',
    'Newsmy P72',
    'Newsmy P72-C',
    'Newsmy T3',
    'Newsmy T7II',
    'NEC-STR',
    'NEC-0912',
    'NEC-101S',
    'NECTEL-101S',
    'NEC-101T',
    'NEC-101TH',
    'NEC-102',
    'NE-103T',
    'NEC909e',
    'NE-202',
    'NE-201A1A',
    'NEC-NE-201A1A',
    'NEC-NEC-NE-201A1A',
    'NEC PC-TE508S1',
    'neken!!',
    'NEO!!',
    '(Nexian )?NX-A[0-9]{3,3}!!',
    'Nextbook Premium 7',
    'Next7C12!',
    'Next7D12!',
    'Next7P12!',
    'Next7Q12!',
    'Next7P',
    'Next7S',
    'Nextbook Premium 7 SE',
    'NEXT8P',
    'Next8P11',
    'Next8P12',
    'Next9P',
    'Next10P12',
    'NEXT',
    'New Andromax-i',
    'Neo V',
    'NEBULA6.9'
  ],
  '@NG': [
    'NGM Black Hole',
    'NGM Dynamic Racing 2',
    'NGM Dynamic Racing 3',
    'NGM Dynamic Star',
    'NGM Dynamic Stylo',
    'NGM Forward Infinity',
    'NGM Forward Racing HD',
    'NGM Forward Young',
    'NGM Harley',
    'NGM Orion',
    'NGM Spirit',
    'NGM Time',
    'NGM Vanity Smart',
    'NGM Action',
    'NGM Legend',
    'NGM-Legend/Legend',
    'NGM Legend2',
    'NGM LegendXL',
    'NGM Miracle',
    'NGM P0laris',
    'NGM Wilco',
    'NGM WINN'
  ],
  '@NI': ['NITROGEN6X', 'NID 7010', 'Nibiru H1', 'Nibiru H1c', 'nine i7400', 'nikeh', 'nikel'],
  '@NM': [
    '(HW-|HUAWEI |HONOR )?(ATH|BLN|BKL|BND|CHE|CHM|COL|DUA|DUK|DLI|EDI|FRD|HN3|H30|H60|HOL|JMM|KIW|LLD|NEM|NMO|PE|PLK|RNE|SCL|KNT|CAM|STF|HDN)!!',
    '(NMP|MBR|XDK|XDS|XMP)\\-!!'
  ],
  '@NO': [
    'Novo7',
    'Novo7 -?Aurora!',
    'novo Aurora',
    'Novo 7 Aurora',
    'Novo7 Advanced',
    'Novo7Advanced!',
    'Novo7 Advanced2',
    'Novo7 Basic',
    'NovoCrystal',
    'Novo 7 Crystal!',
    'Novo7 ELF',
    'Novo7 Fire',
    'Novo7 Flame',
    'Novo7 Grace',
    'Novo7 Legend',
    'novo7Legend!',
    'NOVO7 Mars',
    'Novo7 PALADIN',
    'Novo7 Rainbow',
    'Novo7 -Rainbow',
    'NOVO7 Tornados',
    'Novo7 Venus',
    'Novo 7 Venus',
    'Novo7 Venus QuadCore',
    'Novo 7 Venus QuadCore',
    'Novo8 Advanced',
    'Novo8 Discover Quadcore',
    'Novo8 Disover Quadcore',
    'Novo8 Dream QuadCore',
    'Novo8mini',
    'novo9-Spark',
    'NOVO9 Spark II',
    'Novo 10 Hero',
    'Novo10 ?Hero!',
    'Novo 10 Hero QuadCore',
    'Novo Captain',
    'Novo10 captain QuadCore',
    'NOOK',
    'Nook ?Color!',
    '(NOOK )?BNRV(200|300)!',
    'Nook ?Tablet!',
    'NOOK Slate',
    '(NOOK )?BNTV250!',
    '(NOOK )?BNRV350!',
    '(NOOK )?BNTV(400)!',
    '(NOOK )?BNTV(450)!',
    '(NOOK )?BNTV(600)!',
    '(NOOK )?BNTV(800)!',
    'Nook HD',
    'Nook HD+',
    'Novapad!!',
    'Nova!!',
    'Now',
    'NO1 S6',
    'NOAIN!!',
    'Nokia 1 Plus',
    'Nokia 1',
    'Nokia 2.1',
    'Nokia 2',
    'Nokia 3.1 Plus',
    'Nokia 3.1',
    'Nokia 4.2',
    'Nokia 5.1 Plus',
    'Nokia 5.1',
    'Nokia 6.1 Plus',
    'Nokia 6.1',
    'Nokia 6.2',
    'Nokia 6',
    'Nokia 7.1',
    'Nokia 7 Plus',
    'Nokia 8.1',
    'Nokia 8 Sirocco',
    'Nokia 8',
    'Nokia 9',
    'Nokia 10.1',
    'Nokia N9',
    'Nokia N900',
    'Nokia X',
    'Nokia X Dual SIM',
    'Nokia X+',
    'Nokia Xplus',
    'Nokia XL 4G',
    'Nokia XL',
    'Nokia XL Dual SIM',
    'Nokia X2',
    'NokiaX2DS',
    'Notion Ink ADAM',
    'Note III',
    'Nozomi',
    'Noble TAB07-485',
    '(QMobile|QTab|Q-Smart|Noir)!!'
  ],
  '@NP': ['npm702-NOVO7PALADIN'],
  '@NS': ['NS115', 'NS2816', 'NS-14T002', 'NS-13T001', 'NSZ-G[A-Z][0-9]!!'],
  '@NT': ['(NetTab|NT-)!!'],
  '@NU': ['Numy!!', 'nuvi!!', 'NUU A3', 'NuclearSX-SP5', 'nubia Z5', 'Nubia Z9 Max', 'Nura 2'],
  '@NW': ['NWZ?-Z1000Series!'],
  '@NX': [
    '(HUAWEI )?(ALP|BLA|CRR|LON|MATE|MHA|MT1|MT2|MT7|M200|NXT|Z100)!!',
    '(Nexian )?NX-A[0-9]{3,3}!!',
    'NXA8QC116',
    'NX16A8116K',
    'NXM726',
    'NXM726HN',
    'NXM726HN C030',
    'NXM726HN HASTINGS',
    'NXM727KC!',
    'NXM803HC',
    'NXM803HD',
    'NX868QW8G',
    'NXM805ND',
    'NXM805ND EN',
    'NXM908HC',
    'NXM703U',
    'NXM901',
    'NXM736',
    'NX700QC',
    'NX785QC8G',
    'NXM900MC',
    '(ZXY-)?NX[0-9]{2,3}!!'
  ],
  '@NY': ['NYX!!'],
  '@O2': ['O2 Joggler'],
  '@OB': ['OB-OPPO A31c', 'OB-OPPO 3005', 'Obreey SURFpad'],
  '@OC': ['(AC|BC|LC|MT|RC|QS|VM|TS|OC)[0-9]{4,4}[A-Z]!!'],
  '@OD': [
    'odroida',
    'ODROID-A',
    'ODROIDC',
    'ODROIDC2',
    'ODROID-U',
    'ODROID-U2',
    'ODROID-X',
    'ODROID-XU',
    'ODROID-XU3',
    'ODROID-XU3-ATV',
    'ODROID-XU4',
    'ODROID-X2',
    'ODYS-Chrono',
    'ODYS-EVO',
    'Odys-Loox',
    'ODYS-NOON',
    'ODYS-Q',
    'ODYS Space',
    'ODYS Space TKI BRR233v7',
    'ODYS Space TKI BRR233v9',
    'ODYS-Xpress',
    'ODYS Xtreme',
    'OD103'
  ],
  '@OL': ['Olivetti Olipad 100'],
  '@OM': [
    'Omap5panda',
    'OMAP',
    'OMAP SS',
    'omap3evm',
    'OMAP3ETPP',
    'Omap5sevm',
    'OMS TTD',
    'OMS1 6',
    'omega',
    'Omega 5.0',
    'Omega 5.5'
  ],
  '@ON': [
    'One 7 M77GHG',
    'OnePAD 785I',
    'OnePAD 900HD',
    'OnePAD 970',
    'OnePAD 1100x2',
    'ONETOUCH Flash Plus',
    'one touch 890!',
    'one touch 891!',
    'one touch 900!',
    'one touch 903!',
    'one touch 906!',
    'one touch 908!',
    'one touch 909!',
    'one touch 910!',
    'one touch 913!',
    'one touch 916!',
    'one touch 918!',
    'one touch 922!',
    'one touch 927!',
    'one touch 928!',
    'one touch 930!',
    'one touch 960!',
    'one touch 976!',
    'one touch 978!',
    'one touch 979 HelloKitty',
    'one touch 979!',
    'one touch 980!',
    'one touch 981!',
    'one touch 983!',
    'one touch 985!',
    'one touch 986!',
    'one touch 988!',
    'one touch 990!',
    'one touch 991!',
    'one touch 992!',
    'ONE TOCH 992D',
    'one touch 993!',
    'one touch 995!',
    'one touch 997!',
    'one touch 998!',
    'one touch D662',
    'one touch D668',
    'one touch D820',
    'one touch D920',
    'one touch J320',
    'one ?touch 40(05|10|11)!',
    'one ?touch 4007!',
    'one ?touch 4008!',
    'one ?touch 4009!',
    'one ?touch 4013!',
    'one ?touch 4014!',
    'one ?touch 40(15|16)!',
    'one ?touch 4024!',
    'one ?touch 4027!',
    'one ?touch 4029!',
    'one ?touch 4030!',
    'one ?touch 4031!',
    'one ?touch 4032!',
    'one ?touch 4033!',
    'ONETOUCH POPC3',
    'one ?touch 40(35|36|37)!',
    'one ?touch 5045!',
    'one ?touch 5020!',
    'one ?touch 5021!',
    'one ?touch 5035!',
    'one ?touch 50(36|37)!',
    'ONETOUCH POPC5',
    'one ?touch 50(38)!',
    'one ?touch 5042!',
    'one ?touch 5050!',
    'one ?touch 6010!',
    'one ?touch 6012!',
    'ONE TOUCH IDOL MINI',
    'one ?touch 6014!',
    'one ?touch 6016!',
    'one ?touch 6030!',
    'one ?touch 6032!',
    'one ?touch 6033!',
    'one ?touch 60(34|35)!',
    'one ?touch 6036!',
    'one ?touch 6037!',
    'one ?touch 6039!',
    'one ?touch 6040!',
    'one ?touch 6043!',
    'one ?touch 6045!',
    'one ?touch 6050!',
    'one ?touch 7024!',
    'one touch fierce!',
    'one ?touch 70(25|30)!',
    'one ?touch 70(40|41)!',
    'one ?touch 7042!',
    'one ?touch 7043!',
    'one ?touch 7044!',
    'one ?touch 7045!',
    'one ?touch 7047!',
    'one ?touch 7050!',
    'one ?touch 8000!',
    'one ?touch 8008!',
    'one ?touch 8020!',
    'one ?touch 8030!',
    'one ?touch T10!',
    'one ?touch T20!',
    'one ?touch T60!',
    'ONE TOUCH TAB 7',
    'ONE TOUCH TAB 7HD',
    'ONE TOUCH TAB 8HD',
    'ONE TOUCH EVO7',
    'onetouch EVO7',
    'ONE TOUCH E710',
    'ONE TOUCH EVO 7HD',
    'ONE TOUCH EVO7HD',
    'ONE TOUCH EVO8HD',
    'ONETOUCH POP 7 LTE',
    'ONE ?TOUCH P310(A|X)!',
    'ONE ?TOUCH P320(A|X)!',
    'ONE ?TOUCH P321!',
    'ONE ?TOUCH POP 8S P350X!',
    'One S',
    'One X',
    'One X+',
    'One XL',
    'One V',
    'One',
    'One M7',
    'one m8',
    'One A0001',
    'OnePlus One',
    'OnePlus One A0001',
    'ONE A2001',
    'ONE A2003',
    'ONE A2005',
    'OnePlus2',
    'ONE A3000',
    'ONE A3003',
    'ONEPLUS A3000',
    'ONEPLUS A3003',
    'OnePlus3',
    'ONEPLUS A3010',
    'ONEPLUS A5000',
    'ONEPLUS A5010',
    'ONEPLUS A6000',
    'ONE E1000',
    'ONE E1001',
    'ONE E1003',
    'ONE E1005',
    'ONDA MID',
    'ONDA A9 Core4',
    'ONDA VI10',
    'Onda V812',
    'ONDA v975m',
    'ONDA V989',
    'ONDA V989 Core8'
  ],
  '@OP': [
    'OPPOLenovo A60',
    'Optimus!!',
    'Opus One',
    'OPS-DRD Digital Signage Player',
    'OP110',
    'OPPO A30',
    'OPPO A31',
    'OPPO A31t',
    'OPPO A33',
    'OPPO A33m',
    'OPPO A37m',
    'OPPO A53',
    'OPPO A53m',
    'OPPO A57',
    'OPPO A57t',
    'OPPO A59m',
    'OPPO A59s',
    'OPPO A59st',
    'OPPO A77',
    'OPPO A77t',
    'OPPO A800',
    'OPPOX905',
    'OPPOX907',
    'OPPO Find5',
    'OPPOX909',
    'OPPO X909',
    'OPPOX9015',
    'OPPOX9017',
    'OPPO find7',
    'OPPOR601',
    'OPPOR801',
    'OPPOR803',
    'OPPOR805',
    'OPPOR807',
    'OPPO R811',
    'OPPO R813T',
    'OPPO R815',
    'OPPOR817',
    'Oppo R819',
    'OPPO R821',
    'OPPO R831',
    'Oppo R831 Limited Edition',
    'OPPO R1001',
    'OPPOR8015',
    'OPPOR8111',
    'OPPOT29',
    '(OPPO-?)?T703!',
    'OPPOU701',
    'OPPOU7011',
    'OPPOU7015',
    'OPPO N1',
    'OPPO R7',
    'OPPO R7s',
    'OPPO R7sm',
    'OPPO R7st',
    'OPPO R7t',
    'OPPO R9m',
    'OPPO R9tm',
    'OPPO R9km',
    'OPPO R9s',
    'OPPO R9sk',
    'OPPO R9st',
    'OPPO R9t',
    'OPPO R11',
    'OPPO R11t',
    'OPPO R7 Plus',
    'OPPO R7sPlus',
    'OPPO R9 Plusm A',
    'OPPO R9 Plustm A',
    'OPPO R9s Plus',
    'OPPO R11 Plus',
    'OPPO R11 Plusk',
    'OPPO R11 Pluskt',
    'OPPO R11s Plus',
    'OPSSON!!',
    'OP0118-12',
    'Optimus Barcelona',
    'Optimus Boston',
    'Optimus Madrid',
    'Optimus Monte Carlo',
    'Optimus San Francisco',
    'Optimus San Remo',
    'Optimus Zali'
  ],
  '@OR': [
    'Orange HUAWEI GRA-L09',
    'Orbis',
    'Orange Boston',
    'Orange Covo',
    'Orange Daytona',
    'Orange Dublin',
    'Orange Fova',
    'Orange Gova',
    'Orange Hi 4G',
    'Orange Hiro',
    'Orange infinity 996',
    'Orange Infinity 8008X',
    'Orange Kivo',
    'Orange Monte Carlo',
    'Orange Neva 80',
    'Orange Niva',
    'Orange Nura',
    'Orange Novi',
    'Orange Reyo',
    'Orange Rise 30',
    'Orange Rono',
    'Orange Roya',
    'Orange Runo',
    'Orange San Francisco',
    'Orange Sego',
    'Orange Tactile internet 2',
    'Orange Tado',
    'Orange Yomi',
    'Orange Yumo',
    'Orange Zali'
  ],
  '@OT': ['OT 918', 'OT 919', 'OT 919 HelloKitty', 'OT-990C', 'OT 990M', 'OT-995'],
  '@OU': ['OUYA( Console)?!'],
  '@OV': ['(OV-|Overmax|Vertis)!!'],
  '@OY': [
    'Oysters Pacific 800',
    'Oysters T3 3G',
    'Oysters T7B 3G',
    'Oysters T7X 3G',
    'OYSTERS T14N 3G',
    'Oysters T37',
    'Oysters T72H 3G',
    'Oysters T72HRi 3G',
    'OYSTERS T80 3G'
  ],
  '@OZ': ['OZZY'],
  '@P': ['(DNS )?(Airtab )?(E|ES|M|MA|MC|MF|MW|P|PC|PF)[0-9]{2,4}!!'],
  '@P-': ['P-0[0-9][A-Z]!!'],
  '@P0': [
    'P001',
    'P001 2',
    'P002',
    'P00C',
    'P00I',
    'P01M',
    'P01MA',
    'P01T',
    'P01T 1',
    'P01V',
    'P01W',
    'P01Y',
    'P01Z',
    'P021',
    'P022',
    'P023',
    'P024'
  ],
  '@P1': [
    'P10AN',
    'P105',
    'P1m',
    'P1ma40',
    'P1050X',
    'P10HD??(E6NA)',
    'P11HD',
    'P11HD四核(G9X6)',
    'P11HD??(G9X6)',
    'P11HD四核(G9X7)',
    'P19HD(E1K3)',
    'P19HD(E1K5)'
  ],
  '@P2': [
    'P2A700',
    'P2Lite',
    '(HW-|HUAWEI )?(ALE|ANE|D2|DAV|EML|EVA|FIG|G6|G7|GRA|M100|P2|P6|P7|PRA|RIO|SC|Sophia|VIE|VKY|VNS|VTR|WAS)!!'
  ],
  '@P3': ['P330X', 'P350X', 'P360X', 'P300(Funbook)'],
  '@P4': ['P4i', 'P4', 'P4D Sirius'],
  '@P5': ['P5 Energy', 'P5Life', 'P5Life TM', 'P5'],
  '@P6': [
    'P6 Energy',
    'P6 Energy TM',
    'P6 Pro',
    'P6 Qmax',
    'P6 Quad',
    '(HW-|HUAWEI )?(ALE|ANE|D2|DAV|EML|EVA|FIG|G6|G7|GRA|M100|P2|P6|P7|PRA|RIO|SC|Sophia|VIE|VKY|VNS|VTR|WAS)!!'
  ],
  '@P7': [
    '(HW-|HUAWEI )?(ALE|ANE|D2|DAV|EML|EVA|FIG|G6|G7|GRA|M100|P2|P6|P7|PRA|RIO|SC|Sophia|VIE|VKY|VNS|VTR|WAS)!!',
    'P700i',
    'P701',
    'P7',
    'P70 3G八核(C2B7)',
    'P70h(A5C2)',
    'P72',
    'P72w',
    'P75a(G7E3)',
    'P75HD(M3E5)',
    'P76a(K3G5)',
    'P76a双核(M4Q5)',
    'P76e(A3E1)',
    'P76e(G6R8)',
    'P76h双核(K8V1)',
    'P76s双核(DKH5)',
    'P76TI',
    'P76v(A3V5)',
    'P78双核(G1M5)',
    'P78s(G1M5)',
    'P78s(G1M6)',
    'P78s(G1M7)',
    'P78HD四核(C4A5)',
    'P78HD??(C4A5)',
    'P79HD(A3V9)',
    'P79HD 3G(C4K5)',
    'p7901a'
  ],
  '@P8': [
    'P8 Energy',
    'P8 Energy mini',
    'P8 Energy mini TM',
    'P80 四核 (BV8K)',
    'P80 四核 (BV9K)',
    'P80s 四核(EF6W)',
    'P80 3G四核 (B1KC)',
    'P80 3G四核 (B4KC)',
    'P80 3G八核(A4LL)',
    'P80 3G八核(A5LL)',
    'P80 3G八核(A6LL)',
    'P80 4G(K2G3)',
    'P81HD',
    'P85(A9D3)',
    'P85(A9D5)',
    'P85(R8A1)',
    'P85mini(DT8W)',
    'P85s mini(EWE8)',
    'P85t mini(KW8P)',
    'P85HD双核(K6N2)',
    'P86(F8G6)',
    'P88双核(H3D7)',
    'P88(H3D7)',
    'P88(GT4K)',
    'P88s mini??(F2V6)',
    'P88s mini四核(F2V7)',
    'P88HD(C5GV)',
    'P89 3G八核(D1H8)',
    'P89 3Gk8(D1H8)',
    'P89mini(E2W6)',
    'P89 mini(E2W6)',
    'P89s(F8A5)',
    'P89s mini(F8A2)'
  ],
  '@P9': [
    'P940',
    'P990',
    'P90(H3U6)',
    'P90(H3U7)',
    'P98(F2K9)',
    'P98 八核(B9A3)',
    'P98 3Gk8(A4HY)',
    'P98 3G??(A4HY)',
    'P98 3G(M1Q2)',
    'P98 3G八核(A3HY)',
    'P98 3G八核(A4HY)',
    'P98 4G??(A8H6)',
    'P98 Air?? (C6V8)',
    'P98Air(C6V8)',
    'P98HD(A2Q6)',
    'P98HD+M6',
    'P98T(K3C4)'
  ],
  '@PA': [
    'Panda(Board)?!',
    'Passion',
    '(Transformer )?(Pad )?TF300(T|TG|TL)!',
    '(Transformer )?(Pad )?TF502(T)!',
    '(Transformer )?(Pad )?TF700(T|K)!',
    'PadFone',
    'PadFone 2',
    'PadFone Infinity',
    'PadFone Infinity A86',
    'PadFone T004',
    'PadFone-T004',
    'PadFone T008',
    'PadFone T00C',
    'PadFone X',
    'PadFone X mini',
    'Patio100',
    'Patio100 3G',
    'PAD[0-9]{3,3}!!',
    'Panasonic!!',
    'pandigital9hr',
    'pandigital9hr2',
    'pandigitalopc1',
    'pandigitalopp1',
    'pandigitalp1hr',
    'PantechP!!',
    'PAT712W',
    'PATG7506HD',
    'PAP[0-9]{4,4}!!',
    'PAD1001'
  ],
  '@PB': ['PB99400'],
  '@PC': [
    'PC1038',
    '(DNS )?(Airtab )?(E|ES|M|MA|MC|MF|MW|P|PC|PF)[0-9]{2,4}!!',
    '(HTC|PCD|USCC)?ADR[0-9]{4,4}!!',
    'PC36100!',
    'PC-TE307N1W',
    'PC-TE508BAW',
    'PC-TS508FAM',
    'PC-TS508T1W',
    'PC-TS708T1W'
  ],
  '@PD': ['PD10-DYD', 'PD6D1J'],
  '@PE': [
    '(HW-|HUAWEI |HONOR )?(ATH|BLN|BKL|BND|CHE|CHM|COL|DUA|DUK|DLI|EDI|FRD|HN3|H30|H60|HOL|JMM|KIW|LLD|NEM|NMO|PE|PLK|RNE|SCL|KNT|CAM|STF|HDN)!!',
    'PEDI',
    'Penta!!',
    'Pentagram!!',
    'pepper'
  ],
  '@PF': ['(DNS )?(Airtab )?(E|ES|M|MA|MC|MF|MW|P|PC|PF)[0-9]{2,4}!!'],
  '@PG': ['PG06100', 'PG41200', 'PG86100!', 'PGM 398', 'PGPS7795'],
  '@PH': [
    'PH7M EU 5596',
    'PHA-3850',
    'PHA-3880',
    'PHA-4850',
    'PHA-5850',
    'PH-1',
    'photon',
    'PH44100',
    'Photon',
    'Photon 4G',
    'Photon Q',
    'Photon Q LTE',
    'PH350',
    'PH520',
    'PHICOMM!!',
    'Philips I908',
    'Philips I928',
    'Philips S301',
    'Philips S307',
    'Philips S308',
    'Philips S309',
    'Philips S316T',
    'Philips S326',
    'Philips S337',
    'Philips S358',
    'Philips S388!',
    'Philips S396',
    'Philips S398',
    'Philips S616',
    'Philips T3500',
    'Philips T3566',
    'Philips V377',
    'Philips V387',
    'Philips V526',
    'Philips V787',
    'Philips Xenium V787',
    'Philips X588',
    'Philips W336',
    'Philips W536',
    'Philips W626',
    'Philips W632',
    'Philips W635',
    'PhilipsW635',
    'Philips W737',
    'Philips W832',
    'Philips W3500',
    'Philips W3509',
    'Philips W3550',
    'Philips W3568',
    'Philips W6350',
    'PhilipsW6350',
    'Philips W6610',
    'Philips W6618',
    'Philips W7555',
    'Philips-W7555',
    'Philips-W8500',
    'Philips W8510',
    'Philips W8555',
    'Philips W8560',
    'Philips GoGear Connect',
    'Philips PI5000',
    'PHABLET 4S',
    'Phablet 4.5Q',
    'Phablet 5,3 Q'
  ],
  '@PI': [
    'Pixel C',
    'Pixel',
    'Pixel XL',
    'Pixel 2',
    'Pixel 2XL',
    'Pixel 2 XL',
    'Pixel 3',
    'Pixel 3 XL',
    'Pixel 3a',
    'Pixel 3a XL',
    '(Axioo[\\- ])?PICO!!',
    'picoBit-L',
    '(GIO-)?(GiONEE[- ])?Pioneer P1!',
    '(GIO-)?(GiONEE[- ])?Pioneer P2!',
    '(GIO-)?(GiONEE[- ])?Pioneer P3!',
    '(GIO-)?(GiONEE[- ])?Pioneer P4!',
    'PixelV1',
    'Pixel V2',
    'Pixel V2+',
    'PI2000',
    'PI2010',
    'PI2011',
    'PI3100',
    'PI3100-93',
    'PI3100Z3 93',
    'PI3105',
    'PI3106',
    'PI3110',
    'PI3205G',
    'PI3210G',
    'PI3900',
    'PI3900-93',
    'PI3910',
    'PI4010G',
    'PI7000',
    'PI7100 93',
    '(PNR-)?Pioneer!!',
    'PIRANHA!!'
  ],
  '@PJ': ['PJ83100', 'PJ35100'],
  '@PL': [
    'PLE-701L',
    'PLE-703L',
    '(HW-|HUAWEI |HONOR )?(ATH|BLN|BKL|BND|CHE|CHM|COL|DUA|DUK|DLI|EDI|FRD|HN3|H30|H60|HOL|JMM|KIW|LLD|NEM|NMO|PE|PLK|RNE|SCL|KNT|CAM|STF|HDN)!!',
    'Planet II v2',
    'PLANET',
    'Playboy PB-S3',
    '(PLOYER-)?MOMO!!',
    'PlayTabPro',
    'PLT!!',
    'PlayBook',
    'Plus E',
    'Play 6X-1000',
    'Play8X-1100'
  ],
  '@PM': ['PM36100', 'PM63100', 'PMID!!', 'PMP[0-9]{4,4}!!', 'PMT[0-9]{4,4}!!'],
  '@PN': [
    'pnx8473 kiryung',
    'PNDPP4MT9G2',
    'PNDPP44QC7',
    'PNDPP48GP',
    'PNDPP4MT9G3',
    'PNDPP410GP',
    '(PNR-)?Pioneer!!'
  ],
  '@PO': [
    '(Highscreen|Alpha|Bay|Boost|Cosmo|Explosion|Power|Prime|Zera)!!',
    'PocketBook A7',
    'PocketBook A10',
    'PocketBook A10 3G',
    'PocketBook SURFpad2',
    'PocketBook SURFpad 3 (7,85")',
    'PocketBook SURFpad 4 S',
    'PocketBook SURFpad 4 M',
    'PocketBook SURFpad 4 L',
    'POV-Mobii-7',
    'POV Mobii 7',
    'POV TAB-P506!',
    'POV TAB-P517!',
    'POV TAB-P527!',
    'POV TAB-P629!',
    'POV TAB-P701!',
    'POV TAB-P703!',
    'POV TAB-P720!',
    'POV TAB-P721A!',
    'POV TAB-P721!',
    'POV TAB-P722C!',
    'POV TAB-P731N!',
    'POV TAB-P825!',
    'POV TAB-P925!',
    'POV TAB-PR945!',
    'POV TAB-P1025!',
    'POV TAB-P1030!',
    'POV TAB-PI1045!',
    'POV TAB-P1325!',
    '(POV )?TAB-PLAYTABPRO!',
    '(POV )?TAB-PROTAB25!',
    '(POV )?TAB-PROTAB26!',
    'POV TAB-PROTAB27',
    '(POV )?TAB-PROTAB30!',
    '(POV )?TAB-PROTAB2XXL(4)!',
    '(POV )?TAB NAVI7 3G M!',
    'POV_TAB-NAVI7-3G-M',
    'POV TAB-P547(v1.0)',
    'POV TV-HDMI-200BT',
    'POV TV-HDMI-200BT(V2.0)',
    'POV TV-HDMI-210',
    'POV TV-HDMI-KB-01',
    'POV TV-SMARTTV-500',
    'Polaroid PSPT401',
    'Polaroid PSPC505',
    'Polaroid PSPC550',
    'Polaroid P4005A',
    'Polaroid P5005A',
    'Polaroid P5046A',
    'Polaroid P5525A',
    'Polaroid P5526A',
    'POLY ?PAD!!',
    'POLYTRON!!',
    'POMP!!',
    'Positivo Mini',
    'POSITIVO YPY 07FTB',
    'Positivo Ypy AB7E',
    'Positivo Ypy AB7EC',
    'Positivo Ypy AB7F',
    'Positivo AB7F',
    'Positivo Ypy AB7H',
    'Positivo Ypy AB10E',
    'Positivo Ypy AB10EC',
    'Positivo Ypy AB10H',
    'Positivo BGH Ypy L700',
    'Positivo Ypy L700',
    'Positivo Ypy L700 Ed. Especial',
    'Positivo Ypy L700+',
    'Positivo Ypy L700 Kids',
    'Positivo BGH Ypy L700 Kids',
    'Positivo Ypy L700+ Kids',
    'Positivo Ypy L1000',
    'Positivo Ypy L1000AB',
    'Positivo Ypy L1000F',
    'Positivo Ypy L1050',
    'Positivo Ypy L1050E',
    'Positivo Ypy L1050F',
    'Positivo S380',
    'Positivo S440',
    'Positivo S480',
    'Positivo S550',
    'Positivo X400',
    'Positivo X800'
  ],
  '@PP': ['PP4MT-7', 'PP4MT-9'],
  '@PR': [
    'Project Tango Tablet Development Kit',
    '(Highscreen|Alpha|Bay|Boost|Cosmo|Explosion|Power|Prime|Zera)!!',
    '(HW-|HUAWEI )?(ALE|ANE|D2|DAV|EML|EVA|FIG|G6|G7|GRA|M100|P2|P6|P7|PRA|RIO|SC|Sophia|VIE|VKY|VNS|VTR|WAS)!!',
    'Pro 10 dual core',
    'Prada 3.0',
    'PRO 5',
    'PRO 6',
    'PRO 6s',
    'PRO 6 Plus',
    'Primo76',
    'Primo 91',
    'PRIME PLUS 3G',
    'PROTAB2XXL',
    'PROV!!',
    'PRO!!',
    'Prestigio PAP5000TDUO',
    'PRBT 100',
    'printer-tablet',
    'PRS-T1',
    'Preo Teknosa P1',
    'PRIMO7',
    'PRIMO8',
    'PRO7D',
    'Primo C2',
    'Primo C3 3G',
    'Primo C3',
    'PrimoC4',
    'Primo-D1',
    'Primo D2',
    'Primo D3',
    'Primo D4',
    'Primo D5',
    'Primo D6',
    'Primo D7',
    'Primo E1',
    'Primo E2',
    'PRIMO E3',
    'Primo E4',
    'Primo E4+',
    'Primo E5',
    'Primo E6',
    'Primo E7',
    'Primo E7 Plus',
    'Primo EF',
    'Primo EF2',
    'Primo EF3',
    'Primo EF4',
    'Primo EF4+',
    'Primo EM',
    'Primo F1',
    'Primo F2',
    'Primo-F2',
    'Primo F3',
    'Primo F3i',
    'Primo F4',
    'Primo F5',
    'Primo F6',
    'Primo F7',
    'Primo-G1',
    'Primo G1',
    'Primo G2',
    'Primo-G3',
    'Primo G4',
    'Primo G5',
    'Primo G6',
    'Primo-GF',
    'Primo GF2',
    'Primo GF3',
    'Primo GF4',
    'Primo GH',
    'Primo GH+',
    'Primo-GH2',
    'Primo GH2',
    'Primo GH2 [AOSP]',
    'Primo-GH2 (AOSP KITKAT)',
    'Primo GH3',
    'Primo-GH3',
    'Primo GH4',
    'Primo GH5',
    'Primo GH5 Plus',
    'Primo GH5 mini',
    'Primo GH6',
    'Primo GH6+',
    'Primo GM',
    'Primo GM mini',
    'Primo H2',
    'Primo-H3',
    'Primo H3',
    'Primo H4',
    'Primo H5',
    'Primo H6',
    'Primo HM',
    'Primo HM2',
    'Primo HM3',
    'Primo HM3+',
    'Primo-N',
    'Primo-N1',
    'Primo N2',
    'Primo NF',
    'Primo NF+',
    'Primo NF2',
    'Primo NF2+',
    'Primo NH',
    'Primo NH Lite',
    'Primo NH2 Lite',
    'Primo NH3 Lite',
    'Primo NX',
    'Primo NX2',
    'Primo NX3',
    'Primo NX3 Plus',
    'Primo NX4 mini',
    'Primo R1',
    'Primo R2',
    'Primo R3',
    'Primo R4',
    'Primo R4 Plus',
    'Primo R4s',
    'Primo RH',
    'Primo RH2',
    'Primo RM',
    'Primo RM2',
    'Primo RM2 mini',
    'Primo RX',
    'Primo RX2',
    'PrimoRX2',
    'Primo RX3',
    'Primo RX4',
    'Primo RX5',
    'Primo S1',
    'PrimoS2',
    'Primo S3',
    'Primo S3 mini',
    'Primo S4',
    'Primo V1',
    'Primo V2',
    'Primo VX',
    'Primo VX+',
    '(WALTON )?Primo-X1!',
    'Primo-X2',
    'Primo X2mini',
    'Primo X3',
    'Primo X3mini',
    'Primo X4',
    'Primo Z',
    'Primo-ZX',
    'Primo ZX2',
    'Primo ZX2 Lite',
    'Primo ZX2 mini',
    'Primo Walpad 1',
    'Primo Walpad 7',
    'Primo Walpad 8',
    'Primo Walpad 8W',
    'Proton Lite',
    'prada',
    'Prism',
    'Prism II'
  ],
  '@PS': ['PSPT350', 'PSP[0-9]{4,4}!!', 'PS47'],
  '@PT': ['PTL21'],
  '@PU': [
    'PURE XL',
    'PURE III',
    'PULID F6',
    'PULID F7',
    'PULID F11',
    'PULID T3',
    'PULP',
    'PULP 4G',
    'Pulse',
    'Pulse Mini'
  ],
  '@PY': ['Pyramid'],
  '@Q-': ['Q-Wave!!', '(QMobile|QTab|Q-Smart|Noir)!!'],
  '@Q0': ['Q07CL01'],
  '@Q1': ['(BB )?Q10$!'],
  '@Q5': ['(BB )?Q5$!'],
  '@QI': ['Qilive!!'],
  '@QK': ['QK1505', 'QK1505 A01', 'QK1605-A01'],
  '@QM': ['QM151E', 'QM152E', 'QM163E', 'QM734-8G', 'QM735-8G', '(QMobile|QTab|Q-Smart|Noir)!!', 'QMV7A', 'QMV7B'],
  '@QO': ['QOOQ'],
  '@QS': ['(AC|BC|LC|MT|RC|QS|VM|TS|OC)[0-9]{4,4}[A-Z]!!'],
  '@QT': ['(QMobile|QTab|Q-Smart|Noir)!!', 'QTAQZ3', 'QTAQZ3KID', 'QTAIR7'],
  '@QU': [
    'Quest',
    'Quicki[ -]?([0-9]+)!',
    'QUANTUM 4',
    'QUANTUM 700m',
    'QUANTUM 1010N',
    'Quechua Phone 5',
    'QUBE[ -](B[0-9]S?\\+?)!',
    'QUBE[ -](T[0-9])!',
    'QUMO[ -]QUEST[ -]?([0-9]+i?)!',
    'QUMO Altair ([0-9]+i?)!',
    'QUMO Vega ([0-9]+i?)!',
    'QuickFone Mini',
    'QuickFone-Mini',
    'QuickFone ([NXZ][0-9]\\+?)!'
  ],
  '@QV': ['QV151E'],
  '@QW': ['QW ?TB-[0-9]{4,4}!!'],
  '@R1': ['R1 HD', 'R1001', 'R1011'],
  '@R2': ['R2001', 'R2010', 'R2017'],
  '@R3': ['R30GT'],
  '@R6': ['R6006', 'R6007'],
  '@R7': ['R7005', 'R7007', 'R7f', 'R7i', 'R7kf', 'R7sf', 'R7Plus', 'R7plusf', 'R7Plusm'],
  '@R8': [
    'R801',
    'R801T',
    'R803',
    'R805',
    'R807',
    'R809T',
    'R811',
    'R813T',
    'R815',
    'R815T',
    'R815W',
    'R817',
    'R817T',
    'R819',
    'R819T!',
    'R821',
    'R821T',
    'R823T',
    'R827',
    'R827T',
    'R829',
    'R829T',
    'R830',
    'R830S',
    'R831K',
    'R831L',
    'R831T',
    'R831S',
    'R831',
    'R833T',
    'R850',
    'R883T',
    'R8000',
    'R8001',
    'R8006',
    'R8007',
    'R8015',
    'R8106',
    'R8107',
    'R8109',
    'R8111',
    'R8113',
    'R8200',
    'R8201',
    'R8205',
    'R8206',
    'R8207',
    'R800(a|at|i|iv|x)!'
  ],
  '@RA': [
    'Rage',
    'RAPAXSE080-0508',
    'RAZR',
    'RAZR HD',
    'RAZR M',
    'RAZR MAXX',
    'ramos i7s  ',
    'Ramos i7s Series',
    'Ramosi8',
    'Ramosi8c',
    'Ramosi9',
    'Ramosi9-3G',
    'Ramos i9s',
    'Ramos i9s Series',
    'Ramos i9s pro',
    'Ramosi10',
    'Ramos i11 pro',
    'Ramosi12c',
    'Ramos i100 pro',
    'Ramos K100',
    'Ramos K300',
    'Ramos M7',
    'ramos R9',
    'Ramos W6HD',
    'Ramos W12',
    'Ramos W12HD',
    'Ramos W17Pro V3.0',
    'Ramos W21',
    'Ramos W25HD',
    'Ramos W27Pro',
    'Ramos W31',
    'Ramos w36',
    'Ramos W41',
    'Ramos W41 QuadCore',
    'Ramos X10 PRO!',
    'Rayhov!!',
    'RAINBOW',
    'RAINBOW 4G',
    'RAINBOW JAM',
    '(ZTE )?Racer!!'
  ],
  '@RB': ['RBK-490'],
  '@RC': [
    '(AC|BC|LC|MT|RC|QS|VM|TS|OC)[0-9]{4,4}[A-Z]!!',
    'RCT6703W12',
    'RCT6203W46',
    'RCT6203W46L',
    'RCT6223W87',
    'RCT6303W87DK',
    'RCT6303W87M',
    'RCT6303W87M7',
    'RCT6K03W13',
    'RCT6603W47M7',
    'RCT6603W87M7',
    'RCT6873W42',
    'RCT6773W22B',
    'RCT6773W22BM',
    'RCT6973W43',
    'RCT6513W87',
    'RCT6213W87DK',
    'RCT6673W23M',
    'RCT6673W43M',
    'RCT6S03W12'
  ],
  '@RE': [
    'redhookbay',
    '(E-Boda|Eruption|Essential|Supreme|Storm|Revo)!!',
    'Rezound',
    'Renesas!',
    'Readboy!!',
    'ReederA8R',
    'reeder A8i Quad 2',
    '(Xiaomi )?(Redmi|RedRice|HM)!!',
    '(Xiaomi )?(Redmi|HM)[ \\-]?Note!!',
    'REVVLPLUS C3701A'
  ],
  '@RH': ['(?:RIVO )?RHYTHM RX ?([0-9]+)!'],
  '@RI': [
    'Rikomagic MK802',
    'Rikomagic MK802 ?II!',
    'Rikomagic MK802III',
    'Rikomagic MK802IIIS',
    '(Gsmart|Gigabyte|Rio)!!',
    '(HW-|HUAWEI )?(ALE|ANE|D2|DAV|EML|EVA|FIG|G6|G7|GRA|M100|P2|P6|P7|PRA|RIO|SC|Sophia|VIE|VKY|VNS|VTR|WAS)!!',
    'Rise',
    '(Ritmix )?RM[DP]-?[0-9]{3,3}!!',
    'RIDGE',
    'RIDGE 4G',
    'RIDGE FAB 4G'
  ],
  '@RK': [
    'rksdk',
    'rk2808(sdk)?!',
    'rk2818(sdk)?!',
    'RK2906',
    'RK2918',
    'rk2926-q8',
    'rk2928sdk',
    'rk29sdk',
    'rk30sdk!',
    'rk30mtk',
    'rk3026',
    'rk3028a',
    'rk3028sdk',
    'rk3036',
    'rk3066',
    'rk31sdk',
    'rk31 5931',
    'rk31 8089',
    'rk31 872xu',
    'rk31au',
    'rk31rtl',
    'rk312x',
    'rk3188!',
    'rk3288!',
    'rk3990!',
    'RKM MK602',
    'RKM MK802IIIS',
    'RKM MK802IV',
    'RKM MK902',
    'RKM MK902II'
  ],
  '@RM': ['RM02', 'RM-980', 'RM-1061', '(Ritmix )?RM[DP]-?[0-9]{3,3}!!', 'RMD-[0-9]{2,3}G!!'],
  '@RN': [
    '(HW-|HUAWEI |HONOR )?(ATH|BLN|BKL|BND|CHE|CHM|COL|DUA|DUK|DLI|EDI|FRD|HN3|H30|H60|HOL|JMM|KIW|LLD|NEM|NMO|PE|PLK|RNE|SCL|KNT|CAM|STF|HDN)!!'
  ],
  '@RO': ['Rock-(AL00|CL00|L01|L03)!', 'roiX', 'RoverPad 3W T71D', 'ROAR', 'Roar A50', 'Roar V25', 'rolex'],
  '@RP': ['RP-UDM01A'],
  '@RS': ['RS988'],
  '@RT': ['RTC-700A'],
  '@RW': ['RW107'],
  '@S-': ['S-F16'],
  '@S0': ['S01'],
  '@S1': ['(GIO-)?(GiONEE[- ])?S101!', '(Lenovo )?S1[- ]37AH0!', 'S1005KTAB'],
  '@S2': ['S222', '(Lenovo )?S2[- ]38A(H0|T0)!', 'S2'],
  '@S3': ['s3c6410', 'S30', 'S308', 'S3'],
  '@S4': ['S40', 'S4503Q', 'S4505M', 'S4'],
  '@S5': ['S5PV210', 'S5-F', 'S50', 'S50c', 'S5', 'S5 Mini!', 'S51SE'],
  '@S6': ['S658t', 'S6 Edge+!'],
  '@S7': ['S710d', 'S710D', 'S720i', 'S7', 's732'],
  '@S8': ['S8600', 'S88 DISCOVERY', 'S850', 'S880'],
  '@SA': [
    'sama5d3',
    'SABRESD-MX6DQ',
    'saltbay',
    'Samsung Chromebook 3',
    'SA3CNT',
    'Salora E1',
    'Salora-E1',
    'Salora-E4',
    'Salora-E5',
    'SALORA-E6',
    'SALORA-E7',
    'SALORA E8',
    'Sansui[ -]([A-Z]{1,2}[0-9]+[A-Z]?\\+?)!',
    'Sansui Cosmic SP ([0-9]+)!',
    'SANSUI ETAB ([0-9]+) ?VP!',
    'Satellite!!',
    'sagit',
    'santoni',
    'San Remo Mini',
    'San Francisco',
    'San Francisco for',
    'San Francisco II'
  ],
  '@SB': ['SBM[0-9]0[0-9]SH!!'],
  '@SC': [
    '(HW-|HUAWEI |HONOR )?(ATH|BLN|BKL|BND|CHE|CHM|COL|DUA|DUK|DLI|EDI|FRD|HN3|H30|H60|HOL|JMM|KIW|LLD|NEM|NMO|PE|PLK|RNE|SCL|KNT|CAM|STF|HDN)!!',
    '(HW-|HUAWEI )?(ALE|ANE|D2|DAV|EML|EVA|FIG|G6|G7|GRA|M100|P2|P6|P7|PRA|RIO|SC|Sophia|VIE|VKY|VNS|VTR|WAS)!!',
    '(HW-|HUAWEI )?(CRO|LUA|CUN|SCC|SCU|CAM|LDN|LYO|MYA)!!',
    'SCH-[iI][0-9]{3,3}!!',
    'SCH-L710!',
    'SCH-M828!',
    'SCH-N719',
    'SCH-P[0-9]{3,3}!!',
    'SCH-R[0-9]{3,3}!!',
    'SCH-S[0-9]{3,3}!!',
    'SCH-V727',
    'SCH-W[0-9]{3,4}!!',
    'SC-?0[0-9][A-Z]!!',
    'SC[LTV][23][0-9]!!',
    'Scroll!!',
    'SC-!!',
    'scorpio'
  ],
  '@SD': ['sdk', 'SD4930UR'],
  '@SE': [
    'sec smdkc210',
    'sec smdkv210',
    'SENSUELLE',
    'SensationXE!',
    'SensationXL!',
    'Sensation XL with Beats Audio',
    'Sensation!',
    '(SENCOR )?ELEMENT!!',
    'SENSEIT R390',
    'SENWA S970'
  ],
  '@SF': ['SFR-G8800', 'SFR-G8800 TV', 'SFR StarTab'],
  '@SG': ['SGH-[EILNMS][0-9]{3,4}!!', 'SGH-T[0-9]{3,3}!!', 'SGH-U468!', 'SGH-W2013!', 'SGP[ST0-9][0-9]{2,2}!!'],
  '@SH': [
    'Shark Bay Client platform',
    'shamu',
    'SHIELD Console',
    'SHIELD Android TV',
    'SHIELD Andr0id TV',
    'SHIELD',
    'shieldtablet',
    'SHIELD Tablet',
    'SHIELD Tablet K1',
    'SHIELD Tablet X1',
    'SHIELD Tablet II',
    'Shine',
    'SH940C-LN',
    'SH940C-LN TV',
    'SH960C-LN',
    'Sholes',
    'SHV-E[0-9]{3,3}!!',
    'SHW-M[0-9]{3,3}!!',
    'SH01D',
    'SH-M01',
    'SH-M02',
    'SH-M02-EVA20',
    'SH-M03',
    'SH-M07',
    'SH-RM02',
    'SH-[01][0-9][A-Z]!!',
    '(SHP-)?(SHARP )?SH[0-9]{2,3}!!',
    'SH[FLTV][0-9]{2,2}!!',
    'SHARP-ADS1'
  ],
  '@SI': ['SiRF Dream', 'simvalley SP-142', 'Signature Touch', 'Signature Touch L'],
  '@SK': [
    'SK351',
    'SKT01',
    '(SKY )?IM[- ][A-Z][0-9]{3,3}!!',
    'Skyworth!!',
    'SK17(a|i|iv|i-o)!',
    'SK-Mtek GT7305',
    '(ZTE )?Skate!!'
  ],
  '@SL': [
    'Slider SL101',
    'SL930',
    '(HP|Slate)!!',
    '(HW-|HUAWEI )?(DRA|FLA|TIT|TAG|NCE|TRT|SLA)!!',
    'Slidepad!!',
    'SLIDE'
  ],
  '@SM': [
    'smdk6410',
    'SMDKC110',
    'SMDKV210',
    'SMDK4x12',
    'SMDK4412',
    'SMDK5250',
    'SMDK5410',
    'smp86xx',
    'smp8734',
    'smp8756',
    'SM-G900FG',
    'SmartWatch 3',
    'Smart!!',
    'SM-H900A',
    'SmartTab1',
    'SmartPad!!',
    '(MEO )?Smart A!!',
    'Smart Monitor 17',
    'SMARTTVBOX',
    'SMT-E5015',
    'SMT-i9100',
    'SM-A[0-9]{3,3}!!',
    'SM-C[0-9]{3,3}!!',
    'SM-E[0-9]{3,3}!!',
    'SM-F[0-9]{3,3}!!',
    'SM-G[0-9]{3,3}!!',
    'SM-I9500',
    'SM-J[0-9]{3,3}!!',
    'SM-M[0-9]{3,4}!!',
    'SM-N[0-9]{3,4}!!',
    'SM-P[0-9]{3,3}!!',
    'SM-S[0-9]{3,3}!!',
    'SM-T[0-9]{3,3}!!',
    'SM-V700',
    'SM-W[0-9]{4,4}!!',
    'Smartphone Android by SFR STARADDICT II',
    '(Smartfren|Andromax)!!',
    'Smartfren Tab 7',
    'SM919',
    'SM701',
    'SM801',
    'SmartQ!!',
    'SMART Sprint',
    'SMART Start',
    'SMART Surf2 4G',
    'SmartTab!!'
  ],
  '@SN': ['SN[0-9]!!', 'Snexian!!', '(SNM\\-)?LT[0-9]{2,2}[a-z]?!!', '(SNM\\-)?M[0-9]{2,2}[a-z]!!'],
  '@SO': [
    'SoftwinerEvb',
    'SoftwinerEvb0308',
    'SoftwinerEvd',
    'Softwinerkf026',
    'Softwinerf721',
    'Softwinerf761',
    'Softwinerf761I',
    'Softwinerf900',
    'SoftwinerEvbV13',
    'soho',
    '(HW-|HUAWEI )?(ALE|ANE|D2|DAV|EML|EVA|FIG|G6|G7|GRA|M100|P2|P6|P7|PRA|RIO|SC|Sophia|VIE|VKY|VNS|VTR|WAS)!!',
    'SONIC',
    'Sonim!!',
    'SO-0[0-9][A-Z]!!',
    'SO[LTV][0-9]{2,2}!!',
    'Sony Xperia Ray',
    'SonyEricssonMT15',
    'SonyEricssonST15',
    'Soshphone 4G',
    'soft stone'
  ],
  '@SP': [
    'Sprint!!',
    'Sparkle V',
    'SPNG9716DC',
    'SPH-D[0-9]{3,3}!!',
    'SPH-L[0-9]{3,3}!!',
    'SPH-M[0-9]{3,3}!!',
    'SPH-P[0-9]{3,3}!!',
    'SP-120',
    'SPX-5',
    'SPX-5 3G',
    'SPX-6',
    'SPX-12',
    'SpeedUp S3',
    '(CSL[- ])?(Spice[- ]?)?Mi(-| )?[0-9]{3,3}!!',
    'Spice N-300',
    'Spice N-500',
    'Spice Xlife-425 3G',
    'Spice Xlife-435Q',
    'Spice Xlife-451Q',
    'Spice-Xlife-511Pro',
    'Spice Xlife-512',
    'Spice Xlife-520HD',
    'Spice Xlife-M5+',
    'Spice Xlife-M45q',
    'Spice Xlife-M46q',
    'Spice Xlife-Proton4',
    'Spice Xplor-Proton5',
    'SPICE IV',
    'Spro2',
    'SP-A20i',
    'SpringBoard'
  ],
  '@SR': ['SRT!!'],
  '@ST': [
    'ste l8540!',
    'ste u8500',
    'ste u9540',
    'Stingray',
    'Stream',
    'Status',
    'Style',
    'STV100-[0-9]!',
    'STH100-[0-9]!',
    '(BLU|DASH|LIFE|NEO|STUDIO|VIVO)!!',
    'streak7',
    '(E-Boda|Eruption|Essential|Supreme|Storm|Revo)!!',
    'ST7001',
    'ST8000',
    'ST9001',
    '(HW-|HUAWEI |HONOR )?(ATH|BLN|BKL|BND|CHE|CHM|COL|DUA|DUK|DLI|EDI|FRD|HN3|H30|H60|HOL|JMM|KIW|LLD|NEM|NMO|PE|PLK|RNE|SCL|KNT|CAM|STF|HDN)!!',
    'ST10',
    'ST940I-UP',
    'STM[0-9]{3,3}H!!',
    'Stylo',
    'STARACTIVE',
    'STARACTIVE 2',
    'STARADDICT II',
    'STARADDICT II Plus',
    'STARADDICT III',
    'STARADDICT 4',
    'STARADDICT 5',
    'STARADDICT 6',
    'STARNAUTE II',
    'STARNAUTE 3',
    'STARNAUTE3',
    'STARNAUTE4',
    'Starshine',
    'STARSHINE II',
    'STARSHINE III',
    'STARSHINE 4',
    'STARSHINE5',
    'STARTEXT II',
    'STARTRAIL II',
    'StarTrail III',
    'STARTRAIL4',
    'STARTRAIL 4',
    'STARTRAIL5',
    'STARTRAIL 6 4G',
    'STARTRAIL6',
    'STARTRAIL7',
    'STARTRAIL 8',
    'STARTRAIL 9',
    'STARXTREM',
    'STARXTREM II',
    'STARXTREM3',
    'STARXTREM 4',
    'STARXTREM5',
    'STARXTREM 6',
    'STARTAB',
    'ST[0-9]{2,2}[a-z]?!!',
    'Star N8000',
    'Star N9500',
    'Star N9589',
    'Star Q9000',
    'STAR S5',
    'STAR S7589',
    'Starmobile!!',
    '(Starway )?Andromeda!!',
    'STX!!',
    'STOREX LinkBox',
    'StarTab 715x',
    'ST[0-9]{5,5}-[0-9]!!',
    'ST-PAD',
    'ST-PAD2',
    'STAIRWAY',
    'StarTrail TT'
  ],
  '@SU': [
    'Surfing TAB B 9.7 3G',
    'Surfing Tab C 3G',
    '(E-Boda|Eruption|Essential|Supreme|Storm|Revo)!!',
    '(Explay|X-tremer|ActiveD|Informer|Surfer)!!',
    'surnia',
    'SUGAR ([A-Z][0-9]?(?: Pro)?)!',
    'SUPRA (M[0-9]{2,3}[A-Z]{0,2})!',
    'SUBLIM',
    'SUNSET',
    'SUNSET2'
  ],
  '@SV': ['sv8860', 'SVP-DTV15'],
  '@SW': ['Swift', 'Swift Plus', 'Swift 2 Plus', 'Swift 2 X'],
  '@SX': ['SXZ-PD!!', 'SX9701W'],
  '@SY': ['Sygnus', 'SYTABEX7-2', '(Symphony|Xplorer)!!', 'Synrgic Uno M1'],
  '@SZ': ['SZJ-JS101', 'SZENIO!!'],
  '@T-': [
    'T-07B',
    'T-800',
    'T-200',
    'T-Smart!!',
    'T-01C',
    'T-01D',
    'T-02D',
    'T-Mobile G1',
    'T-Mobile G2',
    'T-Mobile G2 Touch',
    'T-Mobile HTC G2',
    'T-Mobile myTouch',
    'T-Mobile myTouch 3G',
    'T-Mobile myTouch 3G Slide',
    'T-mobile my touch 3g slide',
    'T-Mobile Espresso',
    'T-Mobile myTouch 4G',
    'T-Mobile myTouch Q',
    'T-Mobile Opal',
    'T-Mobile Vivacity',
    'T-Hub2'
  ],
  '@T0': [
    'T01',
    'T012',
    'T02',
    'T05',
    'T03',
    'T04',
    'T00C',
    'T00E',
    'T00N',
    'T00D',
    'T00S',
    'T00T',
    'T001',
    'T00I',
    'T00I-D',
    'T00F',
    'T00J',
    'T00J-D',
    'T00K',
    'T00P',
    'T00G',
    'T00Q'
  ],
  '@T1': ['T1-B', 'T1-D', 'T1-E', 'T1K Plus', 'T1 7.0', 'T11AD!'],
  '@T2': ['T20'],
  '@T3': ['T320a', 'T30', 'T3696', 'T301'],
  '@T6': ['T6'],
  '@T7': ['(OPPO-?)?T703!', 'T720 SE', 'T760 from moage.com'],
  '@T8': ['T8[0-9]{3,3}!!'],
  '@T9': ['T9108', 'T92', 'T9199h', 'T9[0-9]{3,3}!!', 'T959', 'T98 4G??(C6R2)'],
  '@TA': [
    'Tango',
    'TA272HUL',
    'Tablet P1801-T',
    'Tablet P1802-T',
    '(DENVER-)?TA[CD]-[0-9]{4,5}!!',
    'Tablet-P27',
    'TA10CA3',
    '(tablet )?fnac!!',
    '(HW-|HUAWEI )?(DRA|FLA|TIT|TAG|NCE|TRT|SLA)!!',
    '(HW-|HUAWEI )?(BLL|CHC|TAG|KII)!!',
    'TA-FONE!!',
    'TAB1011',
    'TAB-1030',
    '(Lenovo )?(Tab ?)?(2 ?)?[AS](7|8|10)!!',
    'TAB950',
    'TAB1062',
    'TAB192',
    'TA-10(07|29)!',
    'TA-10(84)!',
    'TA-10(20|28|32|38)!',
    'TA-10(24|27|44|53)!',
    'TA-10(61|75|81|88)!',
    'TA-10(00|03|21|25|33|39)!',
    'TA-10(43|50|54|68)!',
    'TA-10(41)!',
    'TA-10(62)!',
    'TA-10(04|12|52)!',
    'TA-10(99)!',
    'TA-11(03|16)!',
    '(POV )?TAB-PLAYTABPRO!',
    '(POV )?TAB-PROTAB25!',
    '(POV )?TAB-PROTAB26!',
    '(POV )?TAB-PROTAB30!',
    'TAB-PROTAB2-IPS9',
    'TAB-PROTAB2-IPS-3G',
    'TAB-PROTAB2-IPS-16',
    'TAB-PROTAB2.4',
    'TAB-PROTAB2XL',
    'TAB-PROTAB2.4XL',
    'TAB-PROTAB2XXL',
    'TAB-PROTAB2XXL(4)',
    '(POV )?TAB-PROTAB2XXL(4)!',
    '(POV )?TAB NAVI7 3G M!',
    'Tablet P',
    'Tablet S',
    'Tabra QAV801',
    'TAB 7 3G V8',
    'TAB 8 3G V8',
    'TAB9 3G',
    'TAB9 3G V8',
    'TAB 10 3G V16',
    'TAB 7i 3G',
    'TAB 10Q',
    'TAB09-410',
    'TAB10-410',
    'TAB07-485',
    'TAB07-200',
    'TAB9-200',
    'TAB10-201',
    'TAB210',
    'TAB220',
    'TAB224',
    'TAB250',
    'TAB275',
    'TAB260',
    'TAB264',
    'TAB360',
    'TAB364',
    'TAB410',
    'TAB411',
    'TAB420',
    'TAB424',
    'TAB450',
    'TAB460',
    'TAB461',
    'TAB464',
    'TAB465EUK',
    'TAB468',
    'TAB469',
    'TAB466EUK',
    'TAB467',
    'TAB462'
  ],
  '@TB': [
    'TB-X103F',
    'TB07FTA',
    'TB100',
    'TB782B',
    'TBD753B',
    'TBDB763',
    'TBDB863',
    'TBDC1093',
    'TBDG734',
    'TBDG874',
    'TBDG1073',
    'TBQC1063'
  ],
  '@TC': [
    'TCC8920 STB!',
    'TCC893X!',
    'TCC8935 HDMI!',
    'TCC8975 STB!',
    'TCC8920 EVM',
    'TCC8925 HDMI DONGLE',
    'TCC8930 STB EV',
    'TCC8930 STB1',
    'TCC8935 HDMI DONGLE',
    'TCL ONE TOUCH 990',
    'TC970',
    'TC970 (Wi-Fi)',
    'TC975',
    'TC55',
    'TC55CH',
    'TC70',
    'TC75',
    'TCL!!'
  ],
  '@TD': ['TD070VA1', 'TD600', 'TD-1010', 'TD506'],
  '@TE': [
    'Telechips M801 Evaluation Board',
    'Telechips TCC8800 eMMC Evaluation Board',
    'Telechips TCC8800 Evaluation Board',
    'Telechips TCC8900 Evaluation Board',
    'Telechips TCC8900 Evaluation Board (US)',
    'Telechips TCC8902 Tablet-PC (DE)',
    'Telechips TCC9300 Evaluation Board',
    'Tegra!!',
    'TECNO!!',
    'Teclast A10',
    'Teclast P76e!',
    'Teclast P85!',
    'Teclast X80h',
    'tegav2',
    'Tele2fon V3',
    'Tele2fon v5',
    'TELEFUNKEN Diamond TD1',
    'Telpad Dual S',
    'Telpad Quad S',
    'Telpad QS',
    'Tensent S9000',
    'teXet X-alpha',
    'Texet TM-4083',
    'teXet X-start',
    'teXet iX-mini',
    'teXet X-navi',
    'TEXET TM-4677',
    'teXet X-medium plus',
    'teXet X-maxi qHD',
    'TeamDRH ICS for GTablet',
    'Telenor!!'
  ],
  '@TF': [
    'TF101',
    'TF101-WiMAX',
    'TF201',
    'tf201t',
    '(Transformer )?(Pad )?TF300(T|TG|TL)!',
    '(Transformer )?(Pad )?TF502(T)!',
    '(Transformer )?(Pad )?TF700(T|K)!'
  ],
  '@TG': ['TG-L800S', 'TG-L900S'],
  '@TH': [
    'thor',
    'Thunder S220',
    '(Cloudfone|CloudPad|Excite|Thrill)!!',
    '(KAZAM|Thunder|Tornado|Trooper)!!',
    'ThinkPad( Tablet)?!',
    '(CJ-)?ThL!!',
    'THRiVE'
  ],
  '@TI': [
    'Tilapia',
    'Titan TV S320',
    '(HW-|HUAWEI )?(DRA|FLA|TIT|TAG|NCE|TRT|SLA)!!',
    '(Karbonn|Titanium)!!',
    'TI320-DU',
    'TI320-DU TV',
    'TizzBird!!',
    'tiffany'
  ],
  '@TL': ['TLINK[0-9]{3,3}!!'],
  '@TM': [
    'TM400',
    'TM105',
    'TM105A',
    'TM-3200R',
    'TM-3204R',
    'TM-3500',
    'TM-4003',
    'TM-4004',
    'TM-4071',
    'TM-4082R/X-driver',
    'TM-4377',
    'TM-4515',
    'TM-4577',
    'TM-4677',
    'TM-4982',
    'TM-5005',
    'TM-5200',
    'TM-5377',
    'TM-7011',
    'TM-7016',
    'TM-7021',
    'TM-7023',
    'TM-7024',
    'TM-7025',
    'TM-7026',
    'TM-7026 (revision 4)',
    'TM-7037W',
    'TM-7038W',
    'TM-7041',
    'TM-7043XD',
    'TM-7047HD 3G',
    'TM-7096',
    'TM-7099',
    'TM-7854',
    'TM-8041HD',
    'TM-8048 revision1',
    'TM-8051',
    'TM-9720',
    'TM-9725',
    'TM-9740',
    'TM-9741',
    'TM-9743W',
    'TM-9747!',
    'TM-9748 3G',
    'TM-9750HD',
    'TM-9751HD',
    'TM-9757',
    'TM-9757 3G rev1',
    'TM-9767',
    'TM-1058',
    'tmn!!'
  ],
  '@TO': [
    'Toro',
    'Toro-VZW',
    'TOUCAN Stick HD',
    'TOUCAN Stick G4',
    'Toucan Stick 4K',
    'TOUCAN Stick 3D mk2',
    'TOUCAN Stick 3D Pro',
    'TOUCHBOOK7.0 3G',
    '(HP )?Touchpad!',
    'Touch Pro 2',
    '(KAZAM|Thunder|Tornado|Trooper)!!',
    'Torque',
    'Touchlet X10.dual',
    'tolino tab!!',
    'TomTom Bridge',
    'TomTom PRO 8275',
    'TOOKY!!',
    'TOSHIBA AC AND AZ',
    'TOSHIBA FOLIO AND A',
    'Tostab03',
    'TOSHIBA WT7-C',
    'TOSHIBA WT8-A'
  ],
  '@TP': ['TPA60W', 'TPC-7151'],
  '@TQ': ['TQ150'],
  '@TR': [
    'Transformer',
    'Transformer TF101(G)?!',
    '(Eee Pad )?Transformer Prime TF201!',
    'Transformer TF201',
    'Transformer TF201G',
    'Transformer Prime',
    'Transformer Prime TF300T',
    'Transformer 300',
    'Transformer Pad',
    '(Transformer )?(Pad )?TF300(T|TG|TL)!',
    '(Transformer )?(Pad )?TF502(T)!',
    'Transformer Pad TF600T',
    '(Transformer )?(Pad )?TF700(T|K)!',
    'Transformer (Pad )?Infinity!',
    'TR720F',
    'TR10CS1',
    'TripNiCE Pyramid',
    '(HW-|HUAWEI )?(DRA|FLA|TIT|TAG|NCE|TRT|SLA)!!',
    'TR10RS1',
    '(KAZAM|Thunder|Tornado|Trooper)!!',
    'Triumph',
    'TRACER OXYGEN GS1',
    'Trevi PHABLET 4C',
    'Trevi PHABLET 5 S',
    'TREQ!!',
    'Trevi REVERSE 5.5Q',
    'Trevi PHABLET 6 S',
    'TRUE BEYOND 3G'
  ],
  '@TS': ['(AC|BC|LC|MT|RC|QS|VM|TS|OC)[0-9]{4,4}[A-Z]!!', 'TSP21', 'TSB CLOUD COMPANION;TOSHIBA AC AND AZ'],
  '@TT': ['TT101'],
  '@TU': [
    'TURBO DG2014',
    'Turbo C4 Plus',
    'Turbo-X pi',
    'Turbo-X Ice',
    'Turbo-X Tablet Spice III',
    'Turkcell!!',
    'Turk Telekom TT175'
  ],
  '@TV': ['TVE9603I', 'TVPAD Slim K3409'],
  '@TX': ['TX201LA', 'TX201LAF', 'TX85', 'TX18'],
  '@U1': ['(CUBE ?)?(K8|U1|U2|U3|U5|U6|U8|U9)[0-9]?GT!!', 'U1', 'U1203'],
  '@U2': ['(CUBE ?)?(K8|U1|U2|U3|U5|U6|U8|U9)[0-9]?GT!!', 'U20(a|i|iv)!'],
  '@U3': ['(CUBE ?)?(K8|U1|U2|U3|U5|U6|U8|U9)[0-9]?GT!!'],
  '@U5': ['(CUBE ?)?(K8|U1|U2|U3|U5|U6|U8|U9)[0-9]?GT!!'],
  '@U6': ['(CUBE ?)?(K8|U1|U2|U3|U5|U6|U8|U9)[0-9]?GT!!'],
  '@U7': ['U701', 'U701T', 'U702', 'U705', 'U705T', 'U705W', 'U707', 'U707T', 'U708', 'U7011', 'U7015'],
  '@U8': ['(CUBE ?)?(K8|U1|U2|U3|U5|U6|U8|U9)[0-9]?GT!!', 'U8[0-9]{3,3}!!', 'U8220'],
  '@U9': ['(CUBE ?)?(K8|U1|U2|U3|U5|U6|U8|U9)[0-9]?GT!!', 'U9[0-9]{3,3}!!'],
  '@UG': ['ugglite'],
  '@UL': [
    'Ultra',
    'Ultra Flare v2',
    'Ultimix!!',
    'Ultra Air',
    'Ultra Charm',
    'Ultra Energy',
    'Ultra Energy Lite',
    'Ultra Energy Plus',
    'Ultra Latitude',
    'Ultra Style',
    'Ultra Wave',
    'Ultimate10',
    'Ultimate10-Android4.0',
    'Ultimate 10',
    'Ulefone Be Touch2',
    'ultrafone!!',
    'Ultym 5',
    'Ultym 5L',
    'Ultym 5.2'
  ],
  '@UM': ['UM840', 'UMI!!'],
  '@UN': ['unknown M200-L09', 'UNO X8', 'UNO X10', 'Unusual!!'],
  '@UO': ['UOOGOU!!'],
  '@UR': ['URBANO PROGRESSO'],
  '@US': [
    'USCC ALCATEL one touch 909B',
    'USCC ALCATEL one touch 988',
    '(HTC|PCD|USCC)?ADR[0-9]{4,4}!!',
    'USCCADR[0-9]{4,4}!!',
    '(USCC-|KYOCERA-)?E[0-9]{4,4}!!',
    '(USCC-|KYOCERA-)?C[0-9]{4,4}!!',
    'USCC-(LG)?US!!',
    'Usmart!!'
  ],
  '@UT': ['UTime!!'],
  '@V ': ['(ZTE ?)?V ?[0-9]{3,3}!!'],
  '@V-': ['V-T100'],
  '@V1': [
    'V1 Viper',
    'V1 Viper E',
    'V1 Viper I',
    'V1 Viper I4G',
    'V1 Viper I4G PL',
    'V1 Viper I4G TM',
    'V1 Viper L',
    'V1 ViperS',
    'V1 Viper S4G',
    'V1 Viper S4G TM',
    'V11',
    'V17HD',
    'V105A4-A-C1',
    'V100MDT',
    '(GIO-)?(GiONEE[- ])?V182!',
    '(GIO-)?(GiONEE[- ])?V185!',
    '(GIO-)?(GiONEE[- ])?V188!',
    'V1',
    'V1277'
  ],
  '@V2': ['V2 Viper', 'V2 Viper I', 'V2 Viper I TM', 'V2 Viper I4G', 'V2 Viper S', 'V2 Viper X', 'V2 Viper X plus'],
  '@V3': ['v360 E1'],
  '@V5': ['V5U-simvalley SP-142', 'V55'],
  '@V7': ['V701s Core4', 'V711s Core4', 'V712 Core4', 'V719 3G'],
  '@V8': [
    'V801 Core4',
    'V801s Core4',
    'V811 Core4',
    'V812 Core4',
    'V813 Core4',
    'V813s Core4',
    'V818',
    'V818mini',
    'V819mini',
    'V819 3G',
    'V819i',
    'V8000 USA Cricket',
    'V8110',
    'V8403',
    'V8405',
    'V8408',
    'V8409',
    'V8412',
    'V8413',
    'V8501',
    'V8502',
    'V8503',
    'V8505',
    'V8507',
    'V8508',
    'V8510',
    'V8511',
    'V8602',
    'V8603'
  ],
  '@V9': [
    'V99',
    'V936',
    'V985',
    'V971 Core4',
    'V971s Core4',
    'V972 Core4',
    'V973 Core4',
    'V975 Core4',
    'V975i',
    'V975m',
    'V975m Core4',
    'V975s Core4',
    'V961',
    'V9',
    'V9S',
    'V9e',
    'V9e+',
    'V9A',
    'V9C'
  ],
  '@VA': ['Vandroid S5E', 'Vandroid T1J', 'Vandroid T3-A', 'Vandroid T3i', 'Vandroid T', 'VAP430'],
  '@VE': [
    'vexpress a9',
    'Ventana',
    'Vendor Optimus',
    'VEOLO',
    'VEOLO2',
    'Vega',
    'VegaBean!',
    'Venture',
    'Venue!!',
    '(OV-|Overmax|Vertis)!!',
    'VEGA NO.6',
    'Verifone Carbon-8',
    'verykool!!',
    'Vertu Aster T',
    'Vertu Signature Touch',
    'VERTU Ti',
    'Venus_V3 5040',
    'Venus V3 5570',
    'Venus V3 5580'
  ],
  '@VF': [
    'VF685',
    'VF695',
    'VF696',
    'VF-696',
    'VF-795',
    'VF-895N',
    'VF945',
    'VFD 100',
    'VFD 200',
    'VFD 300',
    'VFD 301',
    'VFD 311',
    'VFD 500',
    'VFD 501',
    'VFD 510',
    'VFD 511',
    'VFD 513',
    'VFD 600',
    'VFD 610',
    'VFD 700',
    'VFD 710',
    'VFD 900',
    'VF-1397',
    'VF-1497',
    'VFD 1100',
    'VFD 1300',
    'VFD 1400',
    'VFD1400'
  ],
  '@VI': [
    'VirtualBox!',
    'victoriabay',
    'Viva C701',
    'Viva H701',
    'Viva H701 LTE CZ',
    'VivaH7LTE',
    'VivaH8LTE',
    'VivaH10LTE',
    'Viva i7G',
    'VIVA i7',
    'Viva i10HD',
    'Viva i701G TM',
    '(BLU|DASH|LIFE|NEO|STUDIO|VIVO)!!',
    'VICTORY',
    'Victory 2',
    'Victory 3',
    'VICTORY 4',
    'Victory 5',
    'VIA F1',
    'VIA S10',
    'Vibo-A688',
    'VitMod ExtraLite 1.6.5.fullodex for HTC HD7 Pro',
    'Vivid 4G',
    '(HW-|HUAWEI )?(ALE|ANE|D2|DAV|EML|EVA|FIG|G6|G7|GRA|M100|P2|P6|P7|PRA|RIO|SC|Sophia|VIE|VKY|VNS|VTR|WAS)!!',
    'Vibe K5 Plus',
    'VIBE X2 (X2)',
    'VIBE X3',
    'VIBE Z2 Pro (K920)',
    'Vibrantmtd',
    'Vibrant T959',
    'victorys s8',
    'Victorys V8',
    'Videocon!!',
    'ViewSonic-V350',
    'ViewSonic V500',
    'ViewPhone3',
    'ViewPad 4',
    'ViewSonic-ViewPad4',
    'ViewPad7',
    'ViewPad 7D',
    'ViewPad 7D Pro',
    'ViewSonic-ViewPad7e',
    'ViewPad7e',
    'ViewPad 7Q',
    'ViewPad 7Q Plus',
    'ViewPad 7Q Pro',
    'ViewPad7X',
    'ViewPad 8E',
    'ViewPad 9Q',
    'ViewPad 10e',
    'ViewPad 10S',
    'ViewPad 70Q',
    'ViewPad97A',
    'ViewPad97a K1',
    'ViewPad97a Pro',
    'ViewPad 97Q',
    'ViewPad 100Q',
    'ViewPad 100N Pro',
    'ViewPad 701N',
    'ViewPad i7D',
    'ViewPad E100',
    'ViewSonic VB733',
    'VINUS!!',
    '(BBG-|VIV-)?vivo!!',
    'Viettel i5',
    'Viettel I8',
    'VIETTEL V8404!',
    'Viettel V8410',
    'VIETTEL V8411',
    'Viettel V8502',
    'VIETTEL V8506',
    'VIETTEL V8509'
  ],
  '@VK': [
    '(HW-|HUAWEI )?(ALE|ANE|D2|DAV|EML|EVA|FIG|G6|G7|GRA|M100|P2|P6|P7|PRA|RIO|SC|Sophia|VIE|VKY|VNS|VTR|WAS)!!',
    'VK410',
    'VK700',
    'VK810 4G',
    'VK815'
  ],
  '@VL': ['VL-[0-9]{3,3}!!'],
  '@VM': ['VMware Virtual Platform', '(AC|BC|LC|MT|RC|QS|VM|TS|OC)[0-9]{4,4}[A-Z]!!', 'VM670'],
  '@VN': [
    '(HW-|HUAWEI )?(ALE|ANE|D2|DAV|EML|EVA|FIG|G6|G7|GRA|M100|P2|P6|P7|PRA|RIO|SC|Sophia|VIE|VKY|VNS|VTR|WAS)!!'
  ],
  '@VO': [
    'Vogue',
    'Volantis',
    'Volantisg',
    'VOYAGER DG300',
    'VOYAGER2 DG310',
    'Vox',
    'Vortex',
    'vollo Vi86',
    'VOTO GT2++',
    'VOTO GT7',
    'VOTO GT11',
    'VOTO GT11 Pro',
    'VOTO GT18',
    'VOTO V5',
    'VOTO VT868',
    'VOTO VT888',
    'VOTO VT898',
    'VOTO VT898S',
    'VOTO W5300',
    'VOTO X2',
    'VOYO A15',
    'voyo X6',
    'Vodafone!!'
  ],
  '@VS': [
    'VS[0-9]{3,3}!!',
    'VS TOUCH!!',
    'VSP250g',
    'VSP250s',
    'VSD220',
    'VSD221',
    'VSD224',
    'VSD231',
    'VSD241',
    'Vsun HEXA',
    'VSUN ILLUSION',
    'VSUN RACE',
    'Vsun SPARK',
    'VSUN TOUCH',
    'Vsun D3B',
    'Vsun H3',
    'Vsun H9',
    'Vsun i1',
    'Vsun i5',
    'Vsun i9',
    'Vsun V9'
  ],
  '@VT': [
    '(HW-|HUAWEI )?(ALE|ANE|D2|DAV|EML|EVA|FIG|G6|G7|GRA|M100|P2|P6|P7|PRA|RIO|SC|Sophia|VIE|VKY|VNS|VTR|WAS)!!',
    'VT6078',
    'VT75C',
    'VT77C',
    'VT79C',
    'VT87C+',
    'VTAB1008',
    'VTAB3010'
  ],
  '@VW': ['VW RCBKK1'],
  '@VX': ['VX-100', 'VX580A', 'VX580W', 'VX610A'],
  '@W1': ['W10', 'W10 V2.0', 'w13pro', 'W13PRO V2.0', 'W17PRO(Dualcore)', 'W17PRO JB Dualcore', 'W100'],
  '@W2': ['W200', 'W22PRO', 'W22PRO 3G', 'W27(Dualcore)', 'W28(Dualcore)', 'W20'],
  '@W3': ['W337', 'W3620', 'W30(QuadCore)', 'w30hd(QuadCore)', 'W30HDPRO'],
  '@W4': ['w42(QuadCore)'],
  '@W5': ['W5510'],
  '@W6': ['W606', 'W619', 'W686', 'W626', 'W6350', 'W6360', 'W6500', 'W6620', 'W6', 'W6HD ICS', 'W6HD ICS FULL'],
  '@W7': ['W711', 'W757', 'W700', 'W732'],
  '@W8': ['W820', '(GIO-)?(GiONEE[- ])?W800!', 'W800', 'W806', 'W808', 'W810', 'W880', 'W8', 'W8 beyond'],
  '@W9': ['W900', 'W990'],
  '@WA': [
    '(HW-|HUAWEI )?(ALE|ANE|D2|DAV|EML|EVA|FIG|G6|G7|GRA|M100|P2|P6|P7|PRA|RIO|SC|Sophia|VIE|VKY|VNS|VTR|WAS)!!',
    'WA-U420D',
    'WALSUN S1 Pro',
    'WALSUN S2',
    'Walton Primo',
    'WALTON Primo C1',
    'WALTON Primo-D1',
    'WALTON Primo E8+',
    'Walton F2',
    'Walton Primo F2',
    'WALTON Primo-G1',
    'WALTON Primo G1',
    'Walton-GH2',
    'Walton Primo H1',
    'Walton Primo H3',
    'WALTON H3',
    'WALTON Primo HMmini',
    'WALTON Primo-N1',
    'Walton Primo R1',
    'Walton RM2',
    'WALTON Primo S3',
    'Walton Primo VX+',
    '(WALTON )?Primo-X1!',
    'Walpad 8b',
    'Walpad 8x',
    'Walpad 10b',
    'Walpad 10x',
    'Walpad C',
    'Walpad G',
    'Walpad G2',
    'Walpad G2i',
    'Walpad M',
    'WAX'
  ],
  '@WE': [
    'WellcoM-A86',
    'WellcoM-A88',
    'WellcoM-A89',
    'WellcoM-A89-Plus',
    'WellcoM-A99',
    'WellcoM-A800',
    'WEXLER. ZEN 5',
    'WEXLER TAB7ID',
    'WEXLER-TAB-7iS',
    'WEXLER-TAB-7T',
    'WEXLER.BOOK T7008'
  ],
  '@WF': ['WF7C'],
  '@WH': [
    'WHAM D5',
    'WHAM Q4',
    'WHAM-WD38',
    'WHAM WG40',
    'WHAM WG50',
    'WHAM WK41',
    'Wham WK44',
    'WHAM WS35',
    'WHAM WS36',
    'WHAM WS43',
    'WHAMWHAM WS43 Maui',
    'WHAM WT72'
  ],
  '@WI': [
    'Wingray',
    'Wildfire S!',
    'Wildfire!',
    'Wiko Cink Five',
    'Wiko Cink Peax',
    'WIKO-CINK PEAX',
    'Wiko Cink Slim',
    'WIKO-CINK SLIM',
    'Wiko Rainbow',
    'Wiko Stairway',
    'Wileyfox Spark',
    'Wileyfox Spark +',
    'Wileyfox Spark X',
    'Wileyfox Storm',
    'Wileyfox Swift',
    'Wink City S'
  ],
  '@WL': ['WL-101GQC'],
  '@WM': ['WM8650', 'WM8650-mid', 'wm8710-tvbox', 'WM8850-mid'],
  '@WO': ['Woxter!!'],
  '@WS': ['WS171'],
  '@WT': ['WT[0-9]{2,2}[a-z]!!'],
  '@WX': ['WX04K', 'WX06K', 'WX10K', 'WX[0-9]{3,3}!!', 'WX04SH', 'WX05SH', 'Wxt Tab PC 65CXi'],
  '@X-': [
    '(Explay|X-tremer|ActiveD|Informer|Surfer)!!',
    'X-treme PQ11',
    'X-treme PQ15',
    'X-tremePQ22',
    'X-treme-PQ30',
    'X-basic',
    'X-basic2',
    'X-maxi',
    'X-medium'
  ],
  '@X0': [
    'X007D',
    'X008D',
    'X008DA',
    'X008DB',
    'X008DC',
    'X009D',
    'X009DA',
    'X009DB',
    'X009DD',
    'X00AD',
    'X00ADA',
    'X00ADC',
    'X00BD',
    'X00DD',
    'X00DDA',
    'X00DDB',
    'X00HD',
    'X00GD',
    'X013D',
    'X013DA',
    'X013DB',
    'X013DC',
    'X015D',
    'X014D',
    'X002',
    'X003',
    'X005',
    'X008'
  ],
  '@X1': [
    'X1 Soul',
    'X1 Soul Mini',
    'X1 mini Soul',
    'X1 Soul Xtreme',
    'X1 Xtreme Mini',
    'X1',
    'X1 7.0',
    'X1 atom',
    'X1 atom L',
    'X1 Atom s',
    'X1 Beats',
    'X1 Grand',
    'X1 mini',
    'X1 Selfie',
    'X1010',
    'X10(a|i|iv|i-o|s)?$!',
    'X10 ?(Mini ?Pro)$!',
    'X10 ?(Mini)$!',
    'X10H(G3C5)',
    'X10HD 3G(M6K6)',
    'X16 Plus(D3A5)',
    'X16 Power(D6F7)',
    'X16 PRO(D6F8)',
    'X16HD (K3J3)',
    'X16HD 3G(M5J4)',
    'X16HD 3G(M5J5)',
    'X16HD 3G(M5J5',
    'X16HD 3G(M5J6)'
  ],
  '@X2': [
    'X2 Soul',
    'X2 Soul Lite',
    'X2 Soul Lite TM',
    'X2 Soul Mini',
    'X2 Soul Mini TM',
    'X2 Soul PRO',
    'X2 Soul Style',
    'X2 Soul Style TM',
    'X2 Soul Style Plus',
    'X2 Soul Xtreme',
    'X2 Twin'
  ],
  '@X3': [
    'X3 Soul',
    'X3 Soul Lite',
    'X3 Soul Lite TM',
    'X3 Soul mini',
    'X3 Soul PLUS',
    'X3 Soul PRO',
    'X3 Soul Style',
    'X325a',
    'X3-Ice MIUI XT720 Memorila Classics'
  ],
  '@X4': ['X403'],
  '@X5': ['X550', 'X515d', 'X515e', 'X525a', 'X527', 'X505', 'X506', 'X506S', 'X507Q'],
  '@X7': [
    'X710d',
    'X720D',
    'X710E',
    'X7G',
    'X720',
    'X70(C6F9)',
    'X70 3G (C5D9)',
    'X70 R(C7F9)',
    'X70 R(C8F9)',
    'X708S'
  ],
  '@X8': [
    '(GIO-)?(GiONEE[- ])?X817!',
    'X800+',
    'X8',
    'X80(C4M5)',
    'X80h',
    'X80h(FB5M)',
    'X80h(FB6M)',
    'X80HD',
    'X80HD(G2N3)',
    'X80HD(G2N4)',
    'X80HD(G2N5)',
    'X80HD(G2N6)',
    'X80HD(G2N8)',
    'X80HD(G2N9)',
    'X80HD(G2N9',
    'X80 Plus(H5C5)',
    'X80 Plus(H6C3)',
    'X80 Plus(H6C3',
    'X80 Plus(H6C4)',
    'X80 Power(B2N3)',
    'X80 Power(B2N4)',
    'X80 Power(B2N6)',
    'X80 Pro(E2E9)',
    'X80 Pro(E3E6)',
    'X80 Pro(E3E7)',
    'X80 Pro(E3E8)',
    'X80 Pro (E3E9)',
    'X81-8G3D',
    'X89 (E7ED)',
    'X89 (KR89)',
    'X89HD (H21C)'
  ],
  '@X9': [
    'X920e',
    'X9',
    'X903',
    'X903S',
    'X905',
    'X906',
    'X907',
    'X909',
    'X909T',
    'X9000',
    'X9006',
    'X9007',
    'X9009',
    'X9015',
    'X9017',
    'X9070',
    'X9076',
    'X9077',
    'X9079',
    'X90HD (M2PC)',
    'X98 3G(HKC1)',
    'X98 3G(HKC2)',
    'X98 3G(HKC3',
    'X98 3G(HKC3)',
    'X98 3G(lite)',
    'X98 Air(C5KN)',
    'X98 Air Smile',
    'X98 Air 3G',
    'X98 Air 3G(Smile)',
    'X98 Air 3G(C5J5)',
    'X98 Air 3G(C5J6)',
    'X98 Air 3G(C5J8)',
    'X98 Air 3G(C6J6)',
    'X98 Air 3G(C6J6',
    'X98 Air 3G(C8J6)',
    'X98 Air 3G(C8J7)',
    'X98 Air 3G(C9J6)',
    'X98 Air 3G(C9J7)',
    'X98 Air 3G(C9J8)',
    'X98 Air II',
    'X98 Air II(HG5N)',
    'X98 Air II(HG6M)',
    'X98 Air II(HG7N)',
    'X98 Air II(HG8N)',
    'X98 Air II(HG9M)',
    'X98 Air II(HG9N)',
    'X98 Air II(HG9N',
    'X98 Air ? HG9M',
    'X98 Air Ⅱ HG9M',
    'X98 Air II(Smile)',
    'X98 Air III',
    'X98 Air III(M5C5)',
    'X98 Air III(M5C5',
    'X98 Air III(M5C6)',
    'X98 Plus',
    'X98 Plus(A6C7)',
    'X98 Plus(A5C8)',
    'X98 Plus 3G(A6C9)',
    'X98 Plus II (C2D4)',
    'X98 Plus II (C2D6)',
    'X98 Plus II (C2D8)',
    'X98 Plus II (C2E3)',
    'X98 Pro',
    'X98 Pro (K9C6)',
    'X98 Pro (K9C6',
    'X9180'
  ],
  '@XA': ['Xamarin Android Player!'],
  '@XC': ['XCD 28', 'XCD35'],
  '@XD': ['(NMP|MBR|XDK|XDS|XMP)\\-!!', 'XDP-100R'],
  '@XE': [
    'XELIO',
    'XELIO7PHONETAB',
    'Xelio 7 pro',
    'XELIO7PRO',
    'XELIO10 QUAD',
    'XELIO10 PLUS 3G',
    'XELIO10EXTREME',
    'Xelio 10 Pro',
    'Xelio10Pro',
    'XELIOPT2',
    'XelioPT2Pro',
    'Xelio PT4 Pro',
    'XELIO P900A',
    'Xenta-TAB07-210',
    'Xenta-TAB07-211',
    'Xenta TAB07-200',
    'Xenta TAB08-200',
    'Xenta TAB08-201-3G',
    'Xenta TAB9-200',
    'Xenta TAB09-211',
    'Xenta TAB10-211',
    'Xenta TAB10-201',
    'Xenta TAB13-201'
  ],
  '@XI': [
    'Xiaomi',
    '(Xiaomi )?(Xiaomi|Xiaomi M|MI)!!',
    '(Xiaomi|Xiaomi Mi|MI) Note!!',
    '(Xiaomi )?(MI )?MAX$!',
    '(Xiaomi )?(MI )?MAX 2$!',
    '(Xiaomi )?(MI )?MIX$!',
    '(Xiaomi )?(MI )?MIX 2$!',
    '(Xiaomi )?(MI )?MIX 2S$!',
    '(Xiaomi )?20!!',
    '(Xiaomi )?(Redmi|RedRice|HM)!!',
    '(Xiaomi )?(Redmi|HM)[ \\-]?Note!!',
    '(Xiaomi |HM)?20!!',
    'Xiaomi MDT2!',
    'Xiaomi MCT1!',
    'Xiaomi MAT136!',
    'Xiaomi MBT6A5!',
    '(Xiaomi|Xiaomi Mi|MI) Pad!!',
    '(Xiaomi|Xiaomi Mi|MI)Box!!',
    '(Xiaomi|Xiaomi Mi|MI)TV!!'
  ],
  '@XL': [
    'XL39h',
    'Xlife-348E+',
    'Xlife-350',
    'Xlife-364 3G+',
    'Xlife-405',
    'Xlife-410 3G',
    'Xlife-415',
    'Xlife-431Q',
    'Xlife-431Q Lite',
    'Xlife-480q',
    'Xlife-481q',
    'Xlife-482q',
    'Xlife-514Q',
    'Xlife-515Q',
    'Xlife-M5q+',
    'Xlife-M44Q',
    'Xlife-Electro55HD',
    'Xlife-Ezy',
    'Xlife-Victor4'
  ],
  '@XM': ['(NMP|MBR|XDK|XDS|XMP)\\-!!', 'XM50h', 'XM50t'],
  '@XO': [
    'XOOM',
    'XOOM 2!',
    'XOOM MZ606',
    'Xoom Wifi',
    'Xoom LTE',
    'Xoom 3G',
    'XO Learning tablet',
    '(XOLO )?[ABQX][0-9]{3,4}!!',
    'XOLO One',
    'XOLO One16',
    'XOLO One HD',
    'XOLO One LFC',
    'XOLO Play',
    'XOLO PLAY T1000',
    'XOLO T1000',
    'Xolo QC800'
  ],
  '@XP': ['Xperia Z Ultra', 'XPRESS PRO', 'Xperia!!', '(Symphony|Xplorer)!!', 'xPAD-70'],
  '@XT': [
    'Xtreme X2',
    'XT751',
    'XT[0-9]{3,3}!!',
    'xt880b',
    '(Hisense )?(LED[0-9]{2,2}(G|K|L|EC|XT)[0-9]{2,3})!',
    'Xteam Smartpad 810c',
    'Xteam 4.8 Smartpad 810c',
    'XT[0-9]{3,4}!!',
    'Xtab1081HD',
    'Xtreme V10',
    'Xtreme V10i',
    'Xtreme V12',
    'Xtreme V15',
    'Xtreme V20',
    'Xtreme V21',
    'Xtreme V22',
    'Xtreme V25',
    'Xtreme-V30',
    'Xtreme V40i',
    'Xtreme V44',
    'xTAB-7X',
    'xTAB-9',
    'xTAB-70!',
    'xTAB-100!',
    'Xtouch X405',
    'Xtreamer Mobile AiKi',
    'Xtreamer Mobile AiKi a7*',
    'Xtreamer Mobile Aiki5s',
    'Xtreamer Joyz',
    'Xtreamer Wonder'
  ],
  '@XW': ['XW-I8'],
  '@Y2': ['Y2'],
  '@Y5': ['Y538'],
  '@Y6': ['Y6 Max', 'Y6 Piano'],
  '@YD': ['YD201', 'YD202', 'YD203', 'YD206'],
  '@YE': ['Yellowstone', '(Andy|Yezz)!!'],
  '@YO': ['youwave custom', 'YOGA Tablet!!'],
  '@YP': [
    'YPY-72SIM',
    'YPY-73G',
    'Ypy 7 - TB07FTA',
    'YPY 07FTA',
    'YPY 07FTAB',
    'YPY 07FTAB PA',
    'YPY 07FTB',
    'YPY 07FTBF',
    'Ypy 7 - TB07STA',
    'YPY 07STB',
    'YPY 07STBF',
    'YPY 10FTA',
    'YPY10FTA',
    'YPY 10FTB',
    'YPY 10FTBF',
    'YPY 10STB',
    'YPY 10STBF',
    'YPY AB7D',
    'YPY AB7DC',
    'YPY AB10D',
    'YPY AB10DC',
    'YPY ABXD',
    'YPY J213',
    'YPY S350',
    'YPY S350 PLUS',
    'YPY S400',
    'YPY S405',
    'YPY S450',
    'YPY S460',
    'YPY S500',
    'YPY TQ7',
    'YP-G!!',
    'YP712'
  ],
  '@YQ': ['YQ601'],
  '@YU': [
    'yukkabeach',
    'YU4711',
    'YU5010',
    'YU5010A',
    'YU5011',
    'YU5040',
    'YU5050',
    'YUREKA',
    'YU5200',
    'YUreka+',
    'YU5510',
    'YU5510A',
    'YU5530',
    'YU5551',
    'YU 6000',
    'YUSUN A7',
    'YUSUN A8',
    'YUSUN E98',
    'YUSUN L29',
    'YUSUN L63',
    'YUSUN L71',
    'YUSUN L88',
    'YUSUN LA2-T',
    'YUSUN LA2 T',
    'YUSUN LA2-T1',
    'YUSUN LA2 T1',
    'YUSUN LA2-W',
    'YUSUN LA2 W1',
    'YUSUN LA5-W',
    'YUSUN T22',
    'YUSUN-T22',
    'YUSUN T29',
    'YUSUN T30',
    'YUSUN T31',
    'YUSUN T35!',
    'YUSUN T50',
    'YUSUN T85',
    'YUSUN T808',
    'YUSUN W35',
    'YUSUN W90',
    'YUSUN W91',
    'YUSUN W306',
    'yusun W702',
    'YUSUN W706',
    'YUSUN W708',
    'YUSUN - W 800',
    'YUSUN--W 800',
    'YUSUN W808',
    'YUSUN -- W 900'
  ],
  '@YX': ['YX-YUSUN E80', 'YX-YUSUN E89', 'YX-YUSUN E96'],
  '@Z0': [
    'Z002',
    'Z007',
    'Z008',
    'Z008D',
    'Z00A',
    'Z00AD',
    'Z00ADA',
    'Z00ADB',
    'Z00AS',
    'Z00D',
    'Z00ED',
    'Z00EDB',
    'Z00LD',
    'Z00LDC',
    'Z00LDD',
    'Z00MD',
    'Z00RD',
    'Z00TD',
    'Z00TDA',
    'Z00WD',
    'Z011D',
    'Z011DD',
    'Z00UD',
    'Z00UDA',
    'Z00UDB',
    'Z00UDC',
    'Z00UDH',
    'Z00SD',
    'Z00VD',
    'Z00XS',
    'Z00XSA',
    'Z00XSB',
    'Z010D',
    'Z010DA',
    'Z010DB',
    'Z010DD',
    'Z012D',
    'Z012DA',
    'Z012DB',
    'Z012DC',
    'Z012DE',
    'Z012S',
    'Z016D',
    'Z016S',
    'Z017D',
    'Z017DA',
    'Z017DB',
    'Z017DC',
    'Z01BD',
    'Z01BDA',
    'Z01BDB',
    'Z01BDC',
    'Z01BS',
    'Z01FD',
    'Z01GD',
    'Z01HD',
    'Z01HDA',
    'Z01KD',
    'Z01KDA',
    'Z01MDA',
    'Z00YD'
  ],
  '@Z1': ['(BB )?Z10$!', 'Z1-H39LW', '(HUAWEI )?(ALP|BLA|CRR|LON|MATE|MHA|MT1|MT2|MT7|M200|NXT|Z100)!!', 'Z1i'],
  '@Z2': ['Z2 Plus', 'Z2 Rio', 'Z282 C91'],
  '@Z3': ['(BB )?Z30$!', 'Z30Aire', 'Z30Dart', 'Z30Lite', 'Z30PACE'],
  '@Z4': [
    'Z4',
    'Z40Lite+',
    'Z40Pro',
    'Z4OPro',
    'Z40ProLite',
    'Z4OProLite',
    'Z40QStar',
    'Z41 AIRE',
    'Z41Aire',
    'Z41Lite+',
    'Z42 Nova',
    'Z45 Amaze',
    'Z45 Dazzle',
    'Z45 Nova',
    'Z45 Nova+',
    'Z45 Quad',
    'Z45Q Star',
    'Z45Q Star+',
    'Z4 mini'
  ],
  '@Z5': [
    'Z520e',
    'Z520m',
    'Z50 Nova',
    'Z50Pro',
    'Z50 Quad',
    'Z50Q Lite',
    'Z50Q Star',
    'Z51 blaze',
    'Z51 Nova',
    'Z51 Nova+',
    'Z51 PUNCH',
    'Z51 Quad',
    'Z51Q Star',
    'Z52 Inspire',
    'Z52 Thunder',
    'Z52 Thunder+'
  ],
  '@Z7': ['Z71', 'Z710', 'Z710e', 'Z715e'],
  '@ZA': [
    'Zaffire 785',
    'Zaffire 970',
    'ZA400',
    'ZA402',
    'ZA450',
    'ZA451',
    'ZA459',
    'ZA500',
    'ZA501',
    'ZA509',
    'ZA705',
    'ZA935',
    'ZA940',
    'ZA945',
    'ZA950',
    'ZA955',
    'ZA990',
    'ZA966',
    'ZA977',
    'ZA985',
    'ZA987'
  ],
  '@ZB': ['ZB551KL', 'ZB500KG', 'ZB500KL', 'ZB501KL', 'ZBOX-ID18', 'ZBOX-ID81'],
  '@ZC': ['ZC551KL', 'ZC553KL', 'ZC554KL'],
  '@ZE': [
    'ZenWatch',
    'ZenWatch 2',
    'Zenith',
    'Zenfone 5 LTE',
    'ZenFone 2',
    'ZenFone 2E',
    'ZE520KL',
    'ZE550KL',
    'ZE552KL',
    'ZE553KL',
    'ZE554KL',
    'ZEN Touch 2',
    '(Highscreen|Alpha|Bay|Boost|Cosmo|Explosion|Power|Prime|Zera)!!',
    'ZEN 4.5',
    'ZEN 4.7',
    'ZEN 5+',
    'ZENITHINK C94!',
    'Zen PO neo',
    'ZEN U1',
    'ZEN U4',
    'ZEN U5',
    'ZEN 303 3G'
  ],
  '@ZI': [
    'Zii!!',
    'Zio P2',
    'Zio',
    'ZiiLABS ViewBook 730',
    'ZIGO EON5I',
    'Zigo Eon6i',
    'Zigo Eon7i',
    'Zigo Eon52i',
    'Zigo Eon 53',
    'Zigo Nebula6 9',
    'Zigo Nebula Tab 7.1',
    'Zigo N81',
    'Ziss Ranger HD',
    'Zilo'
  ],
  '@ZO': ['Zoom', '(Zopo )?ZP ?[0-9]{3,3}!!'],
  '@ZP': ['(Zopo )?ZP ?[0-9]{3,3}!!'],
  '@ZT': [
    'zt180',
    'ZTE A[0-9]{3,3}!!',
    'ZTE B[0-9]{3,3}!!',
    'ZTE BA[0-9]{3,3}!!',
    'ZTE BV0[0-9]{3,3}!!',
    'ZTE C[0-9]{3,3}!!',
    'ZTE C N[0-9]{3,3}!!',
    'ZTE C R[0-9]{3,3}!!',
    'ZTE C X[0-9]{3,3}!!',
    'ZTE ?G[0-9]{3,3}!!',
    '(ZTE ?)?N[0-9]{3,3}!!',
    '(ZXY-)?(ZTE )?N[0-9]{4,4}!!',
    'ZTE K813',
    'ZTE M[0-9]{3,3}!!',
    'ZTE P[0-9]{3,3}!!',
    'ZTE ?Q[0-9]{3,3}!!',
    'ZTE Q[0-9]!!',
    'ZTE R[0-9]{3,3}!!',
    'ZTE S[0-9]{3,3}!!',
    'ZTE T[0-9]!!',
    'ZTE T ?U[0-9]{3,3}!!',
    '(ZTE ?)?U[0-9]{3,3}!!',
    'ZTE U N[0-9]{3,3}!!',
    'ZTE U[ \\(\\-]V[\\)\\-]?[0-9]{3,3}!!',
    'ZTE U X[0-9]{3,3}!!',
    '(ZTE ?)?V[0-9]{3,3}[A-Z]!!',
    '(ZTE ?)?V ?[0-9]{3,3}!!',
    '(ZTE ?)?X[0-9]{3,3}!!',
    '(ZTE )?Z[0-9]!!',
    '(ZTE )?Blade!!',
    'ZTE Geek!!',
    '(ZTE )?(Grand|Mimosa)!!',
    '(ZTE )?Kis!!',
    '(ZTE )?Racer!!',
    '(ZTE )?Skate!!',
    'ZTE Libra',
    'ZTE LINK',
    'ZTE T T9',
    'ZTE V7073',
    'ZTE V9',
    'ZTE V9A',
    'ZTE C V9E',
    'ZTE V7273',
    'ZTE e-Learning PAD E8Q',
    'ZTE E10T',
    'ZTE E10Q',
    'ZTE R22',
    'ZTE R83',
    'ZTE R84',
    'ZTE V10',
    'ZTE V70',
    'ZTE V72',
    'ZTE V72A',
    'ZTE K88',
    'ZTE K97',
    'ZTE T T98',
    'ZTE TT98',
    'ZTE Crescent',
    'ZTE JOE',
    'ZTE 975',
    'ZTE Tureis',
    'ZTE CLARO Q1',
    'ZTE LEO M1',
    'ZTE LeoM1',
    'ZTE LEO S1',
    'ZTE LEO S2',
    'ZTE LEO Q1',
    'ZTE LEO Q2',
    'ZTE GV821',
    'ZTE-860U',
    'ZTE Roamer',
    'ZTE V9800',
    'ZTE U9810',
    'ZTE U9815',
    'ZTE V9815',
    'ZTE Grand Memo LTE',
    'ZTE V9820',
    'ZTE Nubia Z7',
    'ZTE Nubia X6',
    'ZTE Switch X1',
    'ZTE Switch X2',
    'ZTE Maxx',
    'ZTE Fit 4G Smart',
    'ZTE N5',
    'ZTE N5L',
    'ZTE N5S',
    'ZTE U5',
    'ZTE U5S',
    'ZTEU5S',
    'ZTE V5S',
    'ZTEV5S',
    'ZTE A2015',
    'ZTE A2016',
    'ZTE Axon 7',
    'ZTE A2017',
    'ZTE A2017G',
    'ZTE A2017U',
    'ZTE B2015',
    'ZTE B2016',
    'ZTE B2017',
    'ZTE B2017G',
    'ZTE B2019G',
    'ZTE C2016',
    'ZTE C2017',
    'ZTE STAR',
    'ZTE Star 1',
    'ZTE S2004',
    'ZTE S2005',
    'ZTE S2007',
    'ZTE S2010',
    'ZTE S2014',
    'ZTE U9180',
    'ZTE U9370',
    'ZTE V6500',
    'ZTE V8110',
    'ZTE B860A',
    'ZTE B860AV1',
    'ZTE W1010'
  ],
  '@ZU': [
    'ZUK Z1',
    'ZUK Z2',
    'ZUK Z2131',
    'ZUK Z2151',
    'ZUK Z2 Plus',
    'ZUK Z2132',
    'ZUK Z2 Pro',
    'ZUK Z2121',
    'ZUK Z2122',
    'ZUK Edge'
  ],
  '@ZV': ['ZVII'],
  '@ZX': ['(ZXY-)?(ZTE )?N[0-9]{4,4}!!', '(ZXY-)?NX[0-9]{2,3}!!', 'ZXY-ZTE-C X920', 'ZXY-ZTE V6700']
};

/* This file is automatically generated, do not edit manually! */
